/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteRouteImport } from './routes/login/route'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppEmConstrucaoRouteImport } from './routes/_app/em-construcao'
import { Route as AppLegadoIndisponivelRouteImport } from './routes/_app/legado-indisponivel'
import { Route as AppMeuPerfilRouteRouteImport } from './routes/_app/meu-perfil/route'
import { Route as DevBlocksRouteImport } from './routes/dev/blocks'
import { Route as DevCessionariosRouteImport } from './routes/dev/cessionarios'
import { Route as DevCreditoRouteRouteImport } from './routes/dev/credito/route'
import { Route as DevFormsRouteImport } from './routes/dev/forms'
import { Route as DevPatternsRouteImport } from './routes/dev/patterns'
import { Route as DevProdutosCobrancaRouteImport } from './routes/dev/produtos-cobranca'
import { Route as DevRecordRouteImport } from './routes/dev/record'
import { Route as DevReguaCobrancaRouteImport } from './routes/dev/regua-cobranca'
import { Route as DevShellRouteImport } from './routes/dev/shell'
import { Route as DevUiRouteImport } from './routes/dev/ui'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as LoginAlterarSenhaRouteImport } from './routes/login/alterar-senha'
import { Route as LoginConfirmarEmailRouteImport } from './routes/login/confirmar-email'
import { Route as LoginConfirmarSenhaRouteImport } from './routes/login/confirmar-senha'
import { Route as LoginLogoutRouteImport } from './routes/login/logout'
import { Route as LoginRecuperarSenhaRouteImport } from './routes/login/recuperar-senha'
import { Route as AppAprovacoesIndexRouteImport } from './routes/_app/aprovacoes/index'
import { Route as AppCcbContratarRouteRouteImport } from './routes/_app/ccb/contratar/route'
import { Route as AppChatbotIndexRouteImport } from './routes/_app/chatbot/index'
import { Route as AppConcilicaoIndexRouteImport } from './routes/_app/concilicao/index'
import { Route as AppDashboardIndexRouteImport } from './routes/_app/dashboard/index'
import { Route as AppGestaoCarteiraIndexRouteImport } from './routes/_app/gestao-carteira/index'
import { Route as AppMeuPerfilIndexRouteImport } from './routes/_app/meu-perfil/index'
import { Route as AppPessoasFisicasIndexRouteImport } from './routes/_app/pessoas-fisicas/index'
import { Route as AppPessoasJuridicasIndexRouteImport } from './routes/_app/pessoas-juridicas/index'
import { Route as AppSegurancaIndexRouteImport } from './routes/_app/seguranca/index'
import { Route as DevBoletosIndexRouteImport } from './routes/dev/boletos/index'
import { Route as DevCarteirasIndexRouteImport } from './routes/dev/carteiras/index'
import { Route as DevCentralRegrasIndexRouteImport } from './routes/dev/central-regras/index'
import { Route as DevCobrancasIndexRouteImport } from './routes/dev/cobrancas/index'
import { Route as DevConciliacaoIndexRouteImport } from './routes/dev/conciliacao/index'
import { Route as DevConveniosIndexRouteImport } from './routes/dev/convenios/index'
import { Route as DevCreditoExcluidosIndexRouteImport } from './routes/dev/credito-excluidos/index'
import { Route as DevCreditoIndexRouteImport } from './routes/dev/credito/index'
import { Route as DevCreditoCreditNoteIdRouteImport } from './routes/dev/credito/$creditNoteId'
import { Route as DevDataprevIndexRouteImport } from './routes/dev/dataprev/index'
import { Route as DevFluxoIndexRouteImport } from './routes/dev/fluxo/index'
import { Route as DevGruposIndexRouteImport } from './routes/dev/grupos/index'
import { Route as DevMeuPerfilIndexRouteImport } from './routes/dev/meu-perfil/index'
import { Route as DevPermissoesCorrespondenteIndexRouteImport } from './routes/dev/permissoes-correspondente/index'
import { Route as DevPessoasIndexRouteImport } from './routes/dev/pessoas/index'
import { Route as DevPixMedAdminIndexRouteImport } from './routes/dev/pix-med-admin/index'
import { Route as DevProdutosContaIndexRouteImport } from './routes/dev/produtos-conta/index'
import { Route as DevProdutosCreditoIndexRouteImport } from './routes/dev/produtos-credito/index'
import { Route as DevProdutosLiquidacaoAutomaticaIndexRouteImport } from './routes/dev/produtos-liquidacao-automatica/index'
import { Route as DevRegrasDinamicasIndexRouteImport } from './routes/dev/regras-dinamicas/index'
import { Route as DevReguaComunicacaoIndexRouteImport } from './routes/dev/regua-comunicacao/index'
import { Route as DevSolicitacoesParceirosIndexRouteImport } from './routes/dev/solicitacoes-parceiros/index'
import { Route as DevUsuariosAplicacaoIndexRouteImport } from './routes/dev/usuarios-aplicacao/index'
import { Route as DevUsuariosIndexRouteImport } from './routes/dev/usuarios/index'
import { Route as LoginMfaIndexRouteImport } from './routes/login/mfa/index'
import { Route as LoginMfaSetupRouteImport } from './routes/login/mfa/setup'
import { Route as AppAprovacoesGestaoAprovacoesIndexRouteImport } from './routes/_app/aprovacoes/gestao-aprovacoes/index'
import { Route as AppAprovacoesGestaoAprovacoesInternetBankingRouteImport } from './routes/_app/aprovacoes/gestao-aprovacoes/internet-banking'
import { Route as AppAprovacoesGestaoAprovacoesOperacoesRouteImport } from './routes/_app/aprovacoes/gestao-aprovacoes/operacoes'
import { Route as AppAprovacoesGestaoAprovacoesOperadoresRouteImport } from './routes/_app/aprovacoes/gestao-aprovacoes/operadores'
import { Route as AppAprovacoesGestaoAprovacoesSolicitacoesRouteImport } from './routes/_app/aprovacoes/gestao-aprovacoes/solicitacoes'
import { Route as AppCadastroConfiguracaoRegrasIndexRouteImport } from './routes/_app/cadastro/configuracao-regras/index'
import { Route as AppCadastroConveniosIndexRouteImport } from './routes/_app/cadastro/convenios/index'
import { Route as AppCadastroFundosIndexRouteImport } from './routes/_app/cadastro/fundos/index'
import { Route as AppCadastroGestaoIndexRouteImport } from './routes/_app/cadastro/gestao/index'
import { Route as AppCadastroProdutosContaIndexRouteImport } from './routes/_app/cadastro/produtos-conta/index'
import { Route as AppCadastroProdutosCreditoIndexRouteImport } from './routes/_app/cadastro/produtos-credito/index'
import { Route as AppCadastroProdutosLiquidacaoAutomaticaIndexRouteImport } from './routes/_app/cadastro/produtos-liquidacao-automatica/index'
import { Route as AppCadastroRegrasDinamicasIndexRouteImport } from './routes/_app/cadastro/regras-dinamicas/index'
import { Route as AppCcbCessoesIndexRouteImport } from './routes/_app/ccb/cessoes/index'
import { Route as AppCcbCessoesNovaRouteImport } from './routes/_app/ccb/cessoes/nova'
import { Route as AppCcbContratarIndexRouteImport } from './routes/_app/ccb/contratar/index'
import { Route as AppCcbContratarSplatRouteImport } from './routes/_app/ccb/contratar/$'
import { Route as AppCcbCriarCpfTesteIndexRouteImport } from './routes/_app/ccb/criar-cpf-teste/index'
import { Route as AppCcbDescontoIndexRouteImport } from './routes/_app/ccb/desconto/index'
import { Route as AppCcbExcluidosIndexRouteImport } from './routes/_app/ccb/excluidos/index'
import { Route as AppCcbExcluirAutorizacaoIndexRouteImport } from './routes/_app/ccb/excluir-autorizacao/index'
import { Route as AppCcbGestaoAutorizacoesIndexRouteImport } from './routes/_app/ccb/gestao-autorizacoes/index'
import { Route as AppCcbOperacoesIndexRouteImport } from './routes/_app/ccb/operacoes/index'
import { Route as AppCcbOperacoesCreditNoteIdRouteImport } from './routes/_app/ccb/operacoes/$creditNoteId'
import { Route as AppCcbOperacoesNovaRouteImport } from './routes/_app/ccb/operacoes/nova'
import { Route as AppCcbSimularIndexRouteImport } from './routes/_app/ccb/simular/index'
import { Route as AppChatbotIdIndexRouteImport } from './routes/_app/chatbot/$id/index'
import { Route as AppChatbotRelatoriosIndexRouteImport } from './routes/_app/chatbot/relatorios/index'
import { Route as AppConcilicaoFgtsIndexRouteImport } from './routes/_app/concilicao/fgts/index'
import { Route as AppContasDigitaisContasIndexRouteImport } from './routes/_app/contas-digitais/contas/index'
import { Route as AppContasDigitaisGestaoSpiIndexRouteImport } from './routes/_app/contas-digitais/gestao-spi/index'
import { Route as AppContasDigitaisPixMedAdminIndexRouteImport } from './routes/_app/contas-digitais/pix-med-admin/index'
import { Route as AppContasDigitaisSolicitacoesIndexRouteImport } from './routes/_app/contas-digitais/solicitacoes/index'
import { Route as AppContasDigitaisSplitAutomaticoIndexRouteImport } from './routes/_app/contas-digitais/split-automatico/index'
import { Route as AppGestaoCarteiraCarteirasIndexRouteImport } from './routes/_app/gestao-carteira/carteiras/index'
import { Route as AppGestaoCarteiraCobrancasIndexRouteImport } from './routes/_app/gestao-carteira/cobrancas/index'
import { Route as AppGestaoCarteiraCobrancasBillingIdRouteImport } from './routes/_app/gestao-carteira/cobrancas/$billingId'
import { Route as AppGestaoCarteiraConciliacaoIndexRouteImport } from './routes/_app/gestao-carteira/conciliacao/index'
import { Route as AppGestaoCarteiraDashboardIndexRouteImport } from './routes/_app/gestao-carteira/dashboard/index'
import { Route as AppGestaoCarteiraExecucaoGarantiasIndexRouteImport } from './routes/_app/gestao-carteira/execucao-garantias/index'
import { Route as AppGestaoCarteiraParametrosIndexRouteImport } from './routes/_app/gestao-carteira/parametros/index'
import { Route as AppGestaoCarteiraParcelamentosIndexRouteImport } from './routes/_app/gestao-carteira/parcelamentos/index'
import { Route as AppGestaoCarteiraParcelamentosInstallmentIdRouteImport } from './routes/_app/gestao-carteira/parcelamentos/$installmentId'
import { Route as AppGestaoCarteiraRecuperacaoIndexRouteImport } from './routes/_app/gestao-carteira/recuperacao/index'
import { Route as AppGestaoCarteiraRecuperacaoFilaRouteImport } from './routes/_app/gestao-carteira/recuperacao/fila'
import { Route as AppGestaoCarteiraReguaIndexRouteImport } from './routes/_app/gestao-carteira/regua/index'
import { Route as AppMeuPerfilConfiguracoesIndexRouteImport } from './routes/_app/meu-perfil/configuracoes/index'
import { Route as AppMeuPerfilPermissoesEfetivasIndexRouteImport } from './routes/_app/meu-perfil/permissoes-efetivas/index'
import { Route as AppParceirosSolicitacoesIndexRouteImport } from './routes/_app/parceiros/solicitacoes/index'
import { Route as AppPessoasFisicasPendentesIndexRouteImport } from './routes/_app/pessoas-fisicas/pendentes/index'
import { Route as AppPessoasFisicasTodasIndexRouteImport } from './routes/_app/pessoas-fisicas/todas/index'
import { Route as AppPessoasJuridicasPendentesIndexRouteImport } from './routes/_app/pessoas-juridicas/pendentes/index'
import { Route as AppPessoasJuridicasTodasIndexRouteImport } from './routes/_app/pessoas-juridicas/todas/index'
import { Route as AppSegurancaGruposIndexRouteImport } from './routes/_app/seguranca/grupos/index'
import { Route as AppSegurancaRecursosCorrespondenteIndexRouteImport } from './routes/_app/seguranca/recursos-correspondente/index'
import { Route as AppSegurancaUsuariosAplicacaoIndexRouteImport } from './routes/_app/seguranca/usuarios-aplicacao/index'
import { Route as AppSegurancaUsuariosIndexRouteImport } from './routes/_app/seguranca/usuarios/index'
import { Route as AppCadastroConfiguracaoRegrasRuleIdIndexRouteImport } from './routes/_app/cadastro/configuracao-regras/$ruleId/index'
import { Route as AppCadastroConveniosConvenioIdIndexRouteImport } from './routes/_app/cadastro/convenios/$convenioId/index'
import { Route as AppCadastroFundosFundIdIndexRouteImport } from './routes/_app/cadastro/fundos/$fundId/index'
import { Route as AppCadastroFundosFundIdCessoesRouteImport } from './routes/_app/cadastro/fundos/$fundId/cessoes'
import { Route as AppCadastroFundosFundIdDocumentosRouteImport } from './routes/_app/cadastro/fundos/$fundId/documentos'
import { Route as AppCadastroFundosFundIdEnvolvidosRouteImport } from './routes/_app/cadastro/fundos/$fundId/envolvidos'
import { Route as AppCadastroGestaoProdutosCobrancaIndexRouteImport } from './routes/_app/cadastro/gestao/produtos-cobranca/index'
import { Route as AppCadastroGestaoProdutosCobrancaParametrosCustosRouteImport } from './routes/_app/cadastro/gestao/produtos-cobranca/parametros-custos'
import { Route as AppCadastroProdutosContaProductIdIndexRouteImport } from './routes/_app/cadastro/produtos-conta/$productId/index'
import { Route as AppCadastroProdutosContaProductIdDocumentosRouteImport } from './routes/_app/cadastro/produtos-conta/$productId/documentos'
import { Route as AppCadastroProdutosContaProductIdEnvolvidosRouteImport } from './routes/_app/cadastro/produtos-conta/$productId/envolvidos'
import { Route as AppCadastroProdutosCreditoProductIdIndexRouteImport } from './routes/_app/cadastro/produtos-credito/$productId/index'
import { Route as AppCadastroProdutosCreditoProductIdCustoDeEmissaoRouteImport } from './routes/_app/cadastro/produtos-credito/$productId/custo-de-emissao'
import { Route as AppCadastroProdutosCreditoProductIdDocumentosRouteImport } from './routes/_app/cadastro/produtos-credito/$productId/documentos'
import { Route as AppCadastroProdutosCreditoProductIdDocumentosParaAssinaturaRouteImport } from './routes/_app/cadastro/produtos-credito/$productId/documentos-para-assinatura'
import { Route as AppCadastroProdutosCreditoProductIdEnvolvidosRouteImport } from './routes/_app/cadastro/produtos-credito/$productId/envolvidos'
import { Route as AppCadastroProdutosCreditoProductIdOrgaoRouteImport } from './routes/_app/cadastro/produtos-credito/$productId/orgao'
import { Route as AppCadastroProdutosCreditoProductIdTemplatesRouteImport } from './routes/_app/cadastro/produtos-credito/$productId/templates'
import { Route as AppCadastroRegrasDinamicasRuleIdIndexRouteImport } from './routes/_app/cadastro/regras-dinamicas/$ruleId/index'
import { Route as AppCadastroRegrasDinamicasSimularIndexRouteImport } from './routes/_app/cadastro/regras-dinamicas/simular/index'
import { Route as AppCcbCessoesBatchAssignmentIdIndexRouteImport } from './routes/_app/ccb/cessoes/$batchAssignmentId/index'
import { Route as AppCcbCessoesBatchAssignmentIdDocumentosRouteImport } from './routes/_app/ccb/cessoes/$batchAssignmentId/documentos'
import { Route as AppCcbCessoesBatchAssignmentIdHistoricoRouteImport } from './routes/_app/ccb/cessoes/$batchAssignmentId/historico'
import { Route as AppCcbCessoesBatchAssignmentIdOperacoesRouteImport } from './routes/_app/ccb/cessoes/$batchAssignmentId/operacoes'
import { Route as AppCcbCessoesBatchAssignmentIdParcelasRouteImport } from './routes/_app/ccb/cessoes/$batchAssignmentId/parcelas'
import { Route as AppCcbCessoesSubmissoesDimensaIndexRouteImport } from './routes/_app/ccb/cessoes/submissoes-dimensa/index'
import { Route as AppCcbContratarConsignadoInssIndexRouteImport } from './routes/_app/ccb/contratar/consignado-inss/index'
import { Route as AppCcbContratarConsignadoPrivadoCdcIndexRouteImport } from './routes/_app/ccb/contratar/consignado-privado-cdc/index'
import { Route as AppCcbContratarConsignadoPrivadoIndexRouteImport } from './routes/_app/ccb/contratar/consignado-privado/index'
import { Route as AppCcbContratarConsignadoPublicoIndexRouteImport } from './routes/_app/ccb/contratar/consignado-publico/index'
import { Route as AppCcbContratarCreditoPessoalIndexRouteImport } from './routes/_app/ccb/contratar/credito-pessoal/index'
import { Route as AppCcbContratarVeiculoIndexRouteImport } from './routes/_app/ccb/contratar/veiculo/index'
import { Route as AppChatbotIdAtendimentoIndexRouteImport } from './routes/_app/chatbot/$id/atendimento/index'
import { Route as AppConcilicaoFgtsCalcularLiquidacaoAntecipadaIndexRouteImport } from './routes/_app/concilicao/fgts/calcular-liquidacao-antecipada/index'
import { Route as AppConcilicaoFgtsGerarArquivoLiquidacaoCaixaIndexRouteImport } from './routes/_app/concilicao/fgts/gerar-arquivo-liquidacao-caixa/index'
import { Route as AppConcilicaoFgtsSiapeIndexRouteImport } from './routes/_app/concilicao/fgts/siape/index'
import { Route as AppContasDigitaisContasBankAccountIdIndexRouteImport } from './routes/_app/contas-digitais/contas/$bankAccountId/index'
import { Route as AppContasDigitaisContasBankAccountIdTabRouteImport } from './routes/_app/contas-digitais/contas/$bankAccountId/$tab'
import { Route as AppContasDigitaisGestaoSpiConsultasIndexRouteImport } from './routes/_app/contas-digitais/gestao-spi/consultas/index'
import { Route as AppContasDigitaisSolicitacoesBankAccountIdIndexRouteImport } from './routes/_app/contas-digitais/solicitacoes/$bankAccountId/index'
import { Route as AppContasDigitaisSolicitacoesBankAccountIdAcessosConcedidosRouteImport } from './routes/_app/contas-digitais/solicitacoes/$bankAccountId/acessos-concedidos'
import { Route as AppContasDigitaisSolicitacoesBankAccountIdDocumentosRouteImport } from './routes/_app/contas-digitais/solicitacoes/$bankAccountId/documentos'
import { Route as AppContasDigitaisSolicitacoesBankAccountIdEnvolvidosRouteImport } from './routes/_app/contas-digitais/solicitacoes/$bankAccountId/envolvidos'
import { Route as AppContasDigitaisSolicitacoesBankAccountIdHistoricoRouteImport } from './routes/_app/contas-digitais/solicitacoes/$bankAccountId/historico'
import { Route as AppContasDigitaisSolicitacoesBankAccountIdKycRouteImport } from './routes/_app/contas-digitais/solicitacoes/$bankAccountId/kyc'
import { Route as AppContasDigitaisSplitAutomaticoOperationIdIndexRouteImport } from './routes/_app/contas-digitais/split-automatico/$operationId/index'
import { Route as AppContasDigitaisSplitAutomaticoOperationIdDetalhesRouteImport } from './routes/_app/contas-digitais/split-automatico/$operationId/detalhes'
import { Route as AppGestaoCarteiraCarteirasWalletIdIndexRouteImport } from './routes/_app/gestao-carteira/carteiras/$walletId/index'
import { Route as AppGestaoCarteiraCarteirasWalletIdArquivosRemessaRouteImport } from './routes/_app/gestao-carteira/carteiras/$walletId/arquivos-remessa'
import { Route as AppGestaoCarteiraCarteirasWalletIdArquivosRetornoRouteImport } from './routes/_app/gestao-carteira/carteiras/$walletId/arquivos-retorno'
import { Route as AppGestaoCarteiraCarteirasWalletIdTarifasConvenioRouteImport } from './routes/_app/gestao-carteira/carteiras/$walletId/tarifas-convenio'
import { Route as AppGestaoCarteiraConciliacaoDataprevIndexRouteImport } from './routes/_app/gestao-carteira/conciliacao/dataprev/index'
import { Route as AppGestaoCarteiraConciliacaoDataprevNovaConciliacaoRouteImport } from './routes/_app/gestao-carteira/conciliacao/dataprev/nova-conciliacao'
import { Route as AppGestaoCarteiraRecuperacaoAcordosIndexRouteImport } from './routes/_app/gestao-carteira/recuperacao/acordos/index'
import { Route as AppGestaoCarteiraRecuperacaoAcordosAgreementIdRouteImport } from './routes/_app/gestao-carteira/recuperacao/acordos/$agreementId'
import { Route as AppGestaoCarteiraRecuperacaoDevedorInstallmentIdRouteImport } from './routes/_app/gestao-carteira/recuperacao/devedor/$installmentId'
import { Route as AppParceirosSolicitacoesIdIndexRouteImport } from './routes/_app/parceiros/solicitacoes/$id/index'
import { Route as AppPessoasFisicasTodasPersonIdIndexRouteImport } from './routes/_app/pessoas-fisicas/todas/$personId/index'
import { Route as AppPessoasFisicasTodasPersonIdComplianceRouteImport } from './routes/_app/pessoas-fisicas/todas/$personId/compliance'
import { Route as AppPessoasFisicasTodasPersonIdCreditoRouteImport } from './routes/_app/pessoas-fisicas/todas/$personId/credito'
import { Route as AppPessoasFisicasTodasPersonIdDadosBancariosRouteImport } from './routes/_app/pessoas-fisicas/todas/$personId/dados-bancarios'
import { Route as AppPessoasFisicasTodasPersonIdDocumentosRouteImport } from './routes/_app/pessoas-fisicas/todas/$personId/documentos'
import { Route as AppPessoasFisicasTodasPersonIdOperacoesRouteImport } from './routes/_app/pessoas-fisicas/todas/$personId/operacoes'
import { Route as AppPessoasJuridicasTodasPersonIdIndexRouteImport } from './routes/_app/pessoas-juridicas/todas/$personId/index'
import { Route as AppPessoasJuridicasTodasPersonIdComplianceRouteImport } from './routes/_app/pessoas-juridicas/todas/$personId/compliance'
import { Route as AppPessoasJuridicasTodasPersonIdCreditoRouteImport } from './routes/_app/pessoas-juridicas/todas/$personId/credito'
import { Route as AppPessoasJuridicasTodasPersonIdDadosBancariosRouteImport } from './routes/_app/pessoas-juridicas/todas/$personId/dados-bancarios'
import { Route as AppPessoasJuridicasTodasPersonIdDocumentosRouteImport } from './routes/_app/pessoas-juridicas/todas/$personId/documentos'
import { Route as AppPessoasJuridicasTodasPersonIdOperacoesRouteImport } from './routes/_app/pessoas-juridicas/todas/$personId/operacoes'
import { Route as AppPessoasJuridicasTodasPersonIdSignatariosRouteImport } from './routes/_app/pessoas-juridicas/todas/$personId/signatarios'
import { Route as AppSegurancaGruposGroupIdIndexRouteImport } from './routes/_app/seguranca/grupos/$groupId/index'
import { Route as AppSegurancaGruposGroupIdMembrosRouteImport } from './routes/_app/seguranca/grupos/$groupId/membros'
import { Route as AppSegurancaGruposGroupIdPermissoesRouteImport } from './routes/_app/seguranca/grupos/$groupId/permissoes'
import { Route as AppSegurancaRecursosCorrespondenteIdIndexRouteImport } from './routes/_app/seguranca/recursos-correspondente/$id/index'
import { Route as AppSegurancaUsuariosAplicacaoAplicacaoIdIndexRouteImport } from './routes/_app/seguranca/usuarios-aplicacao/$aplicacaoId/index'
import { Route as AppSegurancaUsuariosUserIdIndexRouteImport } from './routes/_app/seguranca/usuarios/$userId/index'
import { Route as AppSegurancaUsuariosUserIdGruposRouteImport } from './routes/_app/seguranca/usuarios/$userId/grupos'
import { Route as AppSegurancaUsuariosUserIdPermissoesRouteImport } from './routes/_app/seguranca/usuarios/$userId/permissoes'
import { Route as AppCadastroConfiguracaoRegrasRuleIdProdutosIndexRouteImport } from './routes/_app/cadastro/configuracao-regras/$ruleId/produtos/index'
import { Route as AppCcbContratarConsignadoInssNovoIndexRouteImport } from './routes/_app/ccb/contratar/consignado-inss/novo/index'
import { Route as AppCcbContratarConsignadoInssRefinanciamentoIndexRouteImport } from './routes/_app/ccb/contratar/consignado-inss/refinanciamento/index'
import { Route as AppCcbContratarConsignadoPrivadoNovoIndexRouteImport } from './routes/_app/ccb/contratar/consignado-privado/novo/index'
import { Route as AppCcbContratarConsignadoPrivadoRefinanciamentoIndexRouteImport } from './routes/_app/ccb/contratar/consignado-privado/refinanciamento/index'
import { Route as AppCcbContratarConsignadoPublicoNovoCompraDeDividaIndexRouteImport } from './routes/_app/ccb/contratar/consignado-publico/novo-compra-de-divida/index'
import { Route as AppCcbContratarConsignadoPublicoNovoIndexRouteImport } from './routes/_app/ccb/contratar/consignado-publico/novo/index'
import { Route as AppCcbContratarConsignadoPublicoRefinanciamentoIndexRouteImport } from './routes/_app/ccb/contratar/consignado-publico/refinanciamento/index'
import { Route as AppCcbContratarVeiculoCarEquityIndexRouteImport } from './routes/_app/ccb/contratar/veiculo/car-equity/index'
import { Route as AppCcbContratarVeiculoFinanciamentoIndexRouteImport } from './routes/_app/ccb/contratar/veiculo/financiamento/index'
import { Route as AppContasDigitaisContasBankAccountIdPixGerenciarChavesRouteImport } from './routes/_app/contas-digitais/contas/$bankAccountId/pix/gerenciar-chaves'
import { Route as AppContasDigitaisContasBankAccountIdVisualizarIndexRouteImport } from './routes/_app/contas-digitais/contas/$bankAccountId/visualizar/index'
import { Route as AppContasDigitaisContasBankAccountIdVisualizarTabRouteImport } from './routes/_app/contas-digitais/contas/$bankAccountId/visualizar/$tab'
import { Route as AppGestaoCarteiraCarteirasArquivosFileIdRemessaRouteImport } from './routes/_app/gestao-carteira/carteiras/arquivos/$fileId/remessa'
import { Route as AppGestaoCarteiraCarteirasArquivosFileIdRetornoRouteImport } from './routes/_app/gestao-carteira/carteiras/arquivos/$fileId/retorno'
import { Route as AppGestaoCarteiraConciliacaoDataprevConciliationIdIndexRouteImport } from './routes/_app/gestao-carteira/conciliacao/dataprev/$conciliationId/index'
import { Route as AppGestaoCarteiraConciliacaoDataprevConciliationIdHistoricoRouteImport } from './routes/_app/gestao-carteira/conciliacao/dataprev/$conciliationId/historico'
import { Route as AppGestaoCarteiraConciliacaoDataprevConciliationIdInconsistenciasRouteImport } from './routes/_app/gestao-carteira/conciliacao/dataprev/$conciliationId/inconsistencias'
import { Route as AppGestaoCarteiraConciliacaoDataprevConciliationIdLinhaDeRepasseRouteImport } from './routes/_app/gestao-carteira/conciliacao/dataprev/$conciliationId/linha-de-repasse'
import { Route as AppGestaoCarteiraConciliacaoDataprevConciliationIdNaoEncerradasRouteImport } from './routes/_app/gestao-carteira/conciliacao/dataprev/$conciliationId/nao-encerradas'
import { Route as AppGestaoCarteiraConciliacaoDataprevBolsaoIndexRouteImport } from './routes/_app/gestao-carteira/conciliacao/dataprev/bolsao/index'
import { Route as AppGestaoCarteiraConciliacaoDataprevBolsaoIdRouteImport } from './routes/_app/gestao-carteira/conciliacao/dataprev/bolsao/$id'
import { Route as AppContasDigitaisContasBankAccountIdPixPixAutomaticoIndexRouteImport } from './routes/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/index'
import { Route as AppContasDigitaisContasBankAccountIdPixPixAutomaticoAtivasRouteImport } from './routes/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/ativas'
import { Route as AppContasDigitaisContasBankAccountIdPixPixAutomaticoHistoricoRouteImport } from './routes/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/historico'
import { Route as AppContasDigitaisContasBankAccountIdPixPixAutomaticoPendentesRouteImport } from './routes/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/pendentes'
import { Route as AppContasDigitaisContasBankAccountIdPixPixMedIndexRouteImport } from './routes/_app/contas-digitais/contas/$bankAccountId/pix/pix-med/index'
import { Route as AppContasDigitaisContasBankAccountIdPixPixMedConsultarRouteImport } from './routes/_app/contas-digitais/contas/$bankAccountId/pix/pix-med/consultar'
import { Route as AppContasDigitaisContasBankAccountIdPixPixMedContestarRouteImport } from './routes/_app/contas-digitais/contas/$bankAccountId/pix/pix-med/contestar'
import { Route as AppContasDigitaisContasBankAccountIdPixPixMedInformacoesRouteImport } from './routes/_app/contas-digitais/contas/$bankAccountId/pix/pix-med/informacoes'
import { Route as AppContasDigitaisContasBankAccountIdPixPixAutomaticoAgendadosIndexRouteImport } from './routes/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados/index'
import { Route as AppContasDigitaisContasBankAccountIdPixPixAutomaticoAgendadosRealizadosRouteImport } from './routes/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados/realizados'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRouteRoute = LoginRouteRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppEmConstrucaoRoute = AppEmConstrucaoRouteImport.update({
  id: '/em-construcao',
  path: '/em-construcao',
  getParentRoute: () => AppRoute,
} as any)
const AppLegadoIndisponivelRoute = AppLegadoIndisponivelRouteImport.update({
  id: '/legado-indisponivel',
  path: '/legado-indisponivel',
  getParentRoute: () => AppRoute,
} as any)
const AppMeuPerfilRouteRoute = AppMeuPerfilRouteRouteImport.update({
  id: '/meu-perfil',
  path: '/meu-perfil',
  getParentRoute: () => AppRoute,
} as any)
const DevBlocksRoute = DevBlocksRouteImport.update({
  id: '/dev/blocks',
  path: '/dev/blocks',
  getParentRoute: () => rootRouteImport,
} as any)
const DevCessionariosRoute = DevCessionariosRouteImport.update({
  id: '/dev/cessionarios',
  path: '/dev/cessionarios',
  getParentRoute: () => rootRouteImport,
} as any)
const DevCreditoRouteRoute = DevCreditoRouteRouteImport.update({
  id: '/dev/credito',
  path: '/dev/credito',
  getParentRoute: () => rootRouteImport,
} as any)
const DevFormsRoute = DevFormsRouteImport.update({
  id: '/dev/forms',
  path: '/dev/forms',
  getParentRoute: () => rootRouteImport,
} as any)
const DevPatternsRoute = DevPatternsRouteImport.update({
  id: '/dev/patterns',
  path: '/dev/patterns',
  getParentRoute: () => rootRouteImport,
} as any)
const DevProdutosCobrancaRoute = DevProdutosCobrancaRouteImport.update({
  id: '/dev/produtos-cobranca',
  path: '/dev/produtos-cobranca',
  getParentRoute: () => rootRouteImport,
} as any)
const DevRecordRoute = DevRecordRouteImport.update({
  id: '/dev/record',
  path: '/dev/record',
  getParentRoute: () => rootRouteImport,
} as any)
const DevReguaCobrancaRoute = DevReguaCobrancaRouteImport.update({
  id: '/dev/regua-cobranca',
  path: '/dev/regua-cobranca',
  getParentRoute: () => rootRouteImport,
} as any)
const DevShellRoute = DevShellRouteImport.update({
  id: '/dev/shell',
  path: '/dev/shell',
  getParentRoute: () => rootRouteImport,
} as any)
const DevUiRoute = DevUiRouteImport.update({
  id: '/dev/ui',
  path: '/dev/ui',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LoginRouteRoute,
} as any)
const LoginAlterarSenhaRoute = LoginAlterarSenhaRouteImport.update({
  id: '/alterar-senha',
  path: '/alterar-senha',
  getParentRoute: () => LoginRouteRoute,
} as any)
const LoginConfirmarEmailRoute = LoginConfirmarEmailRouteImport.update({
  id: '/confirmar-email',
  path: '/confirmar-email',
  getParentRoute: () => LoginRouteRoute,
} as any)
const LoginConfirmarSenhaRoute = LoginConfirmarSenhaRouteImport.update({
  id: '/confirmar-senha',
  path: '/confirmar-senha',
  getParentRoute: () => LoginRouteRoute,
} as any)
const LoginLogoutRoute = LoginLogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => LoginRouteRoute,
} as any)
const LoginRecuperarSenhaRoute = LoginRecuperarSenhaRouteImport.update({
  id: '/recuperar-senha',
  path: '/recuperar-senha',
  getParentRoute: () => LoginRouteRoute,
} as any)
const AppAprovacoesIndexRoute = AppAprovacoesIndexRouteImport.update({
  id: '/aprovacoes/',
  path: '/aprovacoes/',
  getParentRoute: () => AppRoute,
} as any)
const AppCcbContratarRouteRoute = AppCcbContratarRouteRouteImport.update({
  id: '/ccb/contratar',
  path: '/ccb/contratar',
  getParentRoute: () => AppRoute,
} as any)
const AppChatbotIndexRoute = AppChatbotIndexRouteImport.update({
  id: '/chatbot/',
  path: '/chatbot/',
  getParentRoute: () => AppRoute,
} as any)
const AppConcilicaoIndexRoute = AppConcilicaoIndexRouteImport.update({
  id: '/concilicao/',
  path: '/concilicao/',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardIndexRoute = AppDashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => AppRoute,
} as any)
const AppGestaoCarteiraIndexRoute = AppGestaoCarteiraIndexRouteImport.update({
  id: '/gestao-carteira/',
  path: '/gestao-carteira/',
  getParentRoute: () => AppRoute,
} as any)
const AppMeuPerfilIndexRoute = AppMeuPerfilIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppMeuPerfilRouteRoute,
} as any)
const AppPessoasFisicasIndexRoute = AppPessoasFisicasIndexRouteImport.update({
  id: '/pessoas-fisicas/',
  path: '/pessoas-fisicas/',
  getParentRoute: () => AppRoute,
} as any)
const AppPessoasJuridicasIndexRoute =
  AppPessoasJuridicasIndexRouteImport.update({
    id: '/pessoas-juridicas/',
    path: '/pessoas-juridicas/',
    getParentRoute: () => AppRoute,
  } as any)
const AppSegurancaIndexRoute = AppSegurancaIndexRouteImport.update({
  id: '/seguranca/',
  path: '/seguranca/',
  getParentRoute: () => AppRoute,
} as any)
const DevBoletosIndexRoute = DevBoletosIndexRouteImport.update({
  id: '/dev/boletos/',
  path: '/dev/boletos/',
  getParentRoute: () => rootRouteImport,
} as any)
const DevCarteirasIndexRoute = DevCarteirasIndexRouteImport.update({
  id: '/dev/carteiras/',
  path: '/dev/carteiras/',
  getParentRoute: () => rootRouteImport,
} as any)
const DevCentralRegrasIndexRoute = DevCentralRegrasIndexRouteImport.update({
  id: '/dev/central-regras/',
  path: '/dev/central-regras/',
  getParentRoute: () => rootRouteImport,
} as any)
const DevCobrancasIndexRoute = DevCobrancasIndexRouteImport.update({
  id: '/dev/cobrancas/',
  path: '/dev/cobrancas/',
  getParentRoute: () => rootRouteImport,
} as any)
const DevConciliacaoIndexRoute = DevConciliacaoIndexRouteImport.update({
  id: '/dev/conciliacao/',
  path: '/dev/conciliacao/',
  getParentRoute: () => rootRouteImport,
} as any)
const DevConveniosIndexRoute = DevConveniosIndexRouteImport.update({
  id: '/dev/convenios/',
  path: '/dev/convenios/',
  getParentRoute: () => rootRouteImport,
} as any)
const DevCreditoExcluidosIndexRoute =
  DevCreditoExcluidosIndexRouteImport.update({
    id: '/dev/credito-excluidos/',
    path: '/dev/credito-excluidos/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DevCreditoIndexRoute = DevCreditoIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DevCreditoRouteRoute,
} as any)
const DevCreditoCreditNoteIdRoute = DevCreditoCreditNoteIdRouteImport.update({
  id: '/$creditNoteId',
  path: '/$creditNoteId',
  getParentRoute: () => DevCreditoRouteRoute,
} as any)
const DevDataprevIndexRoute = DevDataprevIndexRouteImport.update({
  id: '/dev/dataprev/',
  path: '/dev/dataprev/',
  getParentRoute: () => rootRouteImport,
} as any)
const DevFluxoIndexRoute = DevFluxoIndexRouteImport.update({
  id: '/dev/fluxo/',
  path: '/dev/fluxo/',
  getParentRoute: () => rootRouteImport,
} as any)
const DevGruposIndexRoute = DevGruposIndexRouteImport.update({
  id: '/dev/grupos/',
  path: '/dev/grupos/',
  getParentRoute: () => rootRouteImport,
} as any)
const DevMeuPerfilIndexRoute = DevMeuPerfilIndexRouteImport.update({
  id: '/dev/meu-perfil/',
  path: '/dev/meu-perfil/',
  getParentRoute: () => rootRouteImport,
} as any)
const DevPermissoesCorrespondenteIndexRoute =
  DevPermissoesCorrespondenteIndexRouteImport.update({
    id: '/dev/permissoes-correspondente/',
    path: '/dev/permissoes-correspondente/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DevPessoasIndexRoute = DevPessoasIndexRouteImport.update({
  id: '/dev/pessoas/',
  path: '/dev/pessoas/',
  getParentRoute: () => rootRouteImport,
} as any)
const DevPixMedAdminIndexRoute = DevPixMedAdminIndexRouteImport.update({
  id: '/dev/pix-med-admin/',
  path: '/dev/pix-med-admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const DevProdutosContaIndexRoute = DevProdutosContaIndexRouteImport.update({
  id: '/dev/produtos-conta/',
  path: '/dev/produtos-conta/',
  getParentRoute: () => rootRouteImport,
} as any)
const DevProdutosCreditoIndexRoute = DevProdutosCreditoIndexRouteImport.update({
  id: '/dev/produtos-credito/',
  path: '/dev/produtos-credito/',
  getParentRoute: () => rootRouteImport,
} as any)
const DevProdutosLiquidacaoAutomaticaIndexRoute =
  DevProdutosLiquidacaoAutomaticaIndexRouteImport.update({
    id: '/dev/produtos-liquidacao-automatica/',
    path: '/dev/produtos-liquidacao-automatica/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DevRegrasDinamicasIndexRoute = DevRegrasDinamicasIndexRouteImport.update({
  id: '/dev/regras-dinamicas/',
  path: '/dev/regras-dinamicas/',
  getParentRoute: () => rootRouteImport,
} as any)
const DevReguaComunicacaoIndexRoute =
  DevReguaComunicacaoIndexRouteImport.update({
    id: '/dev/regua-comunicacao/',
    path: '/dev/regua-comunicacao/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DevSolicitacoesParceirosIndexRoute =
  DevSolicitacoesParceirosIndexRouteImport.update({
    id: '/dev/solicitacoes-parceiros/',
    path: '/dev/solicitacoes-parceiros/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DevUsuariosAplicacaoIndexRoute =
  DevUsuariosAplicacaoIndexRouteImport.update({
    id: '/dev/usuarios-aplicacao/',
    path: '/dev/usuarios-aplicacao/',
    getParentRoute: () => rootRouteImport,
  } as any)
const DevUsuariosIndexRoute = DevUsuariosIndexRouteImport.update({
  id: '/dev/usuarios/',
  path: '/dev/usuarios/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginMfaIndexRoute = LoginMfaIndexRouteImport.update({
  id: '/mfa/',
  path: '/mfa/',
  getParentRoute: () => LoginRouteRoute,
} as any)
const LoginMfaSetupRoute = LoginMfaSetupRouteImport.update({
  id: '/mfa/setup',
  path: '/mfa/setup',
  getParentRoute: () => LoginRouteRoute,
} as any)
const AppAprovacoesGestaoAprovacoesIndexRoute =
  AppAprovacoesGestaoAprovacoesIndexRouteImport.update({
    id: '/aprovacoes/gestao-aprovacoes/',
    path: '/aprovacoes/gestao-aprovacoes/',
    getParentRoute: () => AppRoute,
  } as any)
const AppAprovacoesGestaoAprovacoesInternetBankingRoute =
  AppAprovacoesGestaoAprovacoesInternetBankingRouteImport.update({
    id: '/aprovacoes/gestao-aprovacoes/internet-banking',
    path: '/aprovacoes/gestao-aprovacoes/internet-banking',
    getParentRoute: () => AppRoute,
  } as any)
const AppAprovacoesGestaoAprovacoesOperacoesRoute =
  AppAprovacoesGestaoAprovacoesOperacoesRouteImport.update({
    id: '/aprovacoes/gestao-aprovacoes/operacoes',
    path: '/aprovacoes/gestao-aprovacoes/operacoes',
    getParentRoute: () => AppRoute,
  } as any)
const AppAprovacoesGestaoAprovacoesOperadoresRoute =
  AppAprovacoesGestaoAprovacoesOperadoresRouteImport.update({
    id: '/aprovacoes/gestao-aprovacoes/operadores',
    path: '/aprovacoes/gestao-aprovacoes/operadores',
    getParentRoute: () => AppRoute,
  } as any)
const AppAprovacoesGestaoAprovacoesSolicitacoesRoute =
  AppAprovacoesGestaoAprovacoesSolicitacoesRouteImport.update({
    id: '/aprovacoes/gestao-aprovacoes/solicitacoes',
    path: '/aprovacoes/gestao-aprovacoes/solicitacoes',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastroConfiguracaoRegrasIndexRoute =
  AppCadastroConfiguracaoRegrasIndexRouteImport.update({
    id: '/cadastro/configuracao-regras/',
    path: '/cadastro/configuracao-regras/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastroConveniosIndexRoute =
  AppCadastroConveniosIndexRouteImport.update({
    id: '/cadastro/convenios/',
    path: '/cadastro/convenios/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastroFundosIndexRoute = AppCadastroFundosIndexRouteImport.update({
  id: '/cadastro/fundos/',
  path: '/cadastro/fundos/',
  getParentRoute: () => AppRoute,
} as any)
const AppCadastroGestaoIndexRoute = AppCadastroGestaoIndexRouteImport.update({
  id: '/cadastro/gestao/',
  path: '/cadastro/gestao/',
  getParentRoute: () => AppRoute,
} as any)
const AppCadastroProdutosContaIndexRoute =
  AppCadastroProdutosContaIndexRouteImport.update({
    id: '/cadastro/produtos-conta/',
    path: '/cadastro/produtos-conta/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastroProdutosCreditoIndexRoute =
  AppCadastroProdutosCreditoIndexRouteImport.update({
    id: '/cadastro/produtos-credito/',
    path: '/cadastro/produtos-credito/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastroProdutosLiquidacaoAutomaticaIndexRoute =
  AppCadastroProdutosLiquidacaoAutomaticaIndexRouteImport.update({
    id: '/cadastro/produtos-liquidacao-automatica/',
    path: '/cadastro/produtos-liquidacao-automatica/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastroRegrasDinamicasIndexRoute =
  AppCadastroRegrasDinamicasIndexRouteImport.update({
    id: '/cadastro/regras-dinamicas/',
    path: '/cadastro/regras-dinamicas/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCcbCessoesIndexRoute = AppCcbCessoesIndexRouteImport.update({
  id: '/ccb/cessoes/',
  path: '/ccb/cessoes/',
  getParentRoute: () => AppRoute,
} as any)
const AppCcbCessoesNovaRoute = AppCcbCessoesNovaRouteImport.update({
  id: '/ccb/cessoes/nova',
  path: '/ccb/cessoes/nova',
  getParentRoute: () => AppRoute,
} as any)
const AppCcbContratarIndexRoute = AppCcbContratarIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppCcbContratarRouteRoute,
} as any)
const AppCcbContratarSplatRoute = AppCcbContratarSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AppCcbContratarRouteRoute,
} as any)
const AppCcbCriarCpfTesteIndexRoute =
  AppCcbCriarCpfTesteIndexRouteImport.update({
    id: '/ccb/criar-cpf-teste/',
    path: '/ccb/criar-cpf-teste/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCcbDescontoIndexRoute = AppCcbDescontoIndexRouteImport.update({
  id: '/ccb/desconto/',
  path: '/ccb/desconto/',
  getParentRoute: () => AppRoute,
} as any)
const AppCcbExcluidosIndexRoute = AppCcbExcluidosIndexRouteImport.update({
  id: '/ccb/excluidos/',
  path: '/ccb/excluidos/',
  getParentRoute: () => AppRoute,
} as any)
const AppCcbExcluirAutorizacaoIndexRoute =
  AppCcbExcluirAutorizacaoIndexRouteImport.update({
    id: '/ccb/excluir-autorizacao/',
    path: '/ccb/excluir-autorizacao/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCcbGestaoAutorizacoesIndexRoute =
  AppCcbGestaoAutorizacoesIndexRouteImport.update({
    id: '/ccb/gestao-autorizacoes/',
    path: '/ccb/gestao-autorizacoes/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCcbOperacoesIndexRoute = AppCcbOperacoesIndexRouteImport.update({
  id: '/ccb/operacoes/',
  path: '/ccb/operacoes/',
  getParentRoute: () => AppRoute,
} as any)
const AppCcbOperacoesCreditNoteIdRoute =
  AppCcbOperacoesCreditNoteIdRouteImport.update({
    id: '/ccb/operacoes/$creditNoteId',
    path: '/ccb/operacoes/$creditNoteId',
    getParentRoute: () => AppRoute,
  } as any)
const AppCcbOperacoesNovaRoute = AppCcbOperacoesNovaRouteImport.update({
  id: '/ccb/operacoes/nova',
  path: '/ccb/operacoes/nova',
  getParentRoute: () => AppRoute,
} as any)
const AppCcbSimularIndexRoute = AppCcbSimularIndexRouteImport.update({
  id: '/ccb/simular/',
  path: '/ccb/simular/',
  getParentRoute: () => AppRoute,
} as any)
const AppChatbotIdIndexRoute = AppChatbotIdIndexRouteImport.update({
  id: '/chatbot/$id/',
  path: '/chatbot/$id/',
  getParentRoute: () => AppRoute,
} as any)
const AppChatbotRelatoriosIndexRoute =
  AppChatbotRelatoriosIndexRouteImport.update({
    id: '/chatbot/relatorios/',
    path: '/chatbot/relatorios/',
    getParentRoute: () => AppRoute,
  } as any)
const AppConcilicaoFgtsIndexRoute = AppConcilicaoFgtsIndexRouteImport.update({
  id: '/concilicao/fgts/',
  path: '/concilicao/fgts/',
  getParentRoute: () => AppRoute,
} as any)
const AppContasDigitaisContasIndexRoute =
  AppContasDigitaisContasIndexRouteImport.update({
    id: '/contas-digitais/contas/',
    path: '/contas-digitais/contas/',
    getParentRoute: () => AppRoute,
  } as any)
const AppContasDigitaisGestaoSpiIndexRoute =
  AppContasDigitaisGestaoSpiIndexRouteImport.update({
    id: '/contas-digitais/gestao-spi/',
    path: '/contas-digitais/gestao-spi/',
    getParentRoute: () => AppRoute,
  } as any)
const AppContasDigitaisPixMedAdminIndexRoute =
  AppContasDigitaisPixMedAdminIndexRouteImport.update({
    id: '/contas-digitais/pix-med-admin/',
    path: '/contas-digitais/pix-med-admin/',
    getParentRoute: () => AppRoute,
  } as any)
const AppContasDigitaisSolicitacoesIndexRoute =
  AppContasDigitaisSolicitacoesIndexRouteImport.update({
    id: '/contas-digitais/solicitacoes/',
    path: '/contas-digitais/solicitacoes/',
    getParentRoute: () => AppRoute,
  } as any)
const AppContasDigitaisSplitAutomaticoIndexRoute =
  AppContasDigitaisSplitAutomaticoIndexRouteImport.update({
    id: '/contas-digitais/split-automatico/',
    path: '/contas-digitais/split-automatico/',
    getParentRoute: () => AppRoute,
  } as any)
const AppGestaoCarteiraCarteirasIndexRoute =
  AppGestaoCarteiraCarteirasIndexRouteImport.update({
    id: '/gestao-carteira/carteiras/',
    path: '/gestao-carteira/carteiras/',
    getParentRoute: () => AppRoute,
  } as any)
const AppGestaoCarteiraCobrancasIndexRoute =
  AppGestaoCarteiraCobrancasIndexRouteImport.update({
    id: '/gestao-carteira/cobrancas/',
    path: '/gestao-carteira/cobrancas/',
    getParentRoute: () => AppRoute,
  } as any)
const AppGestaoCarteiraCobrancasBillingIdRoute =
  AppGestaoCarteiraCobrancasBillingIdRouteImport.update({
    id: '/gestao-carteira/cobrancas/$billingId',
    path: '/gestao-carteira/cobrancas/$billingId',
    getParentRoute: () => AppRoute,
  } as any)
const AppGestaoCarteiraConciliacaoIndexRoute =
  AppGestaoCarteiraConciliacaoIndexRouteImport.update({
    id: '/gestao-carteira/conciliacao/',
    path: '/gestao-carteira/conciliacao/',
    getParentRoute: () => AppRoute,
  } as any)
const AppGestaoCarteiraDashboardIndexRoute =
  AppGestaoCarteiraDashboardIndexRouteImport.update({
    id: '/gestao-carteira/dashboard/',
    path: '/gestao-carteira/dashboard/',
    getParentRoute: () => AppRoute,
  } as any)
const AppGestaoCarteiraExecucaoGarantiasIndexRoute =
  AppGestaoCarteiraExecucaoGarantiasIndexRouteImport.update({
    id: '/gestao-carteira/execucao-garantias/',
    path: '/gestao-carteira/execucao-garantias/',
    getParentRoute: () => AppRoute,
  } as any)
const AppGestaoCarteiraParametrosIndexRoute =
  AppGestaoCarteiraParametrosIndexRouteImport.update({
    id: '/gestao-carteira/parametros/',
    path: '/gestao-carteira/parametros/',
    getParentRoute: () => AppRoute,
  } as any)
const AppGestaoCarteiraParcelamentosIndexRoute =
  AppGestaoCarteiraParcelamentosIndexRouteImport.update({
    id: '/gestao-carteira/parcelamentos/',
    path: '/gestao-carteira/parcelamentos/',
    getParentRoute: () => AppRoute,
  } as any)
const AppGestaoCarteiraParcelamentosInstallmentIdRoute =
  AppGestaoCarteiraParcelamentosInstallmentIdRouteImport.update({
    id: '/gestao-carteira/parcelamentos/$installmentId',
    path: '/gestao-carteira/parcelamentos/$installmentId',
    getParentRoute: () => AppRoute,
  } as any)
const AppGestaoCarteiraRecuperacaoIndexRoute =
  AppGestaoCarteiraRecuperacaoIndexRouteImport.update({
    id: '/gestao-carteira/recuperacao/',
    path: '/gestao-carteira/recuperacao/',
    getParentRoute: () => AppRoute,
  } as any)
const AppGestaoCarteiraRecuperacaoFilaRoute =
  AppGestaoCarteiraRecuperacaoFilaRouteImport.update({
    id: '/gestao-carteira/recuperacao/fila',
    path: '/gestao-carteira/recuperacao/fila',
    getParentRoute: () => AppRoute,
  } as any)
const AppGestaoCarteiraReguaIndexRoute =
  AppGestaoCarteiraReguaIndexRouteImport.update({
    id: '/gestao-carteira/regua/',
    path: '/gestao-carteira/regua/',
    getParentRoute: () => AppRoute,
  } as any)
const AppMeuPerfilConfiguracoesIndexRoute =
  AppMeuPerfilConfiguracoesIndexRouteImport.update({
    id: '/configuracoes/',
    path: '/configuracoes/',
    getParentRoute: () => AppMeuPerfilRouteRoute,
  } as any)
const AppMeuPerfilPermissoesEfetivasIndexRoute =
  AppMeuPerfilPermissoesEfetivasIndexRouteImport.update({
    id: '/permissoes-efetivas/',
    path: '/permissoes-efetivas/',
    getParentRoute: () => AppMeuPerfilRouteRoute,
  } as any)
const AppParceirosSolicitacoesIndexRoute =
  AppParceirosSolicitacoesIndexRouteImport.update({
    id: '/parceiros/solicitacoes/',
    path: '/parceiros/solicitacoes/',
    getParentRoute: () => AppRoute,
  } as any)
const AppPessoasFisicasPendentesIndexRoute =
  AppPessoasFisicasPendentesIndexRouteImport.update({
    id: '/pessoas-fisicas/pendentes/',
    path: '/pessoas-fisicas/pendentes/',
    getParentRoute: () => AppRoute,
  } as any)
const AppPessoasFisicasTodasIndexRoute =
  AppPessoasFisicasTodasIndexRouteImport.update({
    id: '/pessoas-fisicas/todas/',
    path: '/pessoas-fisicas/todas/',
    getParentRoute: () => AppRoute,
  } as any)
const AppPessoasJuridicasPendentesIndexRoute =
  AppPessoasJuridicasPendentesIndexRouteImport.update({
    id: '/pessoas-juridicas/pendentes/',
    path: '/pessoas-juridicas/pendentes/',
    getParentRoute: () => AppRoute,
  } as any)
const AppPessoasJuridicasTodasIndexRoute =
  AppPessoasJuridicasTodasIndexRouteImport.update({
    id: '/pessoas-juridicas/todas/',
    path: '/pessoas-juridicas/todas/',
    getParentRoute: () => AppRoute,
  } as any)
const AppSegurancaGruposIndexRoute = AppSegurancaGruposIndexRouteImport.update({
  id: '/seguranca/grupos/',
  path: '/seguranca/grupos/',
  getParentRoute: () => AppRoute,
} as any)
const AppSegurancaRecursosCorrespondenteIndexRoute =
  AppSegurancaRecursosCorrespondenteIndexRouteImport.update({
    id: '/seguranca/recursos-correspondente/',
    path: '/seguranca/recursos-correspondente/',
    getParentRoute: () => AppRoute,
  } as any)
const AppSegurancaUsuariosAplicacaoIndexRoute =
  AppSegurancaUsuariosAplicacaoIndexRouteImport.update({
    id: '/seguranca/usuarios-aplicacao/',
    path: '/seguranca/usuarios-aplicacao/',
    getParentRoute: () => AppRoute,
  } as any)
const AppSegurancaUsuariosIndexRoute =
  AppSegurancaUsuariosIndexRouteImport.update({
    id: '/seguranca/usuarios/',
    path: '/seguranca/usuarios/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastroConfiguracaoRegrasRuleIdIndexRoute =
  AppCadastroConfiguracaoRegrasRuleIdIndexRouteImport.update({
    id: '/cadastro/configuracao-regras/$ruleId/',
    path: '/cadastro/configuracao-regras/$ruleId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastroConveniosConvenioIdIndexRoute =
  AppCadastroConveniosConvenioIdIndexRouteImport.update({
    id: '/cadastro/convenios/$convenioId/',
    path: '/cadastro/convenios/$convenioId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastroFundosFundIdIndexRoute =
  AppCadastroFundosFundIdIndexRouteImport.update({
    id: '/cadastro/fundos/$fundId/',
    path: '/cadastro/fundos/$fundId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastroFundosFundIdCessoesRoute =
  AppCadastroFundosFundIdCessoesRouteImport.update({
    id: '/cadastro/fundos/$fundId/cessoes',
    path: '/cadastro/fundos/$fundId/cessoes',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastroFundosFundIdDocumentosRoute =
  AppCadastroFundosFundIdDocumentosRouteImport.update({
    id: '/cadastro/fundos/$fundId/documentos',
    path: '/cadastro/fundos/$fundId/documentos',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastroFundosFundIdEnvolvidosRoute =
  AppCadastroFundosFundIdEnvolvidosRouteImport.update({
    id: '/cadastro/fundos/$fundId/envolvidos',
    path: '/cadastro/fundos/$fundId/envolvidos',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastroGestaoProdutosCobrancaIndexRoute =
  AppCadastroGestaoProdutosCobrancaIndexRouteImport.update({
    id: '/cadastro/gestao/produtos-cobranca/',
    path: '/cadastro/gestao/produtos-cobranca/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastroGestaoProdutosCobrancaParametrosCustosRoute =
  AppCadastroGestaoProdutosCobrancaParametrosCustosRouteImport.update({
    id: '/cadastro/gestao/produtos-cobranca/parametros-custos',
    path: '/cadastro/gestao/produtos-cobranca/parametros-custos',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastroProdutosContaProductIdIndexRoute =
  AppCadastroProdutosContaProductIdIndexRouteImport.update({
    id: '/cadastro/produtos-conta/$productId/',
    path: '/cadastro/produtos-conta/$productId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastroProdutosContaProductIdDocumentosRoute =
  AppCadastroProdutosContaProductIdDocumentosRouteImport.update({
    id: '/cadastro/produtos-conta/$productId/documentos',
    path: '/cadastro/produtos-conta/$productId/documentos',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastroProdutosContaProductIdEnvolvidosRoute =
  AppCadastroProdutosContaProductIdEnvolvidosRouteImport.update({
    id: '/cadastro/produtos-conta/$productId/envolvidos',
    path: '/cadastro/produtos-conta/$productId/envolvidos',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastroProdutosCreditoProductIdIndexRoute =
  AppCadastroProdutosCreditoProductIdIndexRouteImport.update({
    id: '/cadastro/produtos-credito/$productId/',
    path: '/cadastro/produtos-credito/$productId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastroProdutosCreditoProductIdCustoDeEmissaoRoute =
  AppCadastroProdutosCreditoProductIdCustoDeEmissaoRouteImport.update({
    id: '/cadastro/produtos-credito/$productId/custo-de-emissao',
    path: '/cadastro/produtos-credito/$productId/custo-de-emissao',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastroProdutosCreditoProductIdDocumentosRoute =
  AppCadastroProdutosCreditoProductIdDocumentosRouteImport.update({
    id: '/cadastro/produtos-credito/$productId/documentos',
    path: '/cadastro/produtos-credito/$productId/documentos',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastroProdutosCreditoProductIdDocumentosParaAssinaturaRoute =
  AppCadastroProdutosCreditoProductIdDocumentosParaAssinaturaRouteImport.update(
    {
      id: '/cadastro/produtos-credito/$productId/documentos-para-assinatura',
      path: '/cadastro/produtos-credito/$productId/documentos-para-assinatura',
      getParentRoute: () => AppRoute,
    } as any,
  )
const AppCadastroProdutosCreditoProductIdEnvolvidosRoute =
  AppCadastroProdutosCreditoProductIdEnvolvidosRouteImport.update({
    id: '/cadastro/produtos-credito/$productId/envolvidos',
    path: '/cadastro/produtos-credito/$productId/envolvidos',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastroProdutosCreditoProductIdOrgaoRoute =
  AppCadastroProdutosCreditoProductIdOrgaoRouteImport.update({
    id: '/cadastro/produtos-credito/$productId/orgao',
    path: '/cadastro/produtos-credito/$productId/orgao',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastroProdutosCreditoProductIdTemplatesRoute =
  AppCadastroProdutosCreditoProductIdTemplatesRouteImport.update({
    id: '/cadastro/produtos-credito/$productId/templates',
    path: '/cadastro/produtos-credito/$productId/templates',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastroRegrasDinamicasRuleIdIndexRoute =
  AppCadastroRegrasDinamicasRuleIdIndexRouteImport.update({
    id: '/cadastro/regras-dinamicas/$ruleId/',
    path: '/cadastro/regras-dinamicas/$ruleId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastroRegrasDinamicasSimularIndexRoute =
  AppCadastroRegrasDinamicasSimularIndexRouteImport.update({
    id: '/cadastro/regras-dinamicas/simular/',
    path: '/cadastro/regras-dinamicas/simular/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCcbCessoesBatchAssignmentIdIndexRoute =
  AppCcbCessoesBatchAssignmentIdIndexRouteImport.update({
    id: '/ccb/cessoes/$batchAssignmentId/',
    path: '/ccb/cessoes/$batchAssignmentId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCcbCessoesBatchAssignmentIdDocumentosRoute =
  AppCcbCessoesBatchAssignmentIdDocumentosRouteImport.update({
    id: '/ccb/cessoes/$batchAssignmentId/documentos',
    path: '/ccb/cessoes/$batchAssignmentId/documentos',
    getParentRoute: () => AppRoute,
  } as any)
const AppCcbCessoesBatchAssignmentIdHistoricoRoute =
  AppCcbCessoesBatchAssignmentIdHistoricoRouteImport.update({
    id: '/ccb/cessoes/$batchAssignmentId/historico',
    path: '/ccb/cessoes/$batchAssignmentId/historico',
    getParentRoute: () => AppRoute,
  } as any)
const AppCcbCessoesBatchAssignmentIdOperacoesRoute =
  AppCcbCessoesBatchAssignmentIdOperacoesRouteImport.update({
    id: '/ccb/cessoes/$batchAssignmentId/operacoes',
    path: '/ccb/cessoes/$batchAssignmentId/operacoes',
    getParentRoute: () => AppRoute,
  } as any)
const AppCcbCessoesBatchAssignmentIdParcelasRoute =
  AppCcbCessoesBatchAssignmentIdParcelasRouteImport.update({
    id: '/ccb/cessoes/$batchAssignmentId/parcelas',
    path: '/ccb/cessoes/$batchAssignmentId/parcelas',
    getParentRoute: () => AppRoute,
  } as any)
const AppCcbCessoesSubmissoesDimensaIndexRoute =
  AppCcbCessoesSubmissoesDimensaIndexRouteImport.update({
    id: '/ccb/cessoes/submissoes-dimensa/',
    path: '/ccb/cessoes/submissoes-dimensa/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCcbContratarConsignadoInssIndexRoute =
  AppCcbContratarConsignadoInssIndexRouteImport.update({
    id: '/consignado-inss/',
    path: '/consignado-inss/',
    getParentRoute: () => AppCcbContratarRouteRoute,
  } as any)
const AppCcbContratarConsignadoPrivadoCdcIndexRoute =
  AppCcbContratarConsignadoPrivadoCdcIndexRouteImport.update({
    id: '/consignado-privado-cdc/',
    path: '/consignado-privado-cdc/',
    getParentRoute: () => AppCcbContratarRouteRoute,
  } as any)
const AppCcbContratarConsignadoPrivadoIndexRoute =
  AppCcbContratarConsignadoPrivadoIndexRouteImport.update({
    id: '/consignado-privado/',
    path: '/consignado-privado/',
    getParentRoute: () => AppCcbContratarRouteRoute,
  } as any)
const AppCcbContratarConsignadoPublicoIndexRoute =
  AppCcbContratarConsignadoPublicoIndexRouteImport.update({
    id: '/consignado-publico/',
    path: '/consignado-publico/',
    getParentRoute: () => AppCcbContratarRouteRoute,
  } as any)
const AppCcbContratarCreditoPessoalIndexRoute =
  AppCcbContratarCreditoPessoalIndexRouteImport.update({
    id: '/credito-pessoal/',
    path: '/credito-pessoal/',
    getParentRoute: () => AppCcbContratarRouteRoute,
  } as any)
const AppCcbContratarVeiculoIndexRoute =
  AppCcbContratarVeiculoIndexRouteImport.update({
    id: '/veiculo/',
    path: '/veiculo/',
    getParentRoute: () => AppCcbContratarRouteRoute,
  } as any)
const AppChatbotIdAtendimentoIndexRoute =
  AppChatbotIdAtendimentoIndexRouteImport.update({
    id: '/chatbot/$id/atendimento/',
    path: '/chatbot/$id/atendimento/',
    getParentRoute: () => AppRoute,
  } as any)
const AppConcilicaoFgtsCalcularLiquidacaoAntecipadaIndexRoute =
  AppConcilicaoFgtsCalcularLiquidacaoAntecipadaIndexRouteImport.update({
    id: '/concilicao/fgts/calcular-liquidacao-antecipada/',
    path: '/concilicao/fgts/calcular-liquidacao-antecipada/',
    getParentRoute: () => AppRoute,
  } as any)
const AppConcilicaoFgtsGerarArquivoLiquidacaoCaixaIndexRoute =
  AppConcilicaoFgtsGerarArquivoLiquidacaoCaixaIndexRouteImport.update({
    id: '/concilicao/fgts/gerar-arquivo-liquidacao-caixa/',
    path: '/concilicao/fgts/gerar-arquivo-liquidacao-caixa/',
    getParentRoute: () => AppRoute,
  } as any)
const AppConcilicaoFgtsSiapeIndexRoute =
  AppConcilicaoFgtsSiapeIndexRouteImport.update({
    id: '/concilicao/fgts/siape/',
    path: '/concilicao/fgts/siape/',
    getParentRoute: () => AppRoute,
  } as any)
const AppContasDigitaisContasBankAccountIdIndexRoute =
  AppContasDigitaisContasBankAccountIdIndexRouteImport.update({
    id: '/contas-digitais/contas/$bankAccountId/',
    path: '/contas-digitais/contas/$bankAccountId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppContasDigitaisContasBankAccountIdTabRoute =
  AppContasDigitaisContasBankAccountIdTabRouteImport.update({
    id: '/contas-digitais/contas/$bankAccountId/$tab',
    path: '/contas-digitais/contas/$bankAccountId/$tab',
    getParentRoute: () => AppRoute,
  } as any)
const AppContasDigitaisGestaoSpiConsultasIndexRoute =
  AppContasDigitaisGestaoSpiConsultasIndexRouteImport.update({
    id: '/contas-digitais/gestao-spi/consultas/',
    path: '/contas-digitais/gestao-spi/consultas/',
    getParentRoute: () => AppRoute,
  } as any)
const AppContasDigitaisSolicitacoesBankAccountIdIndexRoute =
  AppContasDigitaisSolicitacoesBankAccountIdIndexRouteImport.update({
    id: '/contas-digitais/solicitacoes/$bankAccountId/',
    path: '/contas-digitais/solicitacoes/$bankAccountId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppContasDigitaisSolicitacoesBankAccountIdAcessosConcedidosRoute =
  AppContasDigitaisSolicitacoesBankAccountIdAcessosConcedidosRouteImport.update(
    {
      id: '/contas-digitais/solicitacoes/$bankAccountId/acessos-concedidos',
      path: '/contas-digitais/solicitacoes/$bankAccountId/acessos-concedidos',
      getParentRoute: () => AppRoute,
    } as any,
  )
const AppContasDigitaisSolicitacoesBankAccountIdDocumentosRoute =
  AppContasDigitaisSolicitacoesBankAccountIdDocumentosRouteImport.update({
    id: '/contas-digitais/solicitacoes/$bankAccountId/documentos',
    path: '/contas-digitais/solicitacoes/$bankAccountId/documentos',
    getParentRoute: () => AppRoute,
  } as any)
const AppContasDigitaisSolicitacoesBankAccountIdEnvolvidosRoute =
  AppContasDigitaisSolicitacoesBankAccountIdEnvolvidosRouteImport.update({
    id: '/contas-digitais/solicitacoes/$bankAccountId/envolvidos',
    path: '/contas-digitais/solicitacoes/$bankAccountId/envolvidos',
    getParentRoute: () => AppRoute,
  } as any)
const AppContasDigitaisSolicitacoesBankAccountIdHistoricoRoute =
  AppContasDigitaisSolicitacoesBankAccountIdHistoricoRouteImport.update({
    id: '/contas-digitais/solicitacoes/$bankAccountId/historico',
    path: '/contas-digitais/solicitacoes/$bankAccountId/historico',
    getParentRoute: () => AppRoute,
  } as any)
const AppContasDigitaisSolicitacoesBankAccountIdKycRoute =
  AppContasDigitaisSolicitacoesBankAccountIdKycRouteImport.update({
    id: '/contas-digitais/solicitacoes/$bankAccountId/kyc',
    path: '/contas-digitais/solicitacoes/$bankAccountId/kyc',
    getParentRoute: () => AppRoute,
  } as any)
const AppContasDigitaisSplitAutomaticoOperationIdIndexRoute =
  AppContasDigitaisSplitAutomaticoOperationIdIndexRouteImport.update({
    id: '/contas-digitais/split-automatico/$operationId/',
    path: '/contas-digitais/split-automatico/$operationId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppContasDigitaisSplitAutomaticoOperationIdDetalhesRoute =
  AppContasDigitaisSplitAutomaticoOperationIdDetalhesRouteImport.update({
    id: '/contas-digitais/split-automatico/$operationId/detalhes',
    path: '/contas-digitais/split-automatico/$operationId/detalhes',
    getParentRoute: () => AppRoute,
  } as any)
const AppGestaoCarteiraCarteirasWalletIdIndexRoute =
  AppGestaoCarteiraCarteirasWalletIdIndexRouteImport.update({
    id: '/gestao-carteira/carteiras/$walletId/',
    path: '/gestao-carteira/carteiras/$walletId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppGestaoCarteiraCarteirasWalletIdArquivosRemessaRoute =
  AppGestaoCarteiraCarteirasWalletIdArquivosRemessaRouteImport.update({
    id: '/gestao-carteira/carteiras/$walletId/arquivos-remessa',
    path: '/gestao-carteira/carteiras/$walletId/arquivos-remessa',
    getParentRoute: () => AppRoute,
  } as any)
const AppGestaoCarteiraCarteirasWalletIdArquivosRetornoRoute =
  AppGestaoCarteiraCarteirasWalletIdArquivosRetornoRouteImport.update({
    id: '/gestao-carteira/carteiras/$walletId/arquivos-retorno',
    path: '/gestao-carteira/carteiras/$walletId/arquivos-retorno',
    getParentRoute: () => AppRoute,
  } as any)
const AppGestaoCarteiraCarteirasWalletIdTarifasConvenioRoute =
  AppGestaoCarteiraCarteirasWalletIdTarifasConvenioRouteImport.update({
    id: '/gestao-carteira/carteiras/$walletId/tarifas-convenio',
    path: '/gestao-carteira/carteiras/$walletId/tarifas-convenio',
    getParentRoute: () => AppRoute,
  } as any)
const AppGestaoCarteiraConciliacaoDataprevIndexRoute =
  AppGestaoCarteiraConciliacaoDataprevIndexRouteImport.update({
    id: '/gestao-carteira/conciliacao/dataprev/',
    path: '/gestao-carteira/conciliacao/dataprev/',
    getParentRoute: () => AppRoute,
  } as any)
const AppGestaoCarteiraConciliacaoDataprevNovaConciliacaoRoute =
  AppGestaoCarteiraConciliacaoDataprevNovaConciliacaoRouteImport.update({
    id: '/gestao-carteira/conciliacao/dataprev/nova-conciliacao',
    path: '/gestao-carteira/conciliacao/dataprev/nova-conciliacao',
    getParentRoute: () => AppRoute,
  } as any)
const AppGestaoCarteiraRecuperacaoAcordosIndexRoute =
  AppGestaoCarteiraRecuperacaoAcordosIndexRouteImport.update({
    id: '/gestao-carteira/recuperacao/acordos/',
    path: '/gestao-carteira/recuperacao/acordos/',
    getParentRoute: () => AppRoute,
  } as any)
const AppGestaoCarteiraRecuperacaoAcordosAgreementIdRoute =
  AppGestaoCarteiraRecuperacaoAcordosAgreementIdRouteImport.update({
    id: '/gestao-carteira/recuperacao/acordos/$agreementId',
    path: '/gestao-carteira/recuperacao/acordos/$agreementId',
    getParentRoute: () => AppRoute,
  } as any)
const AppGestaoCarteiraRecuperacaoDevedorInstallmentIdRoute =
  AppGestaoCarteiraRecuperacaoDevedorInstallmentIdRouteImport.update({
    id: '/gestao-carteira/recuperacao/devedor/$installmentId',
    path: '/gestao-carteira/recuperacao/devedor/$installmentId',
    getParentRoute: () => AppRoute,
  } as any)
const AppParceirosSolicitacoesIdIndexRoute =
  AppParceirosSolicitacoesIdIndexRouteImport.update({
    id: '/parceiros/solicitacoes/$id/',
    path: '/parceiros/solicitacoes/$id/',
    getParentRoute: () => AppRoute,
  } as any)
const AppPessoasFisicasTodasPersonIdIndexRoute =
  AppPessoasFisicasTodasPersonIdIndexRouteImport.update({
    id: '/pessoas-fisicas/todas/$personId/',
    path: '/pessoas-fisicas/todas/$personId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppPessoasFisicasTodasPersonIdComplianceRoute =
  AppPessoasFisicasTodasPersonIdComplianceRouteImport.update({
    id: '/pessoas-fisicas/todas/$personId/compliance',
    path: '/pessoas-fisicas/todas/$personId/compliance',
    getParentRoute: () => AppRoute,
  } as any)
const AppPessoasFisicasTodasPersonIdCreditoRoute =
  AppPessoasFisicasTodasPersonIdCreditoRouteImport.update({
    id: '/pessoas-fisicas/todas/$personId/credito',
    path: '/pessoas-fisicas/todas/$personId/credito',
    getParentRoute: () => AppRoute,
  } as any)
const AppPessoasFisicasTodasPersonIdDadosBancariosRoute =
  AppPessoasFisicasTodasPersonIdDadosBancariosRouteImport.update({
    id: '/pessoas-fisicas/todas/$personId/dados-bancarios',
    path: '/pessoas-fisicas/todas/$personId/dados-bancarios',
    getParentRoute: () => AppRoute,
  } as any)
const AppPessoasFisicasTodasPersonIdDocumentosRoute =
  AppPessoasFisicasTodasPersonIdDocumentosRouteImport.update({
    id: '/pessoas-fisicas/todas/$personId/documentos',
    path: '/pessoas-fisicas/todas/$personId/documentos',
    getParentRoute: () => AppRoute,
  } as any)
const AppPessoasFisicasTodasPersonIdOperacoesRoute =
  AppPessoasFisicasTodasPersonIdOperacoesRouteImport.update({
    id: '/pessoas-fisicas/todas/$personId/operacoes',
    path: '/pessoas-fisicas/todas/$personId/operacoes',
    getParentRoute: () => AppRoute,
  } as any)
const AppPessoasJuridicasTodasPersonIdIndexRoute =
  AppPessoasJuridicasTodasPersonIdIndexRouteImport.update({
    id: '/pessoas-juridicas/todas/$personId/',
    path: '/pessoas-juridicas/todas/$personId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppPessoasJuridicasTodasPersonIdComplianceRoute =
  AppPessoasJuridicasTodasPersonIdComplianceRouteImport.update({
    id: '/pessoas-juridicas/todas/$personId/compliance',
    path: '/pessoas-juridicas/todas/$personId/compliance',
    getParentRoute: () => AppRoute,
  } as any)
const AppPessoasJuridicasTodasPersonIdCreditoRoute =
  AppPessoasJuridicasTodasPersonIdCreditoRouteImport.update({
    id: '/pessoas-juridicas/todas/$personId/credito',
    path: '/pessoas-juridicas/todas/$personId/credito',
    getParentRoute: () => AppRoute,
  } as any)
const AppPessoasJuridicasTodasPersonIdDadosBancariosRoute =
  AppPessoasJuridicasTodasPersonIdDadosBancariosRouteImport.update({
    id: '/pessoas-juridicas/todas/$personId/dados-bancarios',
    path: '/pessoas-juridicas/todas/$personId/dados-bancarios',
    getParentRoute: () => AppRoute,
  } as any)
const AppPessoasJuridicasTodasPersonIdDocumentosRoute =
  AppPessoasJuridicasTodasPersonIdDocumentosRouteImport.update({
    id: '/pessoas-juridicas/todas/$personId/documentos',
    path: '/pessoas-juridicas/todas/$personId/documentos',
    getParentRoute: () => AppRoute,
  } as any)
const AppPessoasJuridicasTodasPersonIdOperacoesRoute =
  AppPessoasJuridicasTodasPersonIdOperacoesRouteImport.update({
    id: '/pessoas-juridicas/todas/$personId/operacoes',
    path: '/pessoas-juridicas/todas/$personId/operacoes',
    getParentRoute: () => AppRoute,
  } as any)
const AppPessoasJuridicasTodasPersonIdSignatariosRoute =
  AppPessoasJuridicasTodasPersonIdSignatariosRouteImport.update({
    id: '/pessoas-juridicas/todas/$personId/signatarios',
    path: '/pessoas-juridicas/todas/$personId/signatarios',
    getParentRoute: () => AppRoute,
  } as any)
const AppSegurancaGruposGroupIdIndexRoute =
  AppSegurancaGruposGroupIdIndexRouteImport.update({
    id: '/seguranca/grupos/$groupId/',
    path: '/seguranca/grupos/$groupId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppSegurancaGruposGroupIdMembrosRoute =
  AppSegurancaGruposGroupIdMembrosRouteImport.update({
    id: '/seguranca/grupos/$groupId/membros',
    path: '/seguranca/grupos/$groupId/membros',
    getParentRoute: () => AppRoute,
  } as any)
const AppSegurancaGruposGroupIdPermissoesRoute =
  AppSegurancaGruposGroupIdPermissoesRouteImport.update({
    id: '/seguranca/grupos/$groupId/permissoes',
    path: '/seguranca/grupos/$groupId/permissoes',
    getParentRoute: () => AppRoute,
  } as any)
const AppSegurancaRecursosCorrespondenteIdIndexRoute =
  AppSegurancaRecursosCorrespondenteIdIndexRouteImport.update({
    id: '/seguranca/recursos-correspondente/$id/',
    path: '/seguranca/recursos-correspondente/$id/',
    getParentRoute: () => AppRoute,
  } as any)
const AppSegurancaUsuariosAplicacaoAplicacaoIdIndexRoute =
  AppSegurancaUsuariosAplicacaoAplicacaoIdIndexRouteImport.update({
    id: '/seguranca/usuarios-aplicacao/$aplicacaoId/',
    path: '/seguranca/usuarios-aplicacao/$aplicacaoId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppSegurancaUsuariosUserIdIndexRoute =
  AppSegurancaUsuariosUserIdIndexRouteImport.update({
    id: '/seguranca/usuarios/$userId/',
    path: '/seguranca/usuarios/$userId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppSegurancaUsuariosUserIdGruposRoute =
  AppSegurancaUsuariosUserIdGruposRouteImport.update({
    id: '/seguranca/usuarios/$userId/grupos',
    path: '/seguranca/usuarios/$userId/grupos',
    getParentRoute: () => AppRoute,
  } as any)
const AppSegurancaUsuariosUserIdPermissoesRoute =
  AppSegurancaUsuariosUserIdPermissoesRouteImport.update({
    id: '/seguranca/usuarios/$userId/permissoes',
    path: '/seguranca/usuarios/$userId/permissoes',
    getParentRoute: () => AppRoute,
  } as any)
const AppCadastroConfiguracaoRegrasRuleIdProdutosIndexRoute =
  AppCadastroConfiguracaoRegrasRuleIdProdutosIndexRouteImport.update({
    id: '/cadastro/configuracao-regras/$ruleId/produtos/',
    path: '/cadastro/configuracao-regras/$ruleId/produtos/',
    getParentRoute: () => AppRoute,
  } as any)
const AppCcbContratarConsignadoInssNovoIndexRoute =
  AppCcbContratarConsignadoInssNovoIndexRouteImport.update({
    id: '/consignado-inss/novo/',
    path: '/consignado-inss/novo/',
    getParentRoute: () => AppCcbContratarRouteRoute,
  } as any)
const AppCcbContratarConsignadoInssRefinanciamentoIndexRoute =
  AppCcbContratarConsignadoInssRefinanciamentoIndexRouteImport.update({
    id: '/consignado-inss/refinanciamento/',
    path: '/consignado-inss/refinanciamento/',
    getParentRoute: () => AppCcbContratarRouteRoute,
  } as any)
const AppCcbContratarConsignadoPrivadoNovoIndexRoute =
  AppCcbContratarConsignadoPrivadoNovoIndexRouteImport.update({
    id: '/consignado-privado/novo/',
    path: '/consignado-privado/novo/',
    getParentRoute: () => AppCcbContratarRouteRoute,
  } as any)
const AppCcbContratarConsignadoPrivadoRefinanciamentoIndexRoute =
  AppCcbContratarConsignadoPrivadoRefinanciamentoIndexRouteImport.update({
    id: '/consignado-privado/refinanciamento/',
    path: '/consignado-privado/refinanciamento/',
    getParentRoute: () => AppCcbContratarRouteRoute,
  } as any)
const AppCcbContratarConsignadoPublicoNovoCompraDeDividaIndexRoute =
  AppCcbContratarConsignadoPublicoNovoCompraDeDividaIndexRouteImport.update({
    id: '/consignado-publico/novo-compra-de-divida/',
    path: '/consignado-publico/novo-compra-de-divida/',
    getParentRoute: () => AppCcbContratarRouteRoute,
  } as any)
const AppCcbContratarConsignadoPublicoNovoIndexRoute =
  AppCcbContratarConsignadoPublicoNovoIndexRouteImport.update({
    id: '/consignado-publico/novo/',
    path: '/consignado-publico/novo/',
    getParentRoute: () => AppCcbContratarRouteRoute,
  } as any)
const AppCcbContratarConsignadoPublicoRefinanciamentoIndexRoute =
  AppCcbContratarConsignadoPublicoRefinanciamentoIndexRouteImport.update({
    id: '/consignado-publico/refinanciamento/',
    path: '/consignado-publico/refinanciamento/',
    getParentRoute: () => AppCcbContratarRouteRoute,
  } as any)
const AppCcbContratarVeiculoCarEquityIndexRoute =
  AppCcbContratarVeiculoCarEquityIndexRouteImport.update({
    id: '/veiculo/car-equity/',
    path: '/veiculo/car-equity/',
    getParentRoute: () => AppCcbContratarRouteRoute,
  } as any)
const AppCcbContratarVeiculoFinanciamentoIndexRoute =
  AppCcbContratarVeiculoFinanciamentoIndexRouteImport.update({
    id: '/veiculo/financiamento/',
    path: '/veiculo/financiamento/',
    getParentRoute: () => AppCcbContratarRouteRoute,
  } as any)
const AppContasDigitaisContasBankAccountIdPixGerenciarChavesRoute =
  AppContasDigitaisContasBankAccountIdPixGerenciarChavesRouteImport.update({
    id: '/contas-digitais/contas/$bankAccountId/pix/gerenciar-chaves',
    path: '/contas-digitais/contas/$bankAccountId/pix/gerenciar-chaves',
    getParentRoute: () => AppRoute,
  } as any)
const AppContasDigitaisContasBankAccountIdVisualizarIndexRoute =
  AppContasDigitaisContasBankAccountIdVisualizarIndexRouteImport.update({
    id: '/contas-digitais/contas/$bankAccountId/visualizar/',
    path: '/contas-digitais/contas/$bankAccountId/visualizar/',
    getParentRoute: () => AppRoute,
  } as any)
const AppContasDigitaisContasBankAccountIdVisualizarTabRoute =
  AppContasDigitaisContasBankAccountIdVisualizarTabRouteImport.update({
    id: '/contas-digitais/contas/$bankAccountId/visualizar/$tab',
    path: '/contas-digitais/contas/$bankAccountId/visualizar/$tab',
    getParentRoute: () => AppRoute,
  } as any)
const AppGestaoCarteiraCarteirasArquivosFileIdRemessaRoute =
  AppGestaoCarteiraCarteirasArquivosFileIdRemessaRouteImport.update({
    id: '/gestao-carteira/carteiras/arquivos/$fileId/remessa',
    path: '/gestao-carteira/carteiras/arquivos/$fileId/remessa',
    getParentRoute: () => AppRoute,
  } as any)
const AppGestaoCarteiraCarteirasArquivosFileIdRetornoRoute =
  AppGestaoCarteiraCarteirasArquivosFileIdRetornoRouteImport.update({
    id: '/gestao-carteira/carteiras/arquivos/$fileId/retorno',
    path: '/gestao-carteira/carteiras/arquivos/$fileId/retorno',
    getParentRoute: () => AppRoute,
  } as any)
const AppGestaoCarteiraConciliacaoDataprevConciliationIdIndexRoute =
  AppGestaoCarteiraConciliacaoDataprevConciliationIdIndexRouteImport.update({
    id: '/gestao-carteira/conciliacao/dataprev/$conciliationId/',
    path: '/gestao-carteira/conciliacao/dataprev/$conciliationId/',
    getParentRoute: () => AppRoute,
  } as any)
const AppGestaoCarteiraConciliacaoDataprevConciliationIdHistoricoRoute =
  AppGestaoCarteiraConciliacaoDataprevConciliationIdHistoricoRouteImport.update(
    {
      id: '/gestao-carteira/conciliacao/dataprev/$conciliationId/historico',
      path: '/gestao-carteira/conciliacao/dataprev/$conciliationId/historico',
      getParentRoute: () => AppRoute,
    } as any,
  )
const AppGestaoCarteiraConciliacaoDataprevConciliationIdInconsistenciasRoute =
  AppGestaoCarteiraConciliacaoDataprevConciliationIdInconsistenciasRouteImport.update(
    {
      id: '/gestao-carteira/conciliacao/dataprev/$conciliationId/inconsistencias',
      path: '/gestao-carteira/conciliacao/dataprev/$conciliationId/inconsistencias',
      getParentRoute: () => AppRoute,
    } as any,
  )
const AppGestaoCarteiraConciliacaoDataprevConciliationIdLinhaDeRepasseRoute =
  AppGestaoCarteiraConciliacaoDataprevConciliationIdLinhaDeRepasseRouteImport.update(
    {
      id: '/gestao-carteira/conciliacao/dataprev/$conciliationId/linha-de-repasse',
      path: '/gestao-carteira/conciliacao/dataprev/$conciliationId/linha-de-repasse',
      getParentRoute: () => AppRoute,
    } as any,
  )
const AppGestaoCarteiraConciliacaoDataprevConciliationIdNaoEncerradasRoute =
  AppGestaoCarteiraConciliacaoDataprevConciliationIdNaoEncerradasRouteImport.update(
    {
      id: '/gestao-carteira/conciliacao/dataprev/$conciliationId/nao-encerradas',
      path: '/gestao-carteira/conciliacao/dataprev/$conciliationId/nao-encerradas',
      getParentRoute: () => AppRoute,
    } as any,
  )
const AppGestaoCarteiraConciliacaoDataprevBolsaoIndexRoute =
  AppGestaoCarteiraConciliacaoDataprevBolsaoIndexRouteImport.update({
    id: '/gestao-carteira/conciliacao/dataprev/bolsao/',
    path: '/gestao-carteira/conciliacao/dataprev/bolsao/',
    getParentRoute: () => AppRoute,
  } as any)
const AppGestaoCarteiraConciliacaoDataprevBolsaoIdRoute =
  AppGestaoCarteiraConciliacaoDataprevBolsaoIdRouteImport.update({
    id: '/gestao-carteira/conciliacao/dataprev/bolsao/$id',
    path: '/gestao-carteira/conciliacao/dataprev/bolsao/$id',
    getParentRoute: () => AppRoute,
  } as any)
const AppContasDigitaisContasBankAccountIdPixPixAutomaticoIndexRoute =
  AppContasDigitaisContasBankAccountIdPixPixAutomaticoIndexRouteImport.update({
    id: '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/',
    path: '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/',
    getParentRoute: () => AppRoute,
  } as any)
const AppContasDigitaisContasBankAccountIdPixPixAutomaticoAtivasRoute =
  AppContasDigitaisContasBankAccountIdPixPixAutomaticoAtivasRouteImport.update({
    id: '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/ativas',
    path: '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/ativas',
    getParentRoute: () => AppRoute,
  } as any)
const AppContasDigitaisContasBankAccountIdPixPixAutomaticoHistoricoRoute =
  AppContasDigitaisContasBankAccountIdPixPixAutomaticoHistoricoRouteImport.update(
    {
      id: '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/historico',
      path: '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/historico',
      getParentRoute: () => AppRoute,
    } as any,
  )
const AppContasDigitaisContasBankAccountIdPixPixAutomaticoPendentesRoute =
  AppContasDigitaisContasBankAccountIdPixPixAutomaticoPendentesRouteImport.update(
    {
      id: '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/pendentes',
      path: '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/pendentes',
      getParentRoute: () => AppRoute,
    } as any,
  )
const AppContasDigitaisContasBankAccountIdPixPixMedIndexRoute =
  AppContasDigitaisContasBankAccountIdPixPixMedIndexRouteImport.update({
    id: '/contas-digitais/contas/$bankAccountId/pix/pix-med/',
    path: '/contas-digitais/contas/$bankAccountId/pix/pix-med/',
    getParentRoute: () => AppRoute,
  } as any)
const AppContasDigitaisContasBankAccountIdPixPixMedConsultarRoute =
  AppContasDigitaisContasBankAccountIdPixPixMedConsultarRouteImport.update({
    id: '/contas-digitais/contas/$bankAccountId/pix/pix-med/consultar',
    path: '/contas-digitais/contas/$bankAccountId/pix/pix-med/consultar',
    getParentRoute: () => AppRoute,
  } as any)
const AppContasDigitaisContasBankAccountIdPixPixMedContestarRoute =
  AppContasDigitaisContasBankAccountIdPixPixMedContestarRouteImport.update({
    id: '/contas-digitais/contas/$bankAccountId/pix/pix-med/contestar',
    path: '/contas-digitais/contas/$bankAccountId/pix/pix-med/contestar',
    getParentRoute: () => AppRoute,
  } as any)
const AppContasDigitaisContasBankAccountIdPixPixMedInformacoesRoute =
  AppContasDigitaisContasBankAccountIdPixPixMedInformacoesRouteImport.update({
    id: '/contas-digitais/contas/$bankAccountId/pix/pix-med/informacoes',
    path: '/contas-digitais/contas/$bankAccountId/pix/pix-med/informacoes',
    getParentRoute: () => AppRoute,
  } as any)
const AppContasDigitaisContasBankAccountIdPixPixAutomaticoAgendadosIndexRoute =
  AppContasDigitaisContasBankAccountIdPixPixAutomaticoAgendadosIndexRouteImport.update(
    {
      id: '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados/',
      path: '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados/',
      getParentRoute: () => AppRoute,
    } as any,
  )
const AppContasDigitaisContasBankAccountIdPixPixAutomaticoAgendadosRealizadosRoute =
  AppContasDigitaisContasBankAccountIdPixPixAutomaticoAgendadosRealizadosRouteImport.update(
    {
      id: '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados/realizados',
      path: '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados/realizados',
      getParentRoute: () => AppRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/login': typeof LoginRouteRouteWithChildren
  '/': typeof AppIndexRoute
  '/meu-perfil': typeof AppMeuPerfilRouteRouteWithChildren
  '/dev/credito': typeof DevCreditoRouteRouteWithChildren
  '/em-construcao': typeof AppEmConstrucaoRoute
  '/legado-indisponivel': typeof AppLegadoIndisponivelRoute
  '/dev/blocks': typeof DevBlocksRoute
  '/dev/cessionarios': typeof DevCessionariosRoute
  '/dev/forms': typeof DevFormsRoute
  '/dev/patterns': typeof DevPatternsRoute
  '/dev/produtos-cobranca': typeof DevProdutosCobrancaRoute
  '/dev/record': typeof DevRecordRoute
  '/dev/regua-cobranca': typeof DevReguaCobrancaRoute
  '/dev/shell': typeof DevShellRoute
  '/dev/ui': typeof DevUiRoute
  '/login/alterar-senha': typeof LoginAlterarSenhaRoute
  '/login/confirmar-email': typeof LoginConfirmarEmailRoute
  '/login/confirmar-senha': typeof LoginConfirmarSenhaRoute
  '/login/logout': typeof LoginLogoutRoute
  '/login/recuperar-senha': typeof LoginRecuperarSenhaRoute
  '/login/': typeof LoginIndexRoute
  '/ccb/contratar': typeof AppCcbContratarRouteRouteWithChildren
  '/dev/credito/$creditNoteId': typeof DevCreditoCreditNoteIdRoute
  '/login/mfa/setup': typeof LoginMfaSetupRoute
  '/aprovacoes/': typeof AppAprovacoesIndexRoute
  '/chatbot/': typeof AppChatbotIndexRoute
  '/concilicao/': typeof AppConcilicaoIndexRoute
  '/dashboard/': typeof AppDashboardIndexRoute
  '/gestao-carteira/': typeof AppGestaoCarteiraIndexRoute
  '/meu-perfil/': typeof AppMeuPerfilIndexRoute
  '/pessoas-fisicas/': typeof AppPessoasFisicasIndexRoute
  '/pessoas-juridicas/': typeof AppPessoasJuridicasIndexRoute
  '/seguranca/': typeof AppSegurancaIndexRoute
  '/dev/boletos/': typeof DevBoletosIndexRoute
  '/dev/carteiras/': typeof DevCarteirasIndexRoute
  '/dev/central-regras/': typeof DevCentralRegrasIndexRoute
  '/dev/cobrancas/': typeof DevCobrancasIndexRoute
  '/dev/conciliacao/': typeof DevConciliacaoIndexRoute
  '/dev/convenios/': typeof DevConveniosIndexRoute
  '/dev/credito-excluidos/': typeof DevCreditoExcluidosIndexRoute
  '/dev/credito/': typeof DevCreditoIndexRoute
  '/dev/dataprev/': typeof DevDataprevIndexRoute
  '/dev/fluxo/': typeof DevFluxoIndexRoute
  '/dev/grupos/': typeof DevGruposIndexRoute
  '/dev/meu-perfil/': typeof DevMeuPerfilIndexRoute
  '/dev/permissoes-correspondente/': typeof DevPermissoesCorrespondenteIndexRoute
  '/dev/pessoas/': typeof DevPessoasIndexRoute
  '/dev/pix-med-admin/': typeof DevPixMedAdminIndexRoute
  '/dev/produtos-conta/': typeof DevProdutosContaIndexRoute
  '/dev/produtos-credito/': typeof DevProdutosCreditoIndexRoute
  '/dev/produtos-liquidacao-automatica/': typeof DevProdutosLiquidacaoAutomaticaIndexRoute
  '/dev/regras-dinamicas/': typeof DevRegrasDinamicasIndexRoute
  '/dev/regua-comunicacao/': typeof DevReguaComunicacaoIndexRoute
  '/dev/solicitacoes-parceiros/': typeof DevSolicitacoesParceirosIndexRoute
  '/dev/usuarios-aplicacao/': typeof DevUsuariosAplicacaoIndexRoute
  '/dev/usuarios/': typeof DevUsuariosIndexRoute
  '/login/mfa/': typeof LoginMfaIndexRoute
  '/aprovacoes/gestao-aprovacoes/internet-banking': typeof AppAprovacoesGestaoAprovacoesInternetBankingRoute
  '/aprovacoes/gestao-aprovacoes/operacoes': typeof AppAprovacoesGestaoAprovacoesOperacoesRoute
  '/aprovacoes/gestao-aprovacoes/operadores': typeof AppAprovacoesGestaoAprovacoesOperadoresRoute
  '/aprovacoes/gestao-aprovacoes/solicitacoes': typeof AppAprovacoesGestaoAprovacoesSolicitacoesRoute
  '/ccb/cessoes/nova': typeof AppCcbCessoesNovaRoute
  '/ccb/contratar/$': typeof AppCcbContratarSplatRoute
  '/ccb/operacoes/$creditNoteId': typeof AppCcbOperacoesCreditNoteIdRoute
  '/ccb/operacoes/nova': typeof AppCcbOperacoesNovaRoute
  '/gestao-carteira/cobrancas/$billingId': typeof AppGestaoCarteiraCobrancasBillingIdRoute
  '/gestao-carteira/parcelamentos/$installmentId': typeof AppGestaoCarteiraParcelamentosInstallmentIdRoute
  '/gestao-carteira/recuperacao/fila': typeof AppGestaoCarteiraRecuperacaoFilaRoute
  '/aprovacoes/gestao-aprovacoes/': typeof AppAprovacoesGestaoAprovacoesIndexRoute
  '/cadastro/configuracao-regras/': typeof AppCadastroConfiguracaoRegrasIndexRoute
  '/cadastro/convenios/': typeof AppCadastroConveniosIndexRoute
  '/cadastro/fundos/': typeof AppCadastroFundosIndexRoute
  '/cadastro/gestao/': typeof AppCadastroGestaoIndexRoute
  '/cadastro/produtos-conta/': typeof AppCadastroProdutosContaIndexRoute
  '/cadastro/produtos-credito/': typeof AppCadastroProdutosCreditoIndexRoute
  '/cadastro/produtos-liquidacao-automatica/': typeof AppCadastroProdutosLiquidacaoAutomaticaIndexRoute
  '/cadastro/regras-dinamicas/': typeof AppCadastroRegrasDinamicasIndexRoute
  '/ccb/cessoes/': typeof AppCcbCessoesIndexRoute
  '/ccb/contratar/': typeof AppCcbContratarIndexRoute
  '/ccb/criar-cpf-teste/': typeof AppCcbCriarCpfTesteIndexRoute
  '/ccb/desconto/': typeof AppCcbDescontoIndexRoute
  '/ccb/excluidos/': typeof AppCcbExcluidosIndexRoute
  '/ccb/excluir-autorizacao/': typeof AppCcbExcluirAutorizacaoIndexRoute
  '/ccb/gestao-autorizacoes/': typeof AppCcbGestaoAutorizacoesIndexRoute
  '/ccb/operacoes/': typeof AppCcbOperacoesIndexRoute
  '/ccb/simular/': typeof AppCcbSimularIndexRoute
  '/chatbot/$id/': typeof AppChatbotIdIndexRoute
  '/chatbot/relatorios/': typeof AppChatbotRelatoriosIndexRoute
  '/concilicao/fgts/': typeof AppConcilicaoFgtsIndexRoute
  '/contas-digitais/contas/': typeof AppContasDigitaisContasIndexRoute
  '/contas-digitais/gestao-spi/': typeof AppContasDigitaisGestaoSpiIndexRoute
  '/contas-digitais/pix-med-admin/': typeof AppContasDigitaisPixMedAdminIndexRoute
  '/contas-digitais/solicitacoes/': typeof AppContasDigitaisSolicitacoesIndexRoute
  '/contas-digitais/split-automatico/': typeof AppContasDigitaisSplitAutomaticoIndexRoute
  '/gestao-carteira/carteiras/': typeof AppGestaoCarteiraCarteirasIndexRoute
  '/gestao-carteira/cobrancas/': typeof AppGestaoCarteiraCobrancasIndexRoute
  '/gestao-carteira/conciliacao/': typeof AppGestaoCarteiraConciliacaoIndexRoute
  '/gestao-carteira/dashboard/': typeof AppGestaoCarteiraDashboardIndexRoute
  '/gestao-carteira/execucao-garantias/': typeof AppGestaoCarteiraExecucaoGarantiasIndexRoute
  '/gestao-carteira/parametros/': typeof AppGestaoCarteiraParametrosIndexRoute
  '/gestao-carteira/parcelamentos/': typeof AppGestaoCarteiraParcelamentosIndexRoute
  '/gestao-carteira/recuperacao/': typeof AppGestaoCarteiraRecuperacaoIndexRoute
  '/gestao-carteira/regua/': typeof AppGestaoCarteiraReguaIndexRoute
  '/meu-perfil/configuracoes/': typeof AppMeuPerfilConfiguracoesIndexRoute
  '/meu-perfil/permissoes-efetivas/': typeof AppMeuPerfilPermissoesEfetivasIndexRoute
  '/parceiros/solicitacoes/': typeof AppParceirosSolicitacoesIndexRoute
  '/pessoas-fisicas/pendentes/': typeof AppPessoasFisicasPendentesIndexRoute
  '/pessoas-fisicas/todas/': typeof AppPessoasFisicasTodasIndexRoute
  '/pessoas-juridicas/pendentes/': typeof AppPessoasJuridicasPendentesIndexRoute
  '/pessoas-juridicas/todas/': typeof AppPessoasJuridicasTodasIndexRoute
  '/seguranca/grupos/': typeof AppSegurancaGruposIndexRoute
  '/seguranca/recursos-correspondente/': typeof AppSegurancaRecursosCorrespondenteIndexRoute
  '/seguranca/usuarios-aplicacao/': typeof AppSegurancaUsuariosAplicacaoIndexRoute
  '/seguranca/usuarios/': typeof AppSegurancaUsuariosIndexRoute
  '/cadastro/fundos/$fundId/cessoes': typeof AppCadastroFundosFundIdCessoesRoute
  '/cadastro/fundos/$fundId/documentos': typeof AppCadastroFundosFundIdDocumentosRoute
  '/cadastro/fundos/$fundId/envolvidos': typeof AppCadastroFundosFundIdEnvolvidosRoute
  '/cadastro/gestao/produtos-cobranca/parametros-custos': typeof AppCadastroGestaoProdutosCobrancaParametrosCustosRoute
  '/cadastro/produtos-conta/$productId/documentos': typeof AppCadastroProdutosContaProductIdDocumentosRoute
  '/cadastro/produtos-conta/$productId/envolvidos': typeof AppCadastroProdutosContaProductIdEnvolvidosRoute
  '/cadastro/produtos-credito/$productId/custo-de-emissao': typeof AppCadastroProdutosCreditoProductIdCustoDeEmissaoRoute
  '/cadastro/produtos-credito/$productId/documentos': typeof AppCadastroProdutosCreditoProductIdDocumentosRoute
  '/cadastro/produtos-credito/$productId/documentos-para-assinatura': typeof AppCadastroProdutosCreditoProductIdDocumentosParaAssinaturaRoute
  '/cadastro/produtos-credito/$productId/envolvidos': typeof AppCadastroProdutosCreditoProductIdEnvolvidosRoute
  '/cadastro/produtos-credito/$productId/orgao': typeof AppCadastroProdutosCreditoProductIdOrgaoRoute
  '/cadastro/produtos-credito/$productId/templates': typeof AppCadastroProdutosCreditoProductIdTemplatesRoute
  '/ccb/cessoes/$batchAssignmentId/documentos': typeof AppCcbCessoesBatchAssignmentIdDocumentosRoute
  '/ccb/cessoes/$batchAssignmentId/historico': typeof AppCcbCessoesBatchAssignmentIdHistoricoRoute
  '/ccb/cessoes/$batchAssignmentId/operacoes': typeof AppCcbCessoesBatchAssignmentIdOperacoesRoute
  '/ccb/cessoes/$batchAssignmentId/parcelas': typeof AppCcbCessoesBatchAssignmentIdParcelasRoute
  '/contas-digitais/contas/$bankAccountId/$tab': typeof AppContasDigitaisContasBankAccountIdTabRoute
  '/contas-digitais/solicitacoes/$bankAccountId/acessos-concedidos': typeof AppContasDigitaisSolicitacoesBankAccountIdAcessosConcedidosRoute
  '/contas-digitais/solicitacoes/$bankAccountId/documentos': typeof AppContasDigitaisSolicitacoesBankAccountIdDocumentosRoute
  '/contas-digitais/solicitacoes/$bankAccountId/envolvidos': typeof AppContasDigitaisSolicitacoesBankAccountIdEnvolvidosRoute
  '/contas-digitais/solicitacoes/$bankAccountId/historico': typeof AppContasDigitaisSolicitacoesBankAccountIdHistoricoRoute
  '/contas-digitais/solicitacoes/$bankAccountId/kyc': typeof AppContasDigitaisSolicitacoesBankAccountIdKycRoute
  '/contas-digitais/split-automatico/$operationId/detalhes': typeof AppContasDigitaisSplitAutomaticoOperationIdDetalhesRoute
  '/gestao-carteira/carteiras/$walletId/arquivos-remessa': typeof AppGestaoCarteiraCarteirasWalletIdArquivosRemessaRoute
  '/gestao-carteira/carteiras/$walletId/arquivos-retorno': typeof AppGestaoCarteiraCarteirasWalletIdArquivosRetornoRoute
  '/gestao-carteira/carteiras/$walletId/tarifas-convenio': typeof AppGestaoCarteiraCarteirasWalletIdTarifasConvenioRoute
  '/gestao-carteira/conciliacao/dataprev/nova-conciliacao': typeof AppGestaoCarteiraConciliacaoDataprevNovaConciliacaoRoute
  '/gestao-carteira/recuperacao/acordos/$agreementId': typeof AppGestaoCarteiraRecuperacaoAcordosAgreementIdRoute
  '/gestao-carteira/recuperacao/devedor/$installmentId': typeof AppGestaoCarteiraRecuperacaoDevedorInstallmentIdRoute
  '/pessoas-fisicas/todas/$personId/compliance': typeof AppPessoasFisicasTodasPersonIdComplianceRoute
  '/pessoas-fisicas/todas/$personId/credito': typeof AppPessoasFisicasTodasPersonIdCreditoRoute
  '/pessoas-fisicas/todas/$personId/dados-bancarios': typeof AppPessoasFisicasTodasPersonIdDadosBancariosRoute
  '/pessoas-fisicas/todas/$personId/documentos': typeof AppPessoasFisicasTodasPersonIdDocumentosRoute
  '/pessoas-fisicas/todas/$personId/operacoes': typeof AppPessoasFisicasTodasPersonIdOperacoesRoute
  '/pessoas-juridicas/todas/$personId/compliance': typeof AppPessoasJuridicasTodasPersonIdComplianceRoute
  '/pessoas-juridicas/todas/$personId/credito': typeof AppPessoasJuridicasTodasPersonIdCreditoRoute
  '/pessoas-juridicas/todas/$personId/dados-bancarios': typeof AppPessoasJuridicasTodasPersonIdDadosBancariosRoute
  '/pessoas-juridicas/todas/$personId/documentos': typeof AppPessoasJuridicasTodasPersonIdDocumentosRoute
  '/pessoas-juridicas/todas/$personId/operacoes': typeof AppPessoasJuridicasTodasPersonIdOperacoesRoute
  '/pessoas-juridicas/todas/$personId/signatarios': typeof AppPessoasJuridicasTodasPersonIdSignatariosRoute
  '/seguranca/grupos/$groupId/membros': typeof AppSegurancaGruposGroupIdMembrosRoute
  '/seguranca/grupos/$groupId/permissoes': typeof AppSegurancaGruposGroupIdPermissoesRoute
  '/seguranca/usuarios/$userId/grupos': typeof AppSegurancaUsuariosUserIdGruposRoute
  '/seguranca/usuarios/$userId/permissoes': typeof AppSegurancaUsuariosUserIdPermissoesRoute
  '/cadastro/configuracao-regras/$ruleId/': typeof AppCadastroConfiguracaoRegrasRuleIdIndexRoute
  '/cadastro/convenios/$convenioId/': typeof AppCadastroConveniosConvenioIdIndexRoute
  '/cadastro/fundos/$fundId/': typeof AppCadastroFundosFundIdIndexRoute
  '/cadastro/gestao/produtos-cobranca/': typeof AppCadastroGestaoProdutosCobrancaIndexRoute
  '/cadastro/produtos-conta/$productId/': typeof AppCadastroProdutosContaProductIdIndexRoute
  '/cadastro/produtos-credito/$productId/': typeof AppCadastroProdutosCreditoProductIdIndexRoute
  '/cadastro/regras-dinamicas/$ruleId/': typeof AppCadastroRegrasDinamicasRuleIdIndexRoute
  '/cadastro/regras-dinamicas/simular/': typeof AppCadastroRegrasDinamicasSimularIndexRoute
  '/ccb/cessoes/$batchAssignmentId/': typeof AppCcbCessoesBatchAssignmentIdIndexRoute
  '/ccb/cessoes/submissoes-dimensa/': typeof AppCcbCessoesSubmissoesDimensaIndexRoute
  '/ccb/contratar/consignado-inss/': typeof AppCcbContratarConsignadoInssIndexRoute
  '/ccb/contratar/consignado-privado-cdc/': typeof AppCcbContratarConsignadoPrivadoCdcIndexRoute
  '/ccb/contratar/consignado-privado/': typeof AppCcbContratarConsignadoPrivadoIndexRoute
  '/ccb/contratar/consignado-publico/': typeof AppCcbContratarConsignadoPublicoIndexRoute
  '/ccb/contratar/credito-pessoal/': typeof AppCcbContratarCreditoPessoalIndexRoute
  '/ccb/contratar/veiculo/': typeof AppCcbContratarVeiculoIndexRoute
  '/chatbot/$id/atendimento/': typeof AppChatbotIdAtendimentoIndexRoute
  '/concilicao/fgts/calcular-liquidacao-antecipada/': typeof AppConcilicaoFgtsCalcularLiquidacaoAntecipadaIndexRoute
  '/concilicao/fgts/gerar-arquivo-liquidacao-caixa/': typeof AppConcilicaoFgtsGerarArquivoLiquidacaoCaixaIndexRoute
  '/concilicao/fgts/siape/': typeof AppConcilicaoFgtsSiapeIndexRoute
  '/contas-digitais/contas/$bankAccountId/': typeof AppContasDigitaisContasBankAccountIdIndexRoute
  '/contas-digitais/gestao-spi/consultas/': typeof AppContasDigitaisGestaoSpiConsultasIndexRoute
  '/contas-digitais/solicitacoes/$bankAccountId/': typeof AppContasDigitaisSolicitacoesBankAccountIdIndexRoute
  '/contas-digitais/split-automatico/$operationId/': typeof AppContasDigitaisSplitAutomaticoOperationIdIndexRoute
  '/gestao-carteira/carteiras/$walletId/': typeof AppGestaoCarteiraCarteirasWalletIdIndexRoute
  '/gestao-carteira/conciliacao/dataprev/': typeof AppGestaoCarteiraConciliacaoDataprevIndexRoute
  '/gestao-carteira/recuperacao/acordos/': typeof AppGestaoCarteiraRecuperacaoAcordosIndexRoute
  '/parceiros/solicitacoes/$id/': typeof AppParceirosSolicitacoesIdIndexRoute
  '/pessoas-fisicas/todas/$personId/': typeof AppPessoasFisicasTodasPersonIdIndexRoute
  '/pessoas-juridicas/todas/$personId/': typeof AppPessoasJuridicasTodasPersonIdIndexRoute
  '/seguranca/grupos/$groupId/': typeof AppSegurancaGruposGroupIdIndexRoute
  '/seguranca/recursos-correspondente/$id/': typeof AppSegurancaRecursosCorrespondenteIdIndexRoute
  '/seguranca/usuarios-aplicacao/$aplicacaoId/': typeof AppSegurancaUsuariosAplicacaoAplicacaoIdIndexRoute
  '/seguranca/usuarios/$userId/': typeof AppSegurancaUsuariosUserIdIndexRoute
  '/contas-digitais/contas/$bankAccountId/pix/gerenciar-chaves': typeof AppContasDigitaisContasBankAccountIdPixGerenciarChavesRoute
  '/contas-digitais/contas/$bankAccountId/visualizar/$tab': typeof AppContasDigitaisContasBankAccountIdVisualizarTabRoute
  '/gestao-carteira/carteiras/arquivos/$fileId/remessa': typeof AppGestaoCarteiraCarteirasArquivosFileIdRemessaRoute
  '/gestao-carteira/carteiras/arquivos/$fileId/retorno': typeof AppGestaoCarteiraCarteirasArquivosFileIdRetornoRoute
  '/gestao-carteira/conciliacao/dataprev/$conciliationId/historico': typeof AppGestaoCarteiraConciliacaoDataprevConciliationIdHistoricoRoute
  '/gestao-carteira/conciliacao/dataprev/$conciliationId/inconsistencias': typeof AppGestaoCarteiraConciliacaoDataprevConciliationIdInconsistenciasRoute
  '/gestao-carteira/conciliacao/dataprev/$conciliationId/linha-de-repasse': typeof AppGestaoCarteiraConciliacaoDataprevConciliationIdLinhaDeRepasseRoute
  '/gestao-carteira/conciliacao/dataprev/$conciliationId/nao-encerradas': typeof AppGestaoCarteiraConciliacaoDataprevConciliationIdNaoEncerradasRoute
  '/gestao-carteira/conciliacao/dataprev/bolsao/$id': typeof AppGestaoCarteiraConciliacaoDataprevBolsaoIdRoute
  '/cadastro/configuracao-regras/$ruleId/produtos/': typeof AppCadastroConfiguracaoRegrasRuleIdProdutosIndexRoute
  '/ccb/contratar/consignado-inss/novo/': typeof AppCcbContratarConsignadoInssNovoIndexRoute
  '/ccb/contratar/consignado-inss/refinanciamento/': typeof AppCcbContratarConsignadoInssRefinanciamentoIndexRoute
  '/ccb/contratar/consignado-privado/novo/': typeof AppCcbContratarConsignadoPrivadoNovoIndexRoute
  '/ccb/contratar/consignado-privado/refinanciamento/': typeof AppCcbContratarConsignadoPrivadoRefinanciamentoIndexRoute
  '/ccb/contratar/consignado-publico/novo-compra-de-divida/': typeof AppCcbContratarConsignadoPublicoNovoCompraDeDividaIndexRoute
  '/ccb/contratar/consignado-publico/novo/': typeof AppCcbContratarConsignadoPublicoNovoIndexRoute
  '/ccb/contratar/consignado-publico/refinanciamento/': typeof AppCcbContratarConsignadoPublicoRefinanciamentoIndexRoute
  '/ccb/contratar/veiculo/car-equity/': typeof AppCcbContratarVeiculoCarEquityIndexRoute
  '/ccb/contratar/veiculo/financiamento/': typeof AppCcbContratarVeiculoFinanciamentoIndexRoute
  '/contas-digitais/contas/$bankAccountId/visualizar/': typeof AppContasDigitaisContasBankAccountIdVisualizarIndexRoute
  '/gestao-carteira/conciliacao/dataprev/$conciliationId/': typeof AppGestaoCarteiraConciliacaoDataprevConciliationIdIndexRoute
  '/gestao-carteira/conciliacao/dataprev/bolsao/': typeof AppGestaoCarteiraConciliacaoDataprevBolsaoIndexRoute
  '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/ativas': typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoAtivasRoute
  '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/historico': typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoHistoricoRoute
  '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/pendentes': typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoPendentesRoute
  '/contas-digitais/contas/$bankAccountId/pix/pix-med/consultar': typeof AppContasDigitaisContasBankAccountIdPixPixMedConsultarRoute
  '/contas-digitais/contas/$bankAccountId/pix/pix-med/contestar': typeof AppContasDigitaisContasBankAccountIdPixPixMedContestarRoute
  '/contas-digitais/contas/$bankAccountId/pix/pix-med/informacoes': typeof AppContasDigitaisContasBankAccountIdPixPixMedInformacoesRoute
  '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/': typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoIndexRoute
  '/contas-digitais/contas/$bankAccountId/pix/pix-med/': typeof AppContasDigitaisContasBankAccountIdPixPixMedIndexRoute
  '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados/realizados': typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoAgendadosRealizadosRoute
  '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados/': typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoAgendadosIndexRoute
}
export interface FileRoutesByTo {
  '/em-construcao': typeof AppEmConstrucaoRoute
  '/legado-indisponivel': typeof AppLegadoIndisponivelRoute
  '/dev/blocks': typeof DevBlocksRoute
  '/dev/cessionarios': typeof DevCessionariosRoute
  '/dev/forms': typeof DevFormsRoute
  '/dev/patterns': typeof DevPatternsRoute
  '/dev/produtos-cobranca': typeof DevProdutosCobrancaRoute
  '/dev/record': typeof DevRecordRoute
  '/dev/regua-cobranca': typeof DevReguaCobrancaRoute
  '/dev/shell': typeof DevShellRoute
  '/dev/ui': typeof DevUiRoute
  '/login/alterar-senha': typeof LoginAlterarSenhaRoute
  '/login/confirmar-email': typeof LoginConfirmarEmailRoute
  '/login/confirmar-senha': typeof LoginConfirmarSenhaRoute
  '/login/logout': typeof LoginLogoutRoute
  '/login/recuperar-senha': typeof LoginRecuperarSenhaRoute
  '/': typeof AppIndexRoute
  '/login': typeof LoginIndexRoute
  '/dev/credito/$creditNoteId': typeof DevCreditoCreditNoteIdRoute
  '/login/mfa/setup': typeof LoginMfaSetupRoute
  '/aprovacoes': typeof AppAprovacoesIndexRoute
  '/chatbot': typeof AppChatbotIndexRoute
  '/concilicao': typeof AppConcilicaoIndexRoute
  '/dashboard': typeof AppDashboardIndexRoute
  '/gestao-carteira': typeof AppGestaoCarteiraIndexRoute
  '/meu-perfil': typeof AppMeuPerfilIndexRoute
  '/pessoas-fisicas': typeof AppPessoasFisicasIndexRoute
  '/pessoas-juridicas': typeof AppPessoasJuridicasIndexRoute
  '/seguranca': typeof AppSegurancaIndexRoute
  '/dev/boletos': typeof DevBoletosIndexRoute
  '/dev/carteiras': typeof DevCarteirasIndexRoute
  '/dev/central-regras': typeof DevCentralRegrasIndexRoute
  '/dev/cobrancas': typeof DevCobrancasIndexRoute
  '/dev/conciliacao': typeof DevConciliacaoIndexRoute
  '/dev/convenios': typeof DevConveniosIndexRoute
  '/dev/credito-excluidos': typeof DevCreditoExcluidosIndexRoute
  '/dev/credito': typeof DevCreditoIndexRoute
  '/dev/dataprev': typeof DevDataprevIndexRoute
  '/dev/fluxo': typeof DevFluxoIndexRoute
  '/dev/grupos': typeof DevGruposIndexRoute
  '/dev/meu-perfil': typeof DevMeuPerfilIndexRoute
  '/dev/permissoes-correspondente': typeof DevPermissoesCorrespondenteIndexRoute
  '/dev/pessoas': typeof DevPessoasIndexRoute
  '/dev/pix-med-admin': typeof DevPixMedAdminIndexRoute
  '/dev/produtos-conta': typeof DevProdutosContaIndexRoute
  '/dev/produtos-credito': typeof DevProdutosCreditoIndexRoute
  '/dev/produtos-liquidacao-automatica': typeof DevProdutosLiquidacaoAutomaticaIndexRoute
  '/dev/regras-dinamicas': typeof DevRegrasDinamicasIndexRoute
  '/dev/regua-comunicacao': typeof DevReguaComunicacaoIndexRoute
  '/dev/solicitacoes-parceiros': typeof DevSolicitacoesParceirosIndexRoute
  '/dev/usuarios-aplicacao': typeof DevUsuariosAplicacaoIndexRoute
  '/dev/usuarios': typeof DevUsuariosIndexRoute
  '/login/mfa': typeof LoginMfaIndexRoute
  '/aprovacoes/gestao-aprovacoes/internet-banking': typeof AppAprovacoesGestaoAprovacoesInternetBankingRoute
  '/aprovacoes/gestao-aprovacoes/operacoes': typeof AppAprovacoesGestaoAprovacoesOperacoesRoute
  '/aprovacoes/gestao-aprovacoes/operadores': typeof AppAprovacoesGestaoAprovacoesOperadoresRoute
  '/aprovacoes/gestao-aprovacoes/solicitacoes': typeof AppAprovacoesGestaoAprovacoesSolicitacoesRoute
  '/ccb/cessoes/nova': typeof AppCcbCessoesNovaRoute
  '/ccb/contratar/$': typeof AppCcbContratarSplatRoute
  '/ccb/operacoes/$creditNoteId': typeof AppCcbOperacoesCreditNoteIdRoute
  '/ccb/operacoes/nova': typeof AppCcbOperacoesNovaRoute
  '/gestao-carteira/cobrancas/$billingId': typeof AppGestaoCarteiraCobrancasBillingIdRoute
  '/gestao-carteira/parcelamentos/$installmentId': typeof AppGestaoCarteiraParcelamentosInstallmentIdRoute
  '/gestao-carteira/recuperacao/fila': typeof AppGestaoCarteiraRecuperacaoFilaRoute
  '/aprovacoes/gestao-aprovacoes': typeof AppAprovacoesGestaoAprovacoesIndexRoute
  '/cadastro/configuracao-regras': typeof AppCadastroConfiguracaoRegrasIndexRoute
  '/cadastro/convenios': typeof AppCadastroConveniosIndexRoute
  '/cadastro/fundos': typeof AppCadastroFundosIndexRoute
  '/cadastro/gestao': typeof AppCadastroGestaoIndexRoute
  '/cadastro/produtos-conta': typeof AppCadastroProdutosContaIndexRoute
  '/cadastro/produtos-credito': typeof AppCadastroProdutosCreditoIndexRoute
  '/cadastro/produtos-liquidacao-automatica': typeof AppCadastroProdutosLiquidacaoAutomaticaIndexRoute
  '/cadastro/regras-dinamicas': typeof AppCadastroRegrasDinamicasIndexRoute
  '/ccb/cessoes': typeof AppCcbCessoesIndexRoute
  '/ccb/contratar': typeof AppCcbContratarIndexRoute
  '/ccb/criar-cpf-teste': typeof AppCcbCriarCpfTesteIndexRoute
  '/ccb/desconto': typeof AppCcbDescontoIndexRoute
  '/ccb/excluidos': typeof AppCcbExcluidosIndexRoute
  '/ccb/excluir-autorizacao': typeof AppCcbExcluirAutorizacaoIndexRoute
  '/ccb/gestao-autorizacoes': typeof AppCcbGestaoAutorizacoesIndexRoute
  '/ccb/operacoes': typeof AppCcbOperacoesIndexRoute
  '/ccb/simular': typeof AppCcbSimularIndexRoute
  '/chatbot/$id': typeof AppChatbotIdIndexRoute
  '/chatbot/relatorios': typeof AppChatbotRelatoriosIndexRoute
  '/concilicao/fgts': typeof AppConcilicaoFgtsIndexRoute
  '/contas-digitais/contas': typeof AppContasDigitaisContasIndexRoute
  '/contas-digitais/gestao-spi': typeof AppContasDigitaisGestaoSpiIndexRoute
  '/contas-digitais/pix-med-admin': typeof AppContasDigitaisPixMedAdminIndexRoute
  '/contas-digitais/solicitacoes': typeof AppContasDigitaisSolicitacoesIndexRoute
  '/contas-digitais/split-automatico': typeof AppContasDigitaisSplitAutomaticoIndexRoute
  '/gestao-carteira/carteiras': typeof AppGestaoCarteiraCarteirasIndexRoute
  '/gestao-carteira/cobrancas': typeof AppGestaoCarteiraCobrancasIndexRoute
  '/gestao-carteira/conciliacao': typeof AppGestaoCarteiraConciliacaoIndexRoute
  '/gestao-carteira/dashboard': typeof AppGestaoCarteiraDashboardIndexRoute
  '/gestao-carteira/execucao-garantias': typeof AppGestaoCarteiraExecucaoGarantiasIndexRoute
  '/gestao-carteira/parametros': typeof AppGestaoCarteiraParametrosIndexRoute
  '/gestao-carteira/parcelamentos': typeof AppGestaoCarteiraParcelamentosIndexRoute
  '/gestao-carteira/recuperacao': typeof AppGestaoCarteiraRecuperacaoIndexRoute
  '/gestao-carteira/regua': typeof AppGestaoCarteiraReguaIndexRoute
  '/meu-perfil/configuracoes': typeof AppMeuPerfilConfiguracoesIndexRoute
  '/meu-perfil/permissoes-efetivas': typeof AppMeuPerfilPermissoesEfetivasIndexRoute
  '/parceiros/solicitacoes': typeof AppParceirosSolicitacoesIndexRoute
  '/pessoas-fisicas/pendentes': typeof AppPessoasFisicasPendentesIndexRoute
  '/pessoas-fisicas/todas': typeof AppPessoasFisicasTodasIndexRoute
  '/pessoas-juridicas/pendentes': typeof AppPessoasJuridicasPendentesIndexRoute
  '/pessoas-juridicas/todas': typeof AppPessoasJuridicasTodasIndexRoute
  '/seguranca/grupos': typeof AppSegurancaGruposIndexRoute
  '/seguranca/recursos-correspondente': typeof AppSegurancaRecursosCorrespondenteIndexRoute
  '/seguranca/usuarios-aplicacao': typeof AppSegurancaUsuariosAplicacaoIndexRoute
  '/seguranca/usuarios': typeof AppSegurancaUsuariosIndexRoute
  '/cadastro/fundos/$fundId/cessoes': typeof AppCadastroFundosFundIdCessoesRoute
  '/cadastro/fundos/$fundId/documentos': typeof AppCadastroFundosFundIdDocumentosRoute
  '/cadastro/fundos/$fundId/envolvidos': typeof AppCadastroFundosFundIdEnvolvidosRoute
  '/cadastro/gestao/produtos-cobranca/parametros-custos': typeof AppCadastroGestaoProdutosCobrancaParametrosCustosRoute
  '/cadastro/produtos-conta/$productId/documentos': typeof AppCadastroProdutosContaProductIdDocumentosRoute
  '/cadastro/produtos-conta/$productId/envolvidos': typeof AppCadastroProdutosContaProductIdEnvolvidosRoute
  '/cadastro/produtos-credito/$productId/custo-de-emissao': typeof AppCadastroProdutosCreditoProductIdCustoDeEmissaoRoute
  '/cadastro/produtos-credito/$productId/documentos': typeof AppCadastroProdutosCreditoProductIdDocumentosRoute
  '/cadastro/produtos-credito/$productId/documentos-para-assinatura': typeof AppCadastroProdutosCreditoProductIdDocumentosParaAssinaturaRoute
  '/cadastro/produtos-credito/$productId/envolvidos': typeof AppCadastroProdutosCreditoProductIdEnvolvidosRoute
  '/cadastro/produtos-credito/$productId/orgao': typeof AppCadastroProdutosCreditoProductIdOrgaoRoute
  '/cadastro/produtos-credito/$productId/templates': typeof AppCadastroProdutosCreditoProductIdTemplatesRoute
  '/ccb/cessoes/$batchAssignmentId/documentos': typeof AppCcbCessoesBatchAssignmentIdDocumentosRoute
  '/ccb/cessoes/$batchAssignmentId/historico': typeof AppCcbCessoesBatchAssignmentIdHistoricoRoute
  '/ccb/cessoes/$batchAssignmentId/operacoes': typeof AppCcbCessoesBatchAssignmentIdOperacoesRoute
  '/ccb/cessoes/$batchAssignmentId/parcelas': typeof AppCcbCessoesBatchAssignmentIdParcelasRoute
  '/contas-digitais/contas/$bankAccountId/$tab': typeof AppContasDigitaisContasBankAccountIdTabRoute
  '/contas-digitais/solicitacoes/$bankAccountId/acessos-concedidos': typeof AppContasDigitaisSolicitacoesBankAccountIdAcessosConcedidosRoute
  '/contas-digitais/solicitacoes/$bankAccountId/documentos': typeof AppContasDigitaisSolicitacoesBankAccountIdDocumentosRoute
  '/contas-digitais/solicitacoes/$bankAccountId/envolvidos': typeof AppContasDigitaisSolicitacoesBankAccountIdEnvolvidosRoute
  '/contas-digitais/solicitacoes/$bankAccountId/historico': typeof AppContasDigitaisSolicitacoesBankAccountIdHistoricoRoute
  '/contas-digitais/solicitacoes/$bankAccountId/kyc': typeof AppContasDigitaisSolicitacoesBankAccountIdKycRoute
  '/contas-digitais/split-automatico/$operationId/detalhes': typeof AppContasDigitaisSplitAutomaticoOperationIdDetalhesRoute
  '/gestao-carteira/carteiras/$walletId/arquivos-remessa': typeof AppGestaoCarteiraCarteirasWalletIdArquivosRemessaRoute
  '/gestao-carteira/carteiras/$walletId/arquivos-retorno': typeof AppGestaoCarteiraCarteirasWalletIdArquivosRetornoRoute
  '/gestao-carteira/carteiras/$walletId/tarifas-convenio': typeof AppGestaoCarteiraCarteirasWalletIdTarifasConvenioRoute
  '/gestao-carteira/conciliacao/dataprev/nova-conciliacao': typeof AppGestaoCarteiraConciliacaoDataprevNovaConciliacaoRoute
  '/gestao-carteira/recuperacao/acordos/$agreementId': typeof AppGestaoCarteiraRecuperacaoAcordosAgreementIdRoute
  '/gestao-carteira/recuperacao/devedor/$installmentId': typeof AppGestaoCarteiraRecuperacaoDevedorInstallmentIdRoute
  '/pessoas-fisicas/todas/$personId/compliance': typeof AppPessoasFisicasTodasPersonIdComplianceRoute
  '/pessoas-fisicas/todas/$personId/credito': typeof AppPessoasFisicasTodasPersonIdCreditoRoute
  '/pessoas-fisicas/todas/$personId/dados-bancarios': typeof AppPessoasFisicasTodasPersonIdDadosBancariosRoute
  '/pessoas-fisicas/todas/$personId/documentos': typeof AppPessoasFisicasTodasPersonIdDocumentosRoute
  '/pessoas-fisicas/todas/$personId/operacoes': typeof AppPessoasFisicasTodasPersonIdOperacoesRoute
  '/pessoas-juridicas/todas/$personId/compliance': typeof AppPessoasJuridicasTodasPersonIdComplianceRoute
  '/pessoas-juridicas/todas/$personId/credito': typeof AppPessoasJuridicasTodasPersonIdCreditoRoute
  '/pessoas-juridicas/todas/$personId/dados-bancarios': typeof AppPessoasJuridicasTodasPersonIdDadosBancariosRoute
  '/pessoas-juridicas/todas/$personId/documentos': typeof AppPessoasJuridicasTodasPersonIdDocumentosRoute
  '/pessoas-juridicas/todas/$personId/operacoes': typeof AppPessoasJuridicasTodasPersonIdOperacoesRoute
  '/pessoas-juridicas/todas/$personId/signatarios': typeof AppPessoasJuridicasTodasPersonIdSignatariosRoute
  '/seguranca/grupos/$groupId/membros': typeof AppSegurancaGruposGroupIdMembrosRoute
  '/seguranca/grupos/$groupId/permissoes': typeof AppSegurancaGruposGroupIdPermissoesRoute
  '/seguranca/usuarios/$userId/grupos': typeof AppSegurancaUsuariosUserIdGruposRoute
  '/seguranca/usuarios/$userId/permissoes': typeof AppSegurancaUsuariosUserIdPermissoesRoute
  '/cadastro/configuracao-regras/$ruleId': typeof AppCadastroConfiguracaoRegrasRuleIdIndexRoute
  '/cadastro/convenios/$convenioId': typeof AppCadastroConveniosConvenioIdIndexRoute
  '/cadastro/fundos/$fundId': typeof AppCadastroFundosFundIdIndexRoute
  '/cadastro/gestao/produtos-cobranca': typeof AppCadastroGestaoProdutosCobrancaIndexRoute
  '/cadastro/produtos-conta/$productId': typeof AppCadastroProdutosContaProductIdIndexRoute
  '/cadastro/produtos-credito/$productId': typeof AppCadastroProdutosCreditoProductIdIndexRoute
  '/cadastro/regras-dinamicas/$ruleId': typeof AppCadastroRegrasDinamicasRuleIdIndexRoute
  '/cadastro/regras-dinamicas/simular': typeof AppCadastroRegrasDinamicasSimularIndexRoute
  '/ccb/cessoes/$batchAssignmentId': typeof AppCcbCessoesBatchAssignmentIdIndexRoute
  '/ccb/cessoes/submissoes-dimensa': typeof AppCcbCessoesSubmissoesDimensaIndexRoute
  '/ccb/contratar/consignado-inss': typeof AppCcbContratarConsignadoInssIndexRoute
  '/ccb/contratar/consignado-privado-cdc': typeof AppCcbContratarConsignadoPrivadoCdcIndexRoute
  '/ccb/contratar/consignado-privado': typeof AppCcbContratarConsignadoPrivadoIndexRoute
  '/ccb/contratar/consignado-publico': typeof AppCcbContratarConsignadoPublicoIndexRoute
  '/ccb/contratar/credito-pessoal': typeof AppCcbContratarCreditoPessoalIndexRoute
  '/ccb/contratar/veiculo': typeof AppCcbContratarVeiculoIndexRoute
  '/chatbot/$id/atendimento': typeof AppChatbotIdAtendimentoIndexRoute
  '/concilicao/fgts/calcular-liquidacao-antecipada': typeof AppConcilicaoFgtsCalcularLiquidacaoAntecipadaIndexRoute
  '/concilicao/fgts/gerar-arquivo-liquidacao-caixa': typeof AppConcilicaoFgtsGerarArquivoLiquidacaoCaixaIndexRoute
  '/concilicao/fgts/siape': typeof AppConcilicaoFgtsSiapeIndexRoute
  '/contas-digitais/contas/$bankAccountId': typeof AppContasDigitaisContasBankAccountIdIndexRoute
  '/contas-digitais/gestao-spi/consultas': typeof AppContasDigitaisGestaoSpiConsultasIndexRoute
  '/contas-digitais/solicitacoes/$bankAccountId': typeof AppContasDigitaisSolicitacoesBankAccountIdIndexRoute
  '/contas-digitais/split-automatico/$operationId': typeof AppContasDigitaisSplitAutomaticoOperationIdIndexRoute
  '/gestao-carteira/carteiras/$walletId': typeof AppGestaoCarteiraCarteirasWalletIdIndexRoute
  '/gestao-carteira/conciliacao/dataprev': typeof AppGestaoCarteiraConciliacaoDataprevIndexRoute
  '/gestao-carteira/recuperacao/acordos': typeof AppGestaoCarteiraRecuperacaoAcordosIndexRoute
  '/parceiros/solicitacoes/$id': typeof AppParceirosSolicitacoesIdIndexRoute
  '/pessoas-fisicas/todas/$personId': typeof AppPessoasFisicasTodasPersonIdIndexRoute
  '/pessoas-juridicas/todas/$personId': typeof AppPessoasJuridicasTodasPersonIdIndexRoute
  '/seguranca/grupos/$groupId': typeof AppSegurancaGruposGroupIdIndexRoute
  '/seguranca/recursos-correspondente/$id': typeof AppSegurancaRecursosCorrespondenteIdIndexRoute
  '/seguranca/usuarios-aplicacao/$aplicacaoId': typeof AppSegurancaUsuariosAplicacaoAplicacaoIdIndexRoute
  '/seguranca/usuarios/$userId': typeof AppSegurancaUsuariosUserIdIndexRoute
  '/contas-digitais/contas/$bankAccountId/pix/gerenciar-chaves': typeof AppContasDigitaisContasBankAccountIdPixGerenciarChavesRoute
  '/contas-digitais/contas/$bankAccountId/visualizar/$tab': typeof AppContasDigitaisContasBankAccountIdVisualizarTabRoute
  '/gestao-carteira/carteiras/arquivos/$fileId/remessa': typeof AppGestaoCarteiraCarteirasArquivosFileIdRemessaRoute
  '/gestao-carteira/carteiras/arquivos/$fileId/retorno': typeof AppGestaoCarteiraCarteirasArquivosFileIdRetornoRoute
  '/gestao-carteira/conciliacao/dataprev/$conciliationId/historico': typeof AppGestaoCarteiraConciliacaoDataprevConciliationIdHistoricoRoute
  '/gestao-carteira/conciliacao/dataprev/$conciliationId/inconsistencias': typeof AppGestaoCarteiraConciliacaoDataprevConciliationIdInconsistenciasRoute
  '/gestao-carteira/conciliacao/dataprev/$conciliationId/linha-de-repasse': typeof AppGestaoCarteiraConciliacaoDataprevConciliationIdLinhaDeRepasseRoute
  '/gestao-carteira/conciliacao/dataprev/$conciliationId/nao-encerradas': typeof AppGestaoCarteiraConciliacaoDataprevConciliationIdNaoEncerradasRoute
  '/gestao-carteira/conciliacao/dataprev/bolsao/$id': typeof AppGestaoCarteiraConciliacaoDataprevBolsaoIdRoute
  '/cadastro/configuracao-regras/$ruleId/produtos': typeof AppCadastroConfiguracaoRegrasRuleIdProdutosIndexRoute
  '/ccb/contratar/consignado-inss/novo': typeof AppCcbContratarConsignadoInssNovoIndexRoute
  '/ccb/contratar/consignado-inss/refinanciamento': typeof AppCcbContratarConsignadoInssRefinanciamentoIndexRoute
  '/ccb/contratar/consignado-privado/novo': typeof AppCcbContratarConsignadoPrivadoNovoIndexRoute
  '/ccb/contratar/consignado-privado/refinanciamento': typeof AppCcbContratarConsignadoPrivadoRefinanciamentoIndexRoute
  '/ccb/contratar/consignado-publico/novo-compra-de-divida': typeof AppCcbContratarConsignadoPublicoNovoCompraDeDividaIndexRoute
  '/ccb/contratar/consignado-publico/novo': typeof AppCcbContratarConsignadoPublicoNovoIndexRoute
  '/ccb/contratar/consignado-publico/refinanciamento': typeof AppCcbContratarConsignadoPublicoRefinanciamentoIndexRoute
  '/ccb/contratar/veiculo/car-equity': typeof AppCcbContratarVeiculoCarEquityIndexRoute
  '/ccb/contratar/veiculo/financiamento': typeof AppCcbContratarVeiculoFinanciamentoIndexRoute
  '/contas-digitais/contas/$bankAccountId/visualizar': typeof AppContasDigitaisContasBankAccountIdVisualizarIndexRoute
  '/gestao-carteira/conciliacao/dataprev/$conciliationId': typeof AppGestaoCarteiraConciliacaoDataprevConciliationIdIndexRoute
  '/gestao-carteira/conciliacao/dataprev/bolsao': typeof AppGestaoCarteiraConciliacaoDataprevBolsaoIndexRoute
  '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/ativas': typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoAtivasRoute
  '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/historico': typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoHistoricoRoute
  '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/pendentes': typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoPendentesRoute
  '/contas-digitais/contas/$bankAccountId/pix/pix-med/consultar': typeof AppContasDigitaisContasBankAccountIdPixPixMedConsultarRoute
  '/contas-digitais/contas/$bankAccountId/pix/pix-med/contestar': typeof AppContasDigitaisContasBankAccountIdPixPixMedContestarRoute
  '/contas-digitais/contas/$bankAccountId/pix/pix-med/informacoes': typeof AppContasDigitaisContasBankAccountIdPixPixMedInformacoesRoute
  '/contas-digitais/contas/$bankAccountId/pix/pix-automatico': typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoIndexRoute
  '/contas-digitais/contas/$bankAccountId/pix/pix-med': typeof AppContasDigitaisContasBankAccountIdPixPixMedIndexRoute
  '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados/realizados': typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoAgendadosRealizadosRoute
  '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados': typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoAgendadosIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/login': typeof LoginRouteRouteWithChildren
  '/_app': typeof AppRouteWithChildren
  '/_app/meu-perfil': typeof AppMeuPerfilRouteRouteWithChildren
  '/dev/credito': typeof DevCreditoRouteRouteWithChildren
  '/_app/em-construcao': typeof AppEmConstrucaoRoute
  '/_app/legado-indisponivel': typeof AppLegadoIndisponivelRoute
  '/dev/blocks': typeof DevBlocksRoute
  '/dev/cessionarios': typeof DevCessionariosRoute
  '/dev/forms': typeof DevFormsRoute
  '/dev/patterns': typeof DevPatternsRoute
  '/dev/produtos-cobranca': typeof DevProdutosCobrancaRoute
  '/dev/record': typeof DevRecordRoute
  '/dev/regua-cobranca': typeof DevReguaCobrancaRoute
  '/dev/shell': typeof DevShellRoute
  '/dev/ui': typeof DevUiRoute
  '/login/alterar-senha': typeof LoginAlterarSenhaRoute
  '/login/confirmar-email': typeof LoginConfirmarEmailRoute
  '/login/confirmar-senha': typeof LoginConfirmarSenhaRoute
  '/login/logout': typeof LoginLogoutRoute
  '/login/recuperar-senha': typeof LoginRecuperarSenhaRoute
  '/_app/': typeof AppIndexRoute
  '/login/': typeof LoginIndexRoute
  '/_app/ccb/contratar': typeof AppCcbContratarRouteRouteWithChildren
  '/dev/credito/$creditNoteId': typeof DevCreditoCreditNoteIdRoute
  '/login/mfa/setup': typeof LoginMfaSetupRoute
  '/_app/aprovacoes/': typeof AppAprovacoesIndexRoute
  '/_app/chatbot/': typeof AppChatbotIndexRoute
  '/_app/concilicao/': typeof AppConcilicaoIndexRoute
  '/_app/dashboard/': typeof AppDashboardIndexRoute
  '/_app/gestao-carteira/': typeof AppGestaoCarteiraIndexRoute
  '/_app/meu-perfil/': typeof AppMeuPerfilIndexRoute
  '/_app/pessoas-fisicas/': typeof AppPessoasFisicasIndexRoute
  '/_app/pessoas-juridicas/': typeof AppPessoasJuridicasIndexRoute
  '/_app/seguranca/': typeof AppSegurancaIndexRoute
  '/dev/boletos/': typeof DevBoletosIndexRoute
  '/dev/carteiras/': typeof DevCarteirasIndexRoute
  '/dev/central-regras/': typeof DevCentralRegrasIndexRoute
  '/dev/cobrancas/': typeof DevCobrancasIndexRoute
  '/dev/conciliacao/': typeof DevConciliacaoIndexRoute
  '/dev/convenios/': typeof DevConveniosIndexRoute
  '/dev/credito-excluidos/': typeof DevCreditoExcluidosIndexRoute
  '/dev/credito/': typeof DevCreditoIndexRoute
  '/dev/dataprev/': typeof DevDataprevIndexRoute
  '/dev/fluxo/': typeof DevFluxoIndexRoute
  '/dev/grupos/': typeof DevGruposIndexRoute
  '/dev/meu-perfil/': typeof DevMeuPerfilIndexRoute
  '/dev/permissoes-correspondente/': typeof DevPermissoesCorrespondenteIndexRoute
  '/dev/pessoas/': typeof DevPessoasIndexRoute
  '/dev/pix-med-admin/': typeof DevPixMedAdminIndexRoute
  '/dev/produtos-conta/': typeof DevProdutosContaIndexRoute
  '/dev/produtos-credito/': typeof DevProdutosCreditoIndexRoute
  '/dev/produtos-liquidacao-automatica/': typeof DevProdutosLiquidacaoAutomaticaIndexRoute
  '/dev/regras-dinamicas/': typeof DevRegrasDinamicasIndexRoute
  '/dev/regua-comunicacao/': typeof DevReguaComunicacaoIndexRoute
  '/dev/solicitacoes-parceiros/': typeof DevSolicitacoesParceirosIndexRoute
  '/dev/usuarios-aplicacao/': typeof DevUsuariosAplicacaoIndexRoute
  '/dev/usuarios/': typeof DevUsuariosIndexRoute
  '/login/mfa/': typeof LoginMfaIndexRoute
  '/_app/aprovacoes/gestao-aprovacoes/internet-banking': typeof AppAprovacoesGestaoAprovacoesInternetBankingRoute
  '/_app/aprovacoes/gestao-aprovacoes/operacoes': typeof AppAprovacoesGestaoAprovacoesOperacoesRoute
  '/_app/aprovacoes/gestao-aprovacoes/operadores': typeof AppAprovacoesGestaoAprovacoesOperadoresRoute
  '/_app/aprovacoes/gestao-aprovacoes/solicitacoes': typeof AppAprovacoesGestaoAprovacoesSolicitacoesRoute
  '/_app/ccb/cessoes/nova': typeof AppCcbCessoesNovaRoute
  '/_app/ccb/contratar/$': typeof AppCcbContratarSplatRoute
  '/_app/ccb/operacoes/$creditNoteId': typeof AppCcbOperacoesCreditNoteIdRoute
  '/_app/ccb/operacoes/nova': typeof AppCcbOperacoesNovaRoute
  '/_app/gestao-carteira/cobrancas/$billingId': typeof AppGestaoCarteiraCobrancasBillingIdRoute
  '/_app/gestao-carteira/parcelamentos/$installmentId': typeof AppGestaoCarteiraParcelamentosInstallmentIdRoute
  '/_app/gestao-carteira/recuperacao/fila': typeof AppGestaoCarteiraRecuperacaoFilaRoute
  '/_app/aprovacoes/gestao-aprovacoes/': typeof AppAprovacoesGestaoAprovacoesIndexRoute
  '/_app/cadastro/configuracao-regras/': typeof AppCadastroConfiguracaoRegrasIndexRoute
  '/_app/cadastro/convenios/': typeof AppCadastroConveniosIndexRoute
  '/_app/cadastro/fundos/': typeof AppCadastroFundosIndexRoute
  '/_app/cadastro/gestao/': typeof AppCadastroGestaoIndexRoute
  '/_app/cadastro/produtos-conta/': typeof AppCadastroProdutosContaIndexRoute
  '/_app/cadastro/produtos-credito/': typeof AppCadastroProdutosCreditoIndexRoute
  '/_app/cadastro/produtos-liquidacao-automatica/': typeof AppCadastroProdutosLiquidacaoAutomaticaIndexRoute
  '/_app/cadastro/regras-dinamicas/': typeof AppCadastroRegrasDinamicasIndexRoute
  '/_app/ccb/cessoes/': typeof AppCcbCessoesIndexRoute
  '/_app/ccb/contratar/': typeof AppCcbContratarIndexRoute
  '/_app/ccb/criar-cpf-teste/': typeof AppCcbCriarCpfTesteIndexRoute
  '/_app/ccb/desconto/': typeof AppCcbDescontoIndexRoute
  '/_app/ccb/excluidos/': typeof AppCcbExcluidosIndexRoute
  '/_app/ccb/excluir-autorizacao/': typeof AppCcbExcluirAutorizacaoIndexRoute
  '/_app/ccb/gestao-autorizacoes/': typeof AppCcbGestaoAutorizacoesIndexRoute
  '/_app/ccb/operacoes/': typeof AppCcbOperacoesIndexRoute
  '/_app/ccb/simular/': typeof AppCcbSimularIndexRoute
  '/_app/chatbot/$id/': typeof AppChatbotIdIndexRoute
  '/_app/chatbot/relatorios/': typeof AppChatbotRelatoriosIndexRoute
  '/_app/concilicao/fgts/': typeof AppConcilicaoFgtsIndexRoute
  '/_app/contas-digitais/contas/': typeof AppContasDigitaisContasIndexRoute
  '/_app/contas-digitais/gestao-spi/': typeof AppContasDigitaisGestaoSpiIndexRoute
  '/_app/contas-digitais/pix-med-admin/': typeof AppContasDigitaisPixMedAdminIndexRoute
  '/_app/contas-digitais/solicitacoes/': typeof AppContasDigitaisSolicitacoesIndexRoute
  '/_app/contas-digitais/split-automatico/': typeof AppContasDigitaisSplitAutomaticoIndexRoute
  '/_app/gestao-carteira/carteiras/': typeof AppGestaoCarteiraCarteirasIndexRoute
  '/_app/gestao-carteira/cobrancas/': typeof AppGestaoCarteiraCobrancasIndexRoute
  '/_app/gestao-carteira/conciliacao/': typeof AppGestaoCarteiraConciliacaoIndexRoute
  '/_app/gestao-carteira/dashboard/': typeof AppGestaoCarteiraDashboardIndexRoute
  '/_app/gestao-carteira/execucao-garantias/': typeof AppGestaoCarteiraExecucaoGarantiasIndexRoute
  '/_app/gestao-carteira/parametros/': typeof AppGestaoCarteiraParametrosIndexRoute
  '/_app/gestao-carteira/parcelamentos/': typeof AppGestaoCarteiraParcelamentosIndexRoute
  '/_app/gestao-carteira/recuperacao/': typeof AppGestaoCarteiraRecuperacaoIndexRoute
  '/_app/gestao-carteira/regua/': typeof AppGestaoCarteiraReguaIndexRoute
  '/_app/meu-perfil/configuracoes/': typeof AppMeuPerfilConfiguracoesIndexRoute
  '/_app/meu-perfil/permissoes-efetivas/': typeof AppMeuPerfilPermissoesEfetivasIndexRoute
  '/_app/parceiros/solicitacoes/': typeof AppParceirosSolicitacoesIndexRoute
  '/_app/pessoas-fisicas/pendentes/': typeof AppPessoasFisicasPendentesIndexRoute
  '/_app/pessoas-fisicas/todas/': typeof AppPessoasFisicasTodasIndexRoute
  '/_app/pessoas-juridicas/pendentes/': typeof AppPessoasJuridicasPendentesIndexRoute
  '/_app/pessoas-juridicas/todas/': typeof AppPessoasJuridicasTodasIndexRoute
  '/_app/seguranca/grupos/': typeof AppSegurancaGruposIndexRoute
  '/_app/seguranca/recursos-correspondente/': typeof AppSegurancaRecursosCorrespondenteIndexRoute
  '/_app/seguranca/usuarios-aplicacao/': typeof AppSegurancaUsuariosAplicacaoIndexRoute
  '/_app/seguranca/usuarios/': typeof AppSegurancaUsuariosIndexRoute
  '/_app/cadastro/fundos/$fundId/cessoes': typeof AppCadastroFundosFundIdCessoesRoute
  '/_app/cadastro/fundos/$fundId/documentos': typeof AppCadastroFundosFundIdDocumentosRoute
  '/_app/cadastro/fundos/$fundId/envolvidos': typeof AppCadastroFundosFundIdEnvolvidosRoute
  '/_app/cadastro/gestao/produtos-cobranca/parametros-custos': typeof AppCadastroGestaoProdutosCobrancaParametrosCustosRoute
  '/_app/cadastro/produtos-conta/$productId/documentos': typeof AppCadastroProdutosContaProductIdDocumentosRoute
  '/_app/cadastro/produtos-conta/$productId/envolvidos': typeof AppCadastroProdutosContaProductIdEnvolvidosRoute
  '/_app/cadastro/produtos-credito/$productId/custo-de-emissao': typeof AppCadastroProdutosCreditoProductIdCustoDeEmissaoRoute
  '/_app/cadastro/produtos-credito/$productId/documentos': typeof AppCadastroProdutosCreditoProductIdDocumentosRoute
  '/_app/cadastro/produtos-credito/$productId/documentos-para-assinatura': typeof AppCadastroProdutosCreditoProductIdDocumentosParaAssinaturaRoute
  '/_app/cadastro/produtos-credito/$productId/envolvidos': typeof AppCadastroProdutosCreditoProductIdEnvolvidosRoute
  '/_app/cadastro/produtos-credito/$productId/orgao': typeof AppCadastroProdutosCreditoProductIdOrgaoRoute
  '/_app/cadastro/produtos-credito/$productId/templates': typeof AppCadastroProdutosCreditoProductIdTemplatesRoute
  '/_app/ccb/cessoes/$batchAssignmentId/documentos': typeof AppCcbCessoesBatchAssignmentIdDocumentosRoute
  '/_app/ccb/cessoes/$batchAssignmentId/historico': typeof AppCcbCessoesBatchAssignmentIdHistoricoRoute
  '/_app/ccb/cessoes/$batchAssignmentId/operacoes': typeof AppCcbCessoesBatchAssignmentIdOperacoesRoute
  '/_app/ccb/cessoes/$batchAssignmentId/parcelas': typeof AppCcbCessoesBatchAssignmentIdParcelasRoute
  '/_app/contas-digitais/contas/$bankAccountId/$tab': typeof AppContasDigitaisContasBankAccountIdTabRoute
  '/_app/contas-digitais/solicitacoes/$bankAccountId/acessos-concedidos': typeof AppContasDigitaisSolicitacoesBankAccountIdAcessosConcedidosRoute
  '/_app/contas-digitais/solicitacoes/$bankAccountId/documentos': typeof AppContasDigitaisSolicitacoesBankAccountIdDocumentosRoute
  '/_app/contas-digitais/solicitacoes/$bankAccountId/envolvidos': typeof AppContasDigitaisSolicitacoesBankAccountIdEnvolvidosRoute
  '/_app/contas-digitais/solicitacoes/$bankAccountId/historico': typeof AppContasDigitaisSolicitacoesBankAccountIdHistoricoRoute
  '/_app/contas-digitais/solicitacoes/$bankAccountId/kyc': typeof AppContasDigitaisSolicitacoesBankAccountIdKycRoute
  '/_app/contas-digitais/split-automatico/$operationId/detalhes': typeof AppContasDigitaisSplitAutomaticoOperationIdDetalhesRoute
  '/_app/gestao-carteira/carteiras/$walletId/arquivos-remessa': typeof AppGestaoCarteiraCarteirasWalletIdArquivosRemessaRoute
  '/_app/gestao-carteira/carteiras/$walletId/arquivos-retorno': typeof AppGestaoCarteiraCarteirasWalletIdArquivosRetornoRoute
  '/_app/gestao-carteira/carteiras/$walletId/tarifas-convenio': typeof AppGestaoCarteiraCarteirasWalletIdTarifasConvenioRoute
  '/_app/gestao-carteira/conciliacao/dataprev/nova-conciliacao': typeof AppGestaoCarteiraConciliacaoDataprevNovaConciliacaoRoute
  '/_app/gestao-carteira/recuperacao/acordos/$agreementId': typeof AppGestaoCarteiraRecuperacaoAcordosAgreementIdRoute
  '/_app/gestao-carteira/recuperacao/devedor/$installmentId': typeof AppGestaoCarteiraRecuperacaoDevedorInstallmentIdRoute
  '/_app/pessoas-fisicas/todas/$personId/compliance': typeof AppPessoasFisicasTodasPersonIdComplianceRoute
  '/_app/pessoas-fisicas/todas/$personId/credito': typeof AppPessoasFisicasTodasPersonIdCreditoRoute
  '/_app/pessoas-fisicas/todas/$personId/dados-bancarios': typeof AppPessoasFisicasTodasPersonIdDadosBancariosRoute
  '/_app/pessoas-fisicas/todas/$personId/documentos': typeof AppPessoasFisicasTodasPersonIdDocumentosRoute
  '/_app/pessoas-fisicas/todas/$personId/operacoes': typeof AppPessoasFisicasTodasPersonIdOperacoesRoute
  '/_app/pessoas-juridicas/todas/$personId/compliance': typeof AppPessoasJuridicasTodasPersonIdComplianceRoute
  '/_app/pessoas-juridicas/todas/$personId/credito': typeof AppPessoasJuridicasTodasPersonIdCreditoRoute
  '/_app/pessoas-juridicas/todas/$personId/dados-bancarios': typeof AppPessoasJuridicasTodasPersonIdDadosBancariosRoute
  '/_app/pessoas-juridicas/todas/$personId/documentos': typeof AppPessoasJuridicasTodasPersonIdDocumentosRoute
  '/_app/pessoas-juridicas/todas/$personId/operacoes': typeof AppPessoasJuridicasTodasPersonIdOperacoesRoute
  '/_app/pessoas-juridicas/todas/$personId/signatarios': typeof AppPessoasJuridicasTodasPersonIdSignatariosRoute
  '/_app/seguranca/grupos/$groupId/membros': typeof AppSegurancaGruposGroupIdMembrosRoute
  '/_app/seguranca/grupos/$groupId/permissoes': typeof AppSegurancaGruposGroupIdPermissoesRoute
  '/_app/seguranca/usuarios/$userId/grupos': typeof AppSegurancaUsuariosUserIdGruposRoute
  '/_app/seguranca/usuarios/$userId/permissoes': typeof AppSegurancaUsuariosUserIdPermissoesRoute
  '/_app/cadastro/configuracao-regras/$ruleId/': typeof AppCadastroConfiguracaoRegrasRuleIdIndexRoute
  '/_app/cadastro/convenios/$convenioId/': typeof AppCadastroConveniosConvenioIdIndexRoute
  '/_app/cadastro/fundos/$fundId/': typeof AppCadastroFundosFundIdIndexRoute
  '/_app/cadastro/gestao/produtos-cobranca/': typeof AppCadastroGestaoProdutosCobrancaIndexRoute
  '/_app/cadastro/produtos-conta/$productId/': typeof AppCadastroProdutosContaProductIdIndexRoute
  '/_app/cadastro/produtos-credito/$productId/': typeof AppCadastroProdutosCreditoProductIdIndexRoute
  '/_app/cadastro/regras-dinamicas/$ruleId/': typeof AppCadastroRegrasDinamicasRuleIdIndexRoute
  '/_app/cadastro/regras-dinamicas/simular/': typeof AppCadastroRegrasDinamicasSimularIndexRoute
  '/_app/ccb/cessoes/$batchAssignmentId/': typeof AppCcbCessoesBatchAssignmentIdIndexRoute
  '/_app/ccb/cessoes/submissoes-dimensa/': typeof AppCcbCessoesSubmissoesDimensaIndexRoute
  '/_app/ccb/contratar/consignado-inss/': typeof AppCcbContratarConsignadoInssIndexRoute
  '/_app/ccb/contratar/consignado-privado-cdc/': typeof AppCcbContratarConsignadoPrivadoCdcIndexRoute
  '/_app/ccb/contratar/consignado-privado/': typeof AppCcbContratarConsignadoPrivadoIndexRoute
  '/_app/ccb/contratar/consignado-publico/': typeof AppCcbContratarConsignadoPublicoIndexRoute
  '/_app/ccb/contratar/credito-pessoal/': typeof AppCcbContratarCreditoPessoalIndexRoute
  '/_app/ccb/contratar/veiculo/': typeof AppCcbContratarVeiculoIndexRoute
  '/_app/chatbot/$id/atendimento/': typeof AppChatbotIdAtendimentoIndexRoute
  '/_app/concilicao/fgts/calcular-liquidacao-antecipada/': typeof AppConcilicaoFgtsCalcularLiquidacaoAntecipadaIndexRoute
  '/_app/concilicao/fgts/gerar-arquivo-liquidacao-caixa/': typeof AppConcilicaoFgtsGerarArquivoLiquidacaoCaixaIndexRoute
  '/_app/concilicao/fgts/siape/': typeof AppConcilicaoFgtsSiapeIndexRoute
  '/_app/contas-digitais/contas/$bankAccountId/': typeof AppContasDigitaisContasBankAccountIdIndexRoute
  '/_app/contas-digitais/gestao-spi/consultas/': typeof AppContasDigitaisGestaoSpiConsultasIndexRoute
  '/_app/contas-digitais/solicitacoes/$bankAccountId/': typeof AppContasDigitaisSolicitacoesBankAccountIdIndexRoute
  '/_app/contas-digitais/split-automatico/$operationId/': typeof AppContasDigitaisSplitAutomaticoOperationIdIndexRoute
  '/_app/gestao-carteira/carteiras/$walletId/': typeof AppGestaoCarteiraCarteirasWalletIdIndexRoute
  '/_app/gestao-carteira/conciliacao/dataprev/': typeof AppGestaoCarteiraConciliacaoDataprevIndexRoute
  '/_app/gestao-carteira/recuperacao/acordos/': typeof AppGestaoCarteiraRecuperacaoAcordosIndexRoute
  '/_app/parceiros/solicitacoes/$id/': typeof AppParceirosSolicitacoesIdIndexRoute
  '/_app/pessoas-fisicas/todas/$personId/': typeof AppPessoasFisicasTodasPersonIdIndexRoute
  '/_app/pessoas-juridicas/todas/$personId/': typeof AppPessoasJuridicasTodasPersonIdIndexRoute
  '/_app/seguranca/grupos/$groupId/': typeof AppSegurancaGruposGroupIdIndexRoute
  '/_app/seguranca/recursos-correspondente/$id/': typeof AppSegurancaRecursosCorrespondenteIdIndexRoute
  '/_app/seguranca/usuarios-aplicacao/$aplicacaoId/': typeof AppSegurancaUsuariosAplicacaoAplicacaoIdIndexRoute
  '/_app/seguranca/usuarios/$userId/': typeof AppSegurancaUsuariosUserIdIndexRoute
  '/_app/contas-digitais/contas/$bankAccountId/pix/gerenciar-chaves': typeof AppContasDigitaisContasBankAccountIdPixGerenciarChavesRoute
  '/_app/contas-digitais/contas/$bankAccountId/visualizar/$tab': typeof AppContasDigitaisContasBankAccountIdVisualizarTabRoute
  '/_app/gestao-carteira/carteiras/arquivos/$fileId/remessa': typeof AppGestaoCarteiraCarteirasArquivosFileIdRemessaRoute
  '/_app/gestao-carteira/carteiras/arquivos/$fileId/retorno': typeof AppGestaoCarteiraCarteirasArquivosFileIdRetornoRoute
  '/_app/gestao-carteira/conciliacao/dataprev/$conciliationId/historico': typeof AppGestaoCarteiraConciliacaoDataprevConciliationIdHistoricoRoute
  '/_app/gestao-carteira/conciliacao/dataprev/$conciliationId/inconsistencias': typeof AppGestaoCarteiraConciliacaoDataprevConciliationIdInconsistenciasRoute
  '/_app/gestao-carteira/conciliacao/dataprev/$conciliationId/linha-de-repasse': typeof AppGestaoCarteiraConciliacaoDataprevConciliationIdLinhaDeRepasseRoute
  '/_app/gestao-carteira/conciliacao/dataprev/$conciliationId/nao-encerradas': typeof AppGestaoCarteiraConciliacaoDataprevConciliationIdNaoEncerradasRoute
  '/_app/gestao-carteira/conciliacao/dataprev/bolsao/$id': typeof AppGestaoCarteiraConciliacaoDataprevBolsaoIdRoute
  '/_app/cadastro/configuracao-regras/$ruleId/produtos/': typeof AppCadastroConfiguracaoRegrasRuleIdProdutosIndexRoute
  '/_app/ccb/contratar/consignado-inss/novo/': typeof AppCcbContratarConsignadoInssNovoIndexRoute
  '/_app/ccb/contratar/consignado-inss/refinanciamento/': typeof AppCcbContratarConsignadoInssRefinanciamentoIndexRoute
  '/_app/ccb/contratar/consignado-privado/novo/': typeof AppCcbContratarConsignadoPrivadoNovoIndexRoute
  '/_app/ccb/contratar/consignado-privado/refinanciamento/': typeof AppCcbContratarConsignadoPrivadoRefinanciamentoIndexRoute
  '/_app/ccb/contratar/consignado-publico/novo-compra-de-divida/': typeof AppCcbContratarConsignadoPublicoNovoCompraDeDividaIndexRoute
  '/_app/ccb/contratar/consignado-publico/novo/': typeof AppCcbContratarConsignadoPublicoNovoIndexRoute
  '/_app/ccb/contratar/consignado-publico/refinanciamento/': typeof AppCcbContratarConsignadoPublicoRefinanciamentoIndexRoute
  '/_app/ccb/contratar/veiculo/car-equity/': typeof AppCcbContratarVeiculoCarEquityIndexRoute
  '/_app/ccb/contratar/veiculo/financiamento/': typeof AppCcbContratarVeiculoFinanciamentoIndexRoute
  '/_app/contas-digitais/contas/$bankAccountId/visualizar/': typeof AppContasDigitaisContasBankAccountIdVisualizarIndexRoute
  '/_app/gestao-carteira/conciliacao/dataprev/$conciliationId/': typeof AppGestaoCarteiraConciliacaoDataprevConciliationIdIndexRoute
  '/_app/gestao-carteira/conciliacao/dataprev/bolsao/': typeof AppGestaoCarteiraConciliacaoDataprevBolsaoIndexRoute
  '/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/ativas': typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoAtivasRoute
  '/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/historico': typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoHistoricoRoute
  '/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/pendentes': typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoPendentesRoute
  '/_app/contas-digitais/contas/$bankAccountId/pix/pix-med/consultar': typeof AppContasDigitaisContasBankAccountIdPixPixMedConsultarRoute
  '/_app/contas-digitais/contas/$bankAccountId/pix/pix-med/contestar': typeof AppContasDigitaisContasBankAccountIdPixPixMedContestarRoute
  '/_app/contas-digitais/contas/$bankAccountId/pix/pix-med/informacoes': typeof AppContasDigitaisContasBankAccountIdPixPixMedInformacoesRoute
  '/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/': typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoIndexRoute
  '/_app/contas-digitais/contas/$bankAccountId/pix/pix-med/': typeof AppContasDigitaisContasBankAccountIdPixPixMedIndexRoute
  '/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados/realizados': typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoAgendadosRealizadosRoute
  '/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados/': typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoAgendadosIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/login'
    | '/'
    | '/meu-perfil'
    | '/dev/credito'
    | '/em-construcao'
    | '/legado-indisponivel'
    | '/dev/blocks'
    | '/dev/cessionarios'
    | '/dev/forms'
    | '/dev/patterns'
    | '/dev/produtos-cobranca'
    | '/dev/record'
    | '/dev/regua-cobranca'
    | '/dev/shell'
    | '/dev/ui'
    | '/login/alterar-senha'
    | '/login/confirmar-email'
    | '/login/confirmar-senha'
    | '/login/logout'
    | '/login/recuperar-senha'
    | '/login/'
    | '/ccb/contratar'
    | '/dev/credito/$creditNoteId'
    | '/login/mfa/setup'
    | '/aprovacoes/'
    | '/chatbot/'
    | '/concilicao/'
    | '/dashboard/'
    | '/gestao-carteira/'
    | '/meu-perfil/'
    | '/pessoas-fisicas/'
    | '/pessoas-juridicas/'
    | '/seguranca/'
    | '/dev/boletos/'
    | '/dev/carteiras/'
    | '/dev/central-regras/'
    | '/dev/cobrancas/'
    | '/dev/conciliacao/'
    | '/dev/convenios/'
    | '/dev/credito-excluidos/'
    | '/dev/credito/'
    | '/dev/dataprev/'
    | '/dev/fluxo/'
    | '/dev/grupos/'
    | '/dev/meu-perfil/'
    | '/dev/permissoes-correspondente/'
    | '/dev/pessoas/'
    | '/dev/pix-med-admin/'
    | '/dev/produtos-conta/'
    | '/dev/produtos-credito/'
    | '/dev/produtos-liquidacao-automatica/'
    | '/dev/regras-dinamicas/'
    | '/dev/regua-comunicacao/'
    | '/dev/solicitacoes-parceiros/'
    | '/dev/usuarios-aplicacao/'
    | '/dev/usuarios/'
    | '/login/mfa/'
    | '/aprovacoes/gestao-aprovacoes/internet-banking'
    | '/aprovacoes/gestao-aprovacoes/operacoes'
    | '/aprovacoes/gestao-aprovacoes/operadores'
    | '/aprovacoes/gestao-aprovacoes/solicitacoes'
    | '/ccb/cessoes/nova'
    | '/ccb/contratar/$'
    | '/ccb/operacoes/$creditNoteId'
    | '/ccb/operacoes/nova'
    | '/gestao-carteira/cobrancas/$billingId'
    | '/gestao-carteira/parcelamentos/$installmentId'
    | '/gestao-carteira/recuperacao/fila'
    | '/aprovacoes/gestao-aprovacoes/'
    | '/cadastro/configuracao-regras/'
    | '/cadastro/convenios/'
    | '/cadastro/fundos/'
    | '/cadastro/gestao/'
    | '/cadastro/produtos-conta/'
    | '/cadastro/produtos-credito/'
    | '/cadastro/produtos-liquidacao-automatica/'
    | '/cadastro/regras-dinamicas/'
    | '/ccb/cessoes/'
    | '/ccb/contratar/'
    | '/ccb/criar-cpf-teste/'
    | '/ccb/desconto/'
    | '/ccb/excluidos/'
    | '/ccb/excluir-autorizacao/'
    | '/ccb/gestao-autorizacoes/'
    | '/ccb/operacoes/'
    | '/ccb/simular/'
    | '/chatbot/$id/'
    | '/chatbot/relatorios/'
    | '/concilicao/fgts/'
    | '/contas-digitais/contas/'
    | '/contas-digitais/gestao-spi/'
    | '/contas-digitais/pix-med-admin/'
    | '/contas-digitais/solicitacoes/'
    | '/contas-digitais/split-automatico/'
    | '/gestao-carteira/carteiras/'
    | '/gestao-carteira/cobrancas/'
    | '/gestao-carteira/conciliacao/'
    | '/gestao-carteira/dashboard/'
    | '/gestao-carteira/execucao-garantias/'
    | '/gestao-carteira/parametros/'
    | '/gestao-carteira/parcelamentos/'
    | '/gestao-carteira/recuperacao/'
    | '/gestao-carteira/regua/'
    | '/meu-perfil/configuracoes/'
    | '/meu-perfil/permissoes-efetivas/'
    | '/parceiros/solicitacoes/'
    | '/pessoas-fisicas/pendentes/'
    | '/pessoas-fisicas/todas/'
    | '/pessoas-juridicas/pendentes/'
    | '/pessoas-juridicas/todas/'
    | '/seguranca/grupos/'
    | '/seguranca/recursos-correspondente/'
    | '/seguranca/usuarios-aplicacao/'
    | '/seguranca/usuarios/'
    | '/cadastro/fundos/$fundId/cessoes'
    | '/cadastro/fundos/$fundId/documentos'
    | '/cadastro/fundos/$fundId/envolvidos'
    | '/cadastro/gestao/produtos-cobranca/parametros-custos'
    | '/cadastro/produtos-conta/$productId/documentos'
    | '/cadastro/produtos-conta/$productId/envolvidos'
    | '/cadastro/produtos-credito/$productId/custo-de-emissao'
    | '/cadastro/produtos-credito/$productId/documentos'
    | '/cadastro/produtos-credito/$productId/documentos-para-assinatura'
    | '/cadastro/produtos-credito/$productId/envolvidos'
    | '/cadastro/produtos-credito/$productId/orgao'
    | '/cadastro/produtos-credito/$productId/templates'
    | '/ccb/cessoes/$batchAssignmentId/documentos'
    | '/ccb/cessoes/$batchAssignmentId/historico'
    | '/ccb/cessoes/$batchAssignmentId/operacoes'
    | '/ccb/cessoes/$batchAssignmentId/parcelas'
    | '/contas-digitais/contas/$bankAccountId/$tab'
    | '/contas-digitais/solicitacoes/$bankAccountId/acessos-concedidos'
    | '/contas-digitais/solicitacoes/$bankAccountId/documentos'
    | '/contas-digitais/solicitacoes/$bankAccountId/envolvidos'
    | '/contas-digitais/solicitacoes/$bankAccountId/historico'
    | '/contas-digitais/solicitacoes/$bankAccountId/kyc'
    | '/contas-digitais/split-automatico/$operationId/detalhes'
    | '/gestao-carteira/carteiras/$walletId/arquivos-remessa'
    | '/gestao-carteira/carteiras/$walletId/arquivos-retorno'
    | '/gestao-carteira/carteiras/$walletId/tarifas-convenio'
    | '/gestao-carteira/conciliacao/dataprev/nova-conciliacao'
    | '/gestao-carteira/recuperacao/acordos/$agreementId'
    | '/gestao-carteira/recuperacao/devedor/$installmentId'
    | '/pessoas-fisicas/todas/$personId/compliance'
    | '/pessoas-fisicas/todas/$personId/credito'
    | '/pessoas-fisicas/todas/$personId/dados-bancarios'
    | '/pessoas-fisicas/todas/$personId/documentos'
    | '/pessoas-fisicas/todas/$personId/operacoes'
    | '/pessoas-juridicas/todas/$personId/compliance'
    | '/pessoas-juridicas/todas/$personId/credito'
    | '/pessoas-juridicas/todas/$personId/dados-bancarios'
    | '/pessoas-juridicas/todas/$personId/documentos'
    | '/pessoas-juridicas/todas/$personId/operacoes'
    | '/pessoas-juridicas/todas/$personId/signatarios'
    | '/seguranca/grupos/$groupId/membros'
    | '/seguranca/grupos/$groupId/permissoes'
    | '/seguranca/usuarios/$userId/grupos'
    | '/seguranca/usuarios/$userId/permissoes'
    | '/cadastro/configuracao-regras/$ruleId/'
    | '/cadastro/convenios/$convenioId/'
    | '/cadastro/fundos/$fundId/'
    | '/cadastro/gestao/produtos-cobranca/'
    | '/cadastro/produtos-conta/$productId/'
    | '/cadastro/produtos-credito/$productId/'
    | '/cadastro/regras-dinamicas/$ruleId/'
    | '/cadastro/regras-dinamicas/simular/'
    | '/ccb/cessoes/$batchAssignmentId/'
    | '/ccb/cessoes/submissoes-dimensa/'
    | '/ccb/contratar/consignado-inss/'
    | '/ccb/contratar/consignado-privado-cdc/'
    | '/ccb/contratar/consignado-privado/'
    | '/ccb/contratar/consignado-publico/'
    | '/ccb/contratar/credito-pessoal/'
    | '/ccb/contratar/veiculo/'
    | '/chatbot/$id/atendimento/'
    | '/concilicao/fgts/calcular-liquidacao-antecipada/'
    | '/concilicao/fgts/gerar-arquivo-liquidacao-caixa/'
    | '/concilicao/fgts/siape/'
    | '/contas-digitais/contas/$bankAccountId/'
    | '/contas-digitais/gestao-spi/consultas/'
    | '/contas-digitais/solicitacoes/$bankAccountId/'
    | '/contas-digitais/split-automatico/$operationId/'
    | '/gestao-carteira/carteiras/$walletId/'
    | '/gestao-carteira/conciliacao/dataprev/'
    | '/gestao-carteira/recuperacao/acordos/'
    | '/parceiros/solicitacoes/$id/'
    | '/pessoas-fisicas/todas/$personId/'
    | '/pessoas-juridicas/todas/$personId/'
    | '/seguranca/grupos/$groupId/'
    | '/seguranca/recursos-correspondente/$id/'
    | '/seguranca/usuarios-aplicacao/$aplicacaoId/'
    | '/seguranca/usuarios/$userId/'
    | '/contas-digitais/contas/$bankAccountId/pix/gerenciar-chaves'
    | '/contas-digitais/contas/$bankAccountId/visualizar/$tab'
    | '/gestao-carteira/carteiras/arquivos/$fileId/remessa'
    | '/gestao-carteira/carteiras/arquivos/$fileId/retorno'
    | '/gestao-carteira/conciliacao/dataprev/$conciliationId/historico'
    | '/gestao-carteira/conciliacao/dataprev/$conciliationId/inconsistencias'
    | '/gestao-carteira/conciliacao/dataprev/$conciliationId/linha-de-repasse'
    | '/gestao-carteira/conciliacao/dataprev/$conciliationId/nao-encerradas'
    | '/gestao-carteira/conciliacao/dataprev/bolsao/$id'
    | '/cadastro/configuracao-regras/$ruleId/produtos/'
    | '/ccb/contratar/consignado-inss/novo/'
    | '/ccb/contratar/consignado-inss/refinanciamento/'
    | '/ccb/contratar/consignado-privado/novo/'
    | '/ccb/contratar/consignado-privado/refinanciamento/'
    | '/ccb/contratar/consignado-publico/novo-compra-de-divida/'
    | '/ccb/contratar/consignado-publico/novo/'
    | '/ccb/contratar/consignado-publico/refinanciamento/'
    | '/ccb/contratar/veiculo/car-equity/'
    | '/ccb/contratar/veiculo/financiamento/'
    | '/contas-digitais/contas/$bankAccountId/visualizar/'
    | '/gestao-carteira/conciliacao/dataprev/$conciliationId/'
    | '/gestao-carteira/conciliacao/dataprev/bolsao/'
    | '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/ativas'
    | '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/historico'
    | '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/pendentes'
    | '/contas-digitais/contas/$bankAccountId/pix/pix-med/consultar'
    | '/contas-digitais/contas/$bankAccountId/pix/pix-med/contestar'
    | '/contas-digitais/contas/$bankAccountId/pix/pix-med/informacoes'
    | '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/'
    | '/contas-digitais/contas/$bankAccountId/pix/pix-med/'
    | '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados/realizados'
    | '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/em-construcao'
    | '/legado-indisponivel'
    | '/dev/blocks'
    | '/dev/cessionarios'
    | '/dev/forms'
    | '/dev/patterns'
    | '/dev/produtos-cobranca'
    | '/dev/record'
    | '/dev/regua-cobranca'
    | '/dev/shell'
    | '/dev/ui'
    | '/login/alterar-senha'
    | '/login/confirmar-email'
    | '/login/confirmar-senha'
    | '/login/logout'
    | '/login/recuperar-senha'
    | '/'
    | '/login'
    | '/dev/credito/$creditNoteId'
    | '/login/mfa/setup'
    | '/aprovacoes'
    | '/chatbot'
    | '/concilicao'
    | '/dashboard'
    | '/gestao-carteira'
    | '/meu-perfil'
    | '/pessoas-fisicas'
    | '/pessoas-juridicas'
    | '/seguranca'
    | '/dev/boletos'
    | '/dev/carteiras'
    | '/dev/central-regras'
    | '/dev/cobrancas'
    | '/dev/conciliacao'
    | '/dev/convenios'
    | '/dev/credito-excluidos'
    | '/dev/credito'
    | '/dev/dataprev'
    | '/dev/fluxo'
    | '/dev/grupos'
    | '/dev/meu-perfil'
    | '/dev/permissoes-correspondente'
    | '/dev/pessoas'
    | '/dev/pix-med-admin'
    | '/dev/produtos-conta'
    | '/dev/produtos-credito'
    | '/dev/produtos-liquidacao-automatica'
    | '/dev/regras-dinamicas'
    | '/dev/regua-comunicacao'
    | '/dev/solicitacoes-parceiros'
    | '/dev/usuarios-aplicacao'
    | '/dev/usuarios'
    | '/login/mfa'
    | '/aprovacoes/gestao-aprovacoes/internet-banking'
    | '/aprovacoes/gestao-aprovacoes/operacoes'
    | '/aprovacoes/gestao-aprovacoes/operadores'
    | '/aprovacoes/gestao-aprovacoes/solicitacoes'
    | '/ccb/cessoes/nova'
    | '/ccb/contratar/$'
    | '/ccb/operacoes/$creditNoteId'
    | '/ccb/operacoes/nova'
    | '/gestao-carteira/cobrancas/$billingId'
    | '/gestao-carteira/parcelamentos/$installmentId'
    | '/gestao-carteira/recuperacao/fila'
    | '/aprovacoes/gestao-aprovacoes'
    | '/cadastro/configuracao-regras'
    | '/cadastro/convenios'
    | '/cadastro/fundos'
    | '/cadastro/gestao'
    | '/cadastro/produtos-conta'
    | '/cadastro/produtos-credito'
    | '/cadastro/produtos-liquidacao-automatica'
    | '/cadastro/regras-dinamicas'
    | '/ccb/cessoes'
    | '/ccb/contratar'
    | '/ccb/criar-cpf-teste'
    | '/ccb/desconto'
    | '/ccb/excluidos'
    | '/ccb/excluir-autorizacao'
    | '/ccb/gestao-autorizacoes'
    | '/ccb/operacoes'
    | '/ccb/simular'
    | '/chatbot/$id'
    | '/chatbot/relatorios'
    | '/concilicao/fgts'
    | '/contas-digitais/contas'
    | '/contas-digitais/gestao-spi'
    | '/contas-digitais/pix-med-admin'
    | '/contas-digitais/solicitacoes'
    | '/contas-digitais/split-automatico'
    | '/gestao-carteira/carteiras'
    | '/gestao-carteira/cobrancas'
    | '/gestao-carteira/conciliacao'
    | '/gestao-carteira/dashboard'
    | '/gestao-carteira/execucao-garantias'
    | '/gestao-carteira/parametros'
    | '/gestao-carteira/parcelamentos'
    | '/gestao-carteira/recuperacao'
    | '/gestao-carteira/regua'
    | '/meu-perfil/configuracoes'
    | '/meu-perfil/permissoes-efetivas'
    | '/parceiros/solicitacoes'
    | '/pessoas-fisicas/pendentes'
    | '/pessoas-fisicas/todas'
    | '/pessoas-juridicas/pendentes'
    | '/pessoas-juridicas/todas'
    | '/seguranca/grupos'
    | '/seguranca/recursos-correspondente'
    | '/seguranca/usuarios-aplicacao'
    | '/seguranca/usuarios'
    | '/cadastro/fundos/$fundId/cessoes'
    | '/cadastro/fundos/$fundId/documentos'
    | '/cadastro/fundos/$fundId/envolvidos'
    | '/cadastro/gestao/produtos-cobranca/parametros-custos'
    | '/cadastro/produtos-conta/$productId/documentos'
    | '/cadastro/produtos-conta/$productId/envolvidos'
    | '/cadastro/produtos-credito/$productId/custo-de-emissao'
    | '/cadastro/produtos-credito/$productId/documentos'
    | '/cadastro/produtos-credito/$productId/documentos-para-assinatura'
    | '/cadastro/produtos-credito/$productId/envolvidos'
    | '/cadastro/produtos-credito/$productId/orgao'
    | '/cadastro/produtos-credito/$productId/templates'
    | '/ccb/cessoes/$batchAssignmentId/documentos'
    | '/ccb/cessoes/$batchAssignmentId/historico'
    | '/ccb/cessoes/$batchAssignmentId/operacoes'
    | '/ccb/cessoes/$batchAssignmentId/parcelas'
    | '/contas-digitais/contas/$bankAccountId/$tab'
    | '/contas-digitais/solicitacoes/$bankAccountId/acessos-concedidos'
    | '/contas-digitais/solicitacoes/$bankAccountId/documentos'
    | '/contas-digitais/solicitacoes/$bankAccountId/envolvidos'
    | '/contas-digitais/solicitacoes/$bankAccountId/historico'
    | '/contas-digitais/solicitacoes/$bankAccountId/kyc'
    | '/contas-digitais/split-automatico/$operationId/detalhes'
    | '/gestao-carteira/carteiras/$walletId/arquivos-remessa'
    | '/gestao-carteira/carteiras/$walletId/arquivos-retorno'
    | '/gestao-carteira/carteiras/$walletId/tarifas-convenio'
    | '/gestao-carteira/conciliacao/dataprev/nova-conciliacao'
    | '/gestao-carteira/recuperacao/acordos/$agreementId'
    | '/gestao-carteira/recuperacao/devedor/$installmentId'
    | '/pessoas-fisicas/todas/$personId/compliance'
    | '/pessoas-fisicas/todas/$personId/credito'
    | '/pessoas-fisicas/todas/$personId/dados-bancarios'
    | '/pessoas-fisicas/todas/$personId/documentos'
    | '/pessoas-fisicas/todas/$personId/operacoes'
    | '/pessoas-juridicas/todas/$personId/compliance'
    | '/pessoas-juridicas/todas/$personId/credito'
    | '/pessoas-juridicas/todas/$personId/dados-bancarios'
    | '/pessoas-juridicas/todas/$personId/documentos'
    | '/pessoas-juridicas/todas/$personId/operacoes'
    | '/pessoas-juridicas/todas/$personId/signatarios'
    | '/seguranca/grupos/$groupId/membros'
    | '/seguranca/grupos/$groupId/permissoes'
    | '/seguranca/usuarios/$userId/grupos'
    | '/seguranca/usuarios/$userId/permissoes'
    | '/cadastro/configuracao-regras/$ruleId'
    | '/cadastro/convenios/$convenioId'
    | '/cadastro/fundos/$fundId'
    | '/cadastro/gestao/produtos-cobranca'
    | '/cadastro/produtos-conta/$productId'
    | '/cadastro/produtos-credito/$productId'
    | '/cadastro/regras-dinamicas/$ruleId'
    | '/cadastro/regras-dinamicas/simular'
    | '/ccb/cessoes/$batchAssignmentId'
    | '/ccb/cessoes/submissoes-dimensa'
    | '/ccb/contratar/consignado-inss'
    | '/ccb/contratar/consignado-privado-cdc'
    | '/ccb/contratar/consignado-privado'
    | '/ccb/contratar/consignado-publico'
    | '/ccb/contratar/credito-pessoal'
    | '/ccb/contratar/veiculo'
    | '/chatbot/$id/atendimento'
    | '/concilicao/fgts/calcular-liquidacao-antecipada'
    | '/concilicao/fgts/gerar-arquivo-liquidacao-caixa'
    | '/concilicao/fgts/siape'
    | '/contas-digitais/contas/$bankAccountId'
    | '/contas-digitais/gestao-spi/consultas'
    | '/contas-digitais/solicitacoes/$bankAccountId'
    | '/contas-digitais/split-automatico/$operationId'
    | '/gestao-carteira/carteiras/$walletId'
    | '/gestao-carteira/conciliacao/dataprev'
    | '/gestao-carteira/recuperacao/acordos'
    | '/parceiros/solicitacoes/$id'
    | '/pessoas-fisicas/todas/$personId'
    | '/pessoas-juridicas/todas/$personId'
    | '/seguranca/grupos/$groupId'
    | '/seguranca/recursos-correspondente/$id'
    | '/seguranca/usuarios-aplicacao/$aplicacaoId'
    | '/seguranca/usuarios/$userId'
    | '/contas-digitais/contas/$bankAccountId/pix/gerenciar-chaves'
    | '/contas-digitais/contas/$bankAccountId/visualizar/$tab'
    | '/gestao-carteira/carteiras/arquivos/$fileId/remessa'
    | '/gestao-carteira/carteiras/arquivos/$fileId/retorno'
    | '/gestao-carteira/conciliacao/dataprev/$conciliationId/historico'
    | '/gestao-carteira/conciliacao/dataprev/$conciliationId/inconsistencias'
    | '/gestao-carteira/conciliacao/dataprev/$conciliationId/linha-de-repasse'
    | '/gestao-carteira/conciliacao/dataprev/$conciliationId/nao-encerradas'
    | '/gestao-carteira/conciliacao/dataprev/bolsao/$id'
    | '/cadastro/configuracao-regras/$ruleId/produtos'
    | '/ccb/contratar/consignado-inss/novo'
    | '/ccb/contratar/consignado-inss/refinanciamento'
    | '/ccb/contratar/consignado-privado/novo'
    | '/ccb/contratar/consignado-privado/refinanciamento'
    | '/ccb/contratar/consignado-publico/novo-compra-de-divida'
    | '/ccb/contratar/consignado-publico/novo'
    | '/ccb/contratar/consignado-publico/refinanciamento'
    | '/ccb/contratar/veiculo/car-equity'
    | '/ccb/contratar/veiculo/financiamento'
    | '/contas-digitais/contas/$bankAccountId/visualizar'
    | '/gestao-carteira/conciliacao/dataprev/$conciliationId'
    | '/gestao-carteira/conciliacao/dataprev/bolsao'
    | '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/ativas'
    | '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/historico'
    | '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/pendentes'
    | '/contas-digitais/contas/$bankAccountId/pix/pix-med/consultar'
    | '/contas-digitais/contas/$bankAccountId/pix/pix-med/contestar'
    | '/contas-digitais/contas/$bankAccountId/pix/pix-med/informacoes'
    | '/contas-digitais/contas/$bankAccountId/pix/pix-automatico'
    | '/contas-digitais/contas/$bankAccountId/pix/pix-med'
    | '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados/realizados'
    | '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados'
  id:
    | '__root__'
    | '/login'
    | '/_app'
    | '/_app/meu-perfil'
    | '/dev/credito'
    | '/_app/em-construcao'
    | '/_app/legado-indisponivel'
    | '/dev/blocks'
    | '/dev/cessionarios'
    | '/dev/forms'
    | '/dev/patterns'
    | '/dev/produtos-cobranca'
    | '/dev/record'
    | '/dev/regua-cobranca'
    | '/dev/shell'
    | '/dev/ui'
    | '/login/alterar-senha'
    | '/login/confirmar-email'
    | '/login/confirmar-senha'
    | '/login/logout'
    | '/login/recuperar-senha'
    | '/_app/'
    | '/login/'
    | '/_app/ccb/contratar'
    | '/dev/credito/$creditNoteId'
    | '/login/mfa/setup'
    | '/_app/aprovacoes/'
    | '/_app/chatbot/'
    | '/_app/concilicao/'
    | '/_app/dashboard/'
    | '/_app/gestao-carteira/'
    | '/_app/meu-perfil/'
    | '/_app/pessoas-fisicas/'
    | '/_app/pessoas-juridicas/'
    | '/_app/seguranca/'
    | '/dev/boletos/'
    | '/dev/carteiras/'
    | '/dev/central-regras/'
    | '/dev/cobrancas/'
    | '/dev/conciliacao/'
    | '/dev/convenios/'
    | '/dev/credito-excluidos/'
    | '/dev/credito/'
    | '/dev/dataprev/'
    | '/dev/fluxo/'
    | '/dev/grupos/'
    | '/dev/meu-perfil/'
    | '/dev/permissoes-correspondente/'
    | '/dev/pessoas/'
    | '/dev/pix-med-admin/'
    | '/dev/produtos-conta/'
    | '/dev/produtos-credito/'
    | '/dev/produtos-liquidacao-automatica/'
    | '/dev/regras-dinamicas/'
    | '/dev/regua-comunicacao/'
    | '/dev/solicitacoes-parceiros/'
    | '/dev/usuarios-aplicacao/'
    | '/dev/usuarios/'
    | '/login/mfa/'
    | '/_app/aprovacoes/gestao-aprovacoes/internet-banking'
    | '/_app/aprovacoes/gestao-aprovacoes/operacoes'
    | '/_app/aprovacoes/gestao-aprovacoes/operadores'
    | '/_app/aprovacoes/gestao-aprovacoes/solicitacoes'
    | '/_app/ccb/cessoes/nova'
    | '/_app/ccb/contratar/$'
    | '/_app/ccb/operacoes/$creditNoteId'
    | '/_app/ccb/operacoes/nova'
    | '/_app/gestao-carteira/cobrancas/$billingId'
    | '/_app/gestao-carteira/parcelamentos/$installmentId'
    | '/_app/gestao-carteira/recuperacao/fila'
    | '/_app/aprovacoes/gestao-aprovacoes/'
    | '/_app/cadastro/configuracao-regras/'
    | '/_app/cadastro/convenios/'
    | '/_app/cadastro/fundos/'
    | '/_app/cadastro/gestao/'
    | '/_app/cadastro/produtos-conta/'
    | '/_app/cadastro/produtos-credito/'
    | '/_app/cadastro/produtos-liquidacao-automatica/'
    | '/_app/cadastro/regras-dinamicas/'
    | '/_app/ccb/cessoes/'
    | '/_app/ccb/contratar/'
    | '/_app/ccb/criar-cpf-teste/'
    | '/_app/ccb/desconto/'
    | '/_app/ccb/excluidos/'
    | '/_app/ccb/excluir-autorizacao/'
    | '/_app/ccb/gestao-autorizacoes/'
    | '/_app/ccb/operacoes/'
    | '/_app/ccb/simular/'
    | '/_app/chatbot/$id/'
    | '/_app/chatbot/relatorios/'
    | '/_app/concilicao/fgts/'
    | '/_app/contas-digitais/contas/'
    | '/_app/contas-digitais/gestao-spi/'
    | '/_app/contas-digitais/pix-med-admin/'
    | '/_app/contas-digitais/solicitacoes/'
    | '/_app/contas-digitais/split-automatico/'
    | '/_app/gestao-carteira/carteiras/'
    | '/_app/gestao-carteira/cobrancas/'
    | '/_app/gestao-carteira/conciliacao/'
    | '/_app/gestao-carteira/dashboard/'
    | '/_app/gestao-carteira/execucao-garantias/'
    | '/_app/gestao-carteira/parametros/'
    | '/_app/gestao-carteira/parcelamentos/'
    | '/_app/gestao-carteira/recuperacao/'
    | '/_app/gestao-carteira/regua/'
    | '/_app/meu-perfil/configuracoes/'
    | '/_app/meu-perfil/permissoes-efetivas/'
    | '/_app/parceiros/solicitacoes/'
    | '/_app/pessoas-fisicas/pendentes/'
    | '/_app/pessoas-fisicas/todas/'
    | '/_app/pessoas-juridicas/pendentes/'
    | '/_app/pessoas-juridicas/todas/'
    | '/_app/seguranca/grupos/'
    | '/_app/seguranca/recursos-correspondente/'
    | '/_app/seguranca/usuarios-aplicacao/'
    | '/_app/seguranca/usuarios/'
    | '/_app/cadastro/fundos/$fundId/cessoes'
    | '/_app/cadastro/fundos/$fundId/documentos'
    | '/_app/cadastro/fundos/$fundId/envolvidos'
    | '/_app/cadastro/gestao/produtos-cobranca/parametros-custos'
    | '/_app/cadastro/produtos-conta/$productId/documentos'
    | '/_app/cadastro/produtos-conta/$productId/envolvidos'
    | '/_app/cadastro/produtos-credito/$productId/custo-de-emissao'
    | '/_app/cadastro/produtos-credito/$productId/documentos'
    | '/_app/cadastro/produtos-credito/$productId/documentos-para-assinatura'
    | '/_app/cadastro/produtos-credito/$productId/envolvidos'
    | '/_app/cadastro/produtos-credito/$productId/orgao'
    | '/_app/cadastro/produtos-credito/$productId/templates'
    | '/_app/ccb/cessoes/$batchAssignmentId/documentos'
    | '/_app/ccb/cessoes/$batchAssignmentId/historico'
    | '/_app/ccb/cessoes/$batchAssignmentId/operacoes'
    | '/_app/ccb/cessoes/$batchAssignmentId/parcelas'
    | '/_app/contas-digitais/contas/$bankAccountId/$tab'
    | '/_app/contas-digitais/solicitacoes/$bankAccountId/acessos-concedidos'
    | '/_app/contas-digitais/solicitacoes/$bankAccountId/documentos'
    | '/_app/contas-digitais/solicitacoes/$bankAccountId/envolvidos'
    | '/_app/contas-digitais/solicitacoes/$bankAccountId/historico'
    | '/_app/contas-digitais/solicitacoes/$bankAccountId/kyc'
    | '/_app/contas-digitais/split-automatico/$operationId/detalhes'
    | '/_app/gestao-carteira/carteiras/$walletId/arquivos-remessa'
    | '/_app/gestao-carteira/carteiras/$walletId/arquivos-retorno'
    | '/_app/gestao-carteira/carteiras/$walletId/tarifas-convenio'
    | '/_app/gestao-carteira/conciliacao/dataprev/nova-conciliacao'
    | '/_app/gestao-carteira/recuperacao/acordos/$agreementId'
    | '/_app/gestao-carteira/recuperacao/devedor/$installmentId'
    | '/_app/pessoas-fisicas/todas/$personId/compliance'
    | '/_app/pessoas-fisicas/todas/$personId/credito'
    | '/_app/pessoas-fisicas/todas/$personId/dados-bancarios'
    | '/_app/pessoas-fisicas/todas/$personId/documentos'
    | '/_app/pessoas-fisicas/todas/$personId/operacoes'
    | '/_app/pessoas-juridicas/todas/$personId/compliance'
    | '/_app/pessoas-juridicas/todas/$personId/credito'
    | '/_app/pessoas-juridicas/todas/$personId/dados-bancarios'
    | '/_app/pessoas-juridicas/todas/$personId/documentos'
    | '/_app/pessoas-juridicas/todas/$personId/operacoes'
    | '/_app/pessoas-juridicas/todas/$personId/signatarios'
    | '/_app/seguranca/grupos/$groupId/membros'
    | '/_app/seguranca/grupos/$groupId/permissoes'
    | '/_app/seguranca/usuarios/$userId/grupos'
    | '/_app/seguranca/usuarios/$userId/permissoes'
    | '/_app/cadastro/configuracao-regras/$ruleId/'
    | '/_app/cadastro/convenios/$convenioId/'
    | '/_app/cadastro/fundos/$fundId/'
    | '/_app/cadastro/gestao/produtos-cobranca/'
    | '/_app/cadastro/produtos-conta/$productId/'
    | '/_app/cadastro/produtos-credito/$productId/'
    | '/_app/cadastro/regras-dinamicas/$ruleId/'
    | '/_app/cadastro/regras-dinamicas/simular/'
    | '/_app/ccb/cessoes/$batchAssignmentId/'
    | '/_app/ccb/cessoes/submissoes-dimensa/'
    | '/_app/ccb/contratar/consignado-inss/'
    | '/_app/ccb/contratar/consignado-privado-cdc/'
    | '/_app/ccb/contratar/consignado-privado/'
    | '/_app/ccb/contratar/consignado-publico/'
    | '/_app/ccb/contratar/credito-pessoal/'
    | '/_app/ccb/contratar/veiculo/'
    | '/_app/chatbot/$id/atendimento/'
    | '/_app/concilicao/fgts/calcular-liquidacao-antecipada/'
    | '/_app/concilicao/fgts/gerar-arquivo-liquidacao-caixa/'
    | '/_app/concilicao/fgts/siape/'
    | '/_app/contas-digitais/contas/$bankAccountId/'
    | '/_app/contas-digitais/gestao-spi/consultas/'
    | '/_app/contas-digitais/solicitacoes/$bankAccountId/'
    | '/_app/contas-digitais/split-automatico/$operationId/'
    | '/_app/gestao-carteira/carteiras/$walletId/'
    | '/_app/gestao-carteira/conciliacao/dataprev/'
    | '/_app/gestao-carteira/recuperacao/acordos/'
    | '/_app/parceiros/solicitacoes/$id/'
    | '/_app/pessoas-fisicas/todas/$personId/'
    | '/_app/pessoas-juridicas/todas/$personId/'
    | '/_app/seguranca/grupos/$groupId/'
    | '/_app/seguranca/recursos-correspondente/$id/'
    | '/_app/seguranca/usuarios-aplicacao/$aplicacaoId/'
    | '/_app/seguranca/usuarios/$userId/'
    | '/_app/contas-digitais/contas/$bankAccountId/pix/gerenciar-chaves'
    | '/_app/contas-digitais/contas/$bankAccountId/visualizar/$tab'
    | '/_app/gestao-carteira/carteiras/arquivos/$fileId/remessa'
    | '/_app/gestao-carteira/carteiras/arquivos/$fileId/retorno'
    | '/_app/gestao-carteira/conciliacao/dataprev/$conciliationId/historico'
    | '/_app/gestao-carteira/conciliacao/dataprev/$conciliationId/inconsistencias'
    | '/_app/gestao-carteira/conciliacao/dataprev/$conciliationId/linha-de-repasse'
    | '/_app/gestao-carteira/conciliacao/dataprev/$conciliationId/nao-encerradas'
    | '/_app/gestao-carteira/conciliacao/dataprev/bolsao/$id'
    | '/_app/cadastro/configuracao-regras/$ruleId/produtos/'
    | '/_app/ccb/contratar/consignado-inss/novo/'
    | '/_app/ccb/contratar/consignado-inss/refinanciamento/'
    | '/_app/ccb/contratar/consignado-privado/novo/'
    | '/_app/ccb/contratar/consignado-privado/refinanciamento/'
    | '/_app/ccb/contratar/consignado-publico/novo-compra-de-divida/'
    | '/_app/ccb/contratar/consignado-publico/novo/'
    | '/_app/ccb/contratar/consignado-publico/refinanciamento/'
    | '/_app/ccb/contratar/veiculo/car-equity/'
    | '/_app/ccb/contratar/veiculo/financiamento/'
    | '/_app/contas-digitais/contas/$bankAccountId/visualizar/'
    | '/_app/gestao-carteira/conciliacao/dataprev/$conciliationId/'
    | '/_app/gestao-carteira/conciliacao/dataprev/bolsao/'
    | '/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/ativas'
    | '/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/historico'
    | '/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/pendentes'
    | '/_app/contas-digitais/contas/$bankAccountId/pix/pix-med/consultar'
    | '/_app/contas-digitais/contas/$bankAccountId/pix/pix-med/contestar'
    | '/_app/contas-digitais/contas/$bankAccountId/pix/pix-med/informacoes'
    | '/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/'
    | '/_app/contas-digitais/contas/$bankAccountId/pix/pix-med/'
    | '/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados/realizados'
    | '/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LoginRouteRoute: typeof LoginRouteRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  DevCreditoRouteRoute: typeof DevCreditoRouteRouteWithChildren
  DevBlocksRoute: typeof DevBlocksRoute
  DevCessionariosRoute: typeof DevCessionariosRoute
  DevFormsRoute: typeof DevFormsRoute
  DevPatternsRoute: typeof DevPatternsRoute
  DevProdutosCobrancaRoute: typeof DevProdutosCobrancaRoute
  DevRecordRoute: typeof DevRecordRoute
  DevReguaCobrancaRoute: typeof DevReguaCobrancaRoute
  DevShellRoute: typeof DevShellRoute
  DevUiRoute: typeof DevUiRoute
  DevBoletosIndexRoute: typeof DevBoletosIndexRoute
  DevCarteirasIndexRoute: typeof DevCarteirasIndexRoute
  DevCentralRegrasIndexRoute: typeof DevCentralRegrasIndexRoute
  DevCobrancasIndexRoute: typeof DevCobrancasIndexRoute
  DevConciliacaoIndexRoute: typeof DevConciliacaoIndexRoute
  DevConveniosIndexRoute: typeof DevConveniosIndexRoute
  DevCreditoExcluidosIndexRoute: typeof DevCreditoExcluidosIndexRoute
  DevDataprevIndexRoute: typeof DevDataprevIndexRoute
  DevFluxoIndexRoute: typeof DevFluxoIndexRoute
  DevGruposIndexRoute: typeof DevGruposIndexRoute
  DevMeuPerfilIndexRoute: typeof DevMeuPerfilIndexRoute
  DevPermissoesCorrespondenteIndexRoute: typeof DevPermissoesCorrespondenteIndexRoute
  DevPessoasIndexRoute: typeof DevPessoasIndexRoute
  DevPixMedAdminIndexRoute: typeof DevPixMedAdminIndexRoute
  DevProdutosContaIndexRoute: typeof DevProdutosContaIndexRoute
  DevProdutosCreditoIndexRoute: typeof DevProdutosCreditoIndexRoute
  DevProdutosLiquidacaoAutomaticaIndexRoute: typeof DevProdutosLiquidacaoAutomaticaIndexRoute
  DevRegrasDinamicasIndexRoute: typeof DevRegrasDinamicasIndexRoute
  DevReguaComunicacaoIndexRoute: typeof DevReguaComunicacaoIndexRoute
  DevSolicitacoesParceirosIndexRoute: typeof DevSolicitacoesParceirosIndexRoute
  DevUsuariosAplicacaoIndexRoute: typeof DevUsuariosAplicacaoIndexRoute
  DevUsuariosIndexRoute: typeof DevUsuariosIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/em-construcao': {
      id: '/_app/em-construcao'
      path: '/em-construcao'
      fullPath: '/em-construcao'
      preLoaderRoute: typeof AppEmConstrucaoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/legado-indisponivel': {
      id: '/_app/legado-indisponivel'
      path: '/legado-indisponivel'
      fullPath: '/legado-indisponivel'
      preLoaderRoute: typeof AppLegadoIndisponivelRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meu-perfil': {
      id: '/_app/meu-perfil'
      path: '/meu-perfil'
      fullPath: '/meu-perfil'
      preLoaderRoute: typeof AppMeuPerfilRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/dev/blocks': {
      id: '/dev/blocks'
      path: '/dev/blocks'
      fullPath: '/dev/blocks'
      preLoaderRoute: typeof DevBlocksRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/cessionarios': {
      id: '/dev/cessionarios'
      path: '/dev/cessionarios'
      fullPath: '/dev/cessionarios'
      preLoaderRoute: typeof DevCessionariosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/credito': {
      id: '/dev/credito'
      path: '/dev/credito'
      fullPath: '/dev/credito'
      preLoaderRoute: typeof DevCreditoRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/forms': {
      id: '/dev/forms'
      path: '/dev/forms'
      fullPath: '/dev/forms'
      preLoaderRoute: typeof DevFormsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/patterns': {
      id: '/dev/patterns'
      path: '/dev/patterns'
      fullPath: '/dev/patterns'
      preLoaderRoute: typeof DevPatternsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/produtos-cobranca': {
      id: '/dev/produtos-cobranca'
      path: '/dev/produtos-cobranca'
      fullPath: '/dev/produtos-cobranca'
      preLoaderRoute: typeof DevProdutosCobrancaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/record': {
      id: '/dev/record'
      path: '/dev/record'
      fullPath: '/dev/record'
      preLoaderRoute: typeof DevRecordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/regua-cobranca': {
      id: '/dev/regua-cobranca'
      path: '/dev/regua-cobranca'
      fullPath: '/dev/regua-cobranca'
      preLoaderRoute: typeof DevReguaCobrancaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/shell': {
      id: '/dev/shell'
      path: '/dev/shell'
      fullPath: '/dev/shell'
      preLoaderRoute: typeof DevShellRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/ui': {
      id: '/dev/ui'
      path: '/dev/ui'
      fullPath: '/dev/ui'
      preLoaderRoute: typeof DevUiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof LoginRouteRoute
    }
    '/login/alterar-senha': {
      id: '/login/alterar-senha'
      path: '/alterar-senha'
      fullPath: '/login/alterar-senha'
      preLoaderRoute: typeof LoginAlterarSenhaRouteImport
      parentRoute: typeof LoginRouteRoute
    }
    '/login/confirmar-email': {
      id: '/login/confirmar-email'
      path: '/confirmar-email'
      fullPath: '/login/confirmar-email'
      preLoaderRoute: typeof LoginConfirmarEmailRouteImport
      parentRoute: typeof LoginRouteRoute
    }
    '/login/confirmar-senha': {
      id: '/login/confirmar-senha'
      path: '/confirmar-senha'
      fullPath: '/login/confirmar-senha'
      preLoaderRoute: typeof LoginConfirmarSenhaRouteImport
      parentRoute: typeof LoginRouteRoute
    }
    '/login/logout': {
      id: '/login/logout'
      path: '/logout'
      fullPath: '/login/logout'
      preLoaderRoute: typeof LoginLogoutRouteImport
      parentRoute: typeof LoginRouteRoute
    }
    '/login/recuperar-senha': {
      id: '/login/recuperar-senha'
      path: '/recuperar-senha'
      fullPath: '/login/recuperar-senha'
      preLoaderRoute: typeof LoginRecuperarSenhaRouteImport
      parentRoute: typeof LoginRouteRoute
    }
    '/_app/aprovacoes/': {
      id: '/_app/aprovacoes/'
      path: '/aprovacoes'
      fullPath: '/aprovacoes/'
      preLoaderRoute: typeof AppAprovacoesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ccb/contratar': {
      id: '/_app/ccb/contratar'
      path: '/ccb/contratar'
      fullPath: '/ccb/contratar'
      preLoaderRoute: typeof AppCcbContratarRouteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/chatbot/': {
      id: '/_app/chatbot/'
      path: '/chatbot'
      fullPath: '/chatbot/'
      preLoaderRoute: typeof AppChatbotIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/concilicao/': {
      id: '/_app/concilicao/'
      path: '/concilicao'
      fullPath: '/concilicao/'
      preLoaderRoute: typeof AppConcilicaoIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard/': {
      id: '/_app/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof AppDashboardIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/': {
      id: '/_app/gestao-carteira/'
      path: '/gestao-carteira'
      fullPath: '/gestao-carteira/'
      preLoaderRoute: typeof AppGestaoCarteiraIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meu-perfil/': {
      id: '/_app/meu-perfil/'
      path: '/'
      fullPath: '/meu-perfil/'
      preLoaderRoute: typeof AppMeuPerfilIndexRouteImport
      parentRoute: typeof AppMeuPerfilRouteRoute
    }
    '/_app/pessoas-fisicas/': {
      id: '/_app/pessoas-fisicas/'
      path: '/pessoas-fisicas'
      fullPath: '/pessoas-fisicas/'
      preLoaderRoute: typeof AppPessoasFisicasIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pessoas-juridicas/': {
      id: '/_app/pessoas-juridicas/'
      path: '/pessoas-juridicas'
      fullPath: '/pessoas-juridicas/'
      preLoaderRoute: typeof AppPessoasJuridicasIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/seguranca/': {
      id: '/_app/seguranca/'
      path: '/seguranca'
      fullPath: '/seguranca/'
      preLoaderRoute: typeof AppSegurancaIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/dev/boletos/': {
      id: '/dev/boletos/'
      path: '/dev/boletos'
      fullPath: '/dev/boletos/'
      preLoaderRoute: typeof DevBoletosIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/carteiras/': {
      id: '/dev/carteiras/'
      path: '/dev/carteiras'
      fullPath: '/dev/carteiras/'
      preLoaderRoute: typeof DevCarteirasIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/central-regras/': {
      id: '/dev/central-regras/'
      path: '/dev/central-regras'
      fullPath: '/dev/central-regras/'
      preLoaderRoute: typeof DevCentralRegrasIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/cobrancas/': {
      id: '/dev/cobrancas/'
      path: '/dev/cobrancas'
      fullPath: '/dev/cobrancas/'
      preLoaderRoute: typeof DevCobrancasIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/conciliacao/': {
      id: '/dev/conciliacao/'
      path: '/dev/conciliacao'
      fullPath: '/dev/conciliacao/'
      preLoaderRoute: typeof DevConciliacaoIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/convenios/': {
      id: '/dev/convenios/'
      path: '/dev/convenios'
      fullPath: '/dev/convenios/'
      preLoaderRoute: typeof DevConveniosIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/credito-excluidos/': {
      id: '/dev/credito-excluidos/'
      path: '/dev/credito-excluidos'
      fullPath: '/dev/credito-excluidos/'
      preLoaderRoute: typeof DevCreditoExcluidosIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/credito/': {
      id: '/dev/credito/'
      path: '/'
      fullPath: '/dev/credito/'
      preLoaderRoute: typeof DevCreditoIndexRouteImport
      parentRoute: typeof DevCreditoRouteRoute
    }
    '/dev/credito/$creditNoteId': {
      id: '/dev/credito/$creditNoteId'
      path: '/$creditNoteId'
      fullPath: '/dev/credito/$creditNoteId'
      preLoaderRoute: typeof DevCreditoCreditNoteIdRouteImport
      parentRoute: typeof DevCreditoRouteRoute
    }
    '/dev/dataprev/': {
      id: '/dev/dataprev/'
      path: '/dev/dataprev'
      fullPath: '/dev/dataprev/'
      preLoaderRoute: typeof DevDataprevIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/fluxo/': {
      id: '/dev/fluxo/'
      path: '/dev/fluxo'
      fullPath: '/dev/fluxo/'
      preLoaderRoute: typeof DevFluxoIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/grupos/': {
      id: '/dev/grupos/'
      path: '/dev/grupos'
      fullPath: '/dev/grupos/'
      preLoaderRoute: typeof DevGruposIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/meu-perfil/': {
      id: '/dev/meu-perfil/'
      path: '/dev/meu-perfil'
      fullPath: '/dev/meu-perfil/'
      preLoaderRoute: typeof DevMeuPerfilIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/permissoes-correspondente/': {
      id: '/dev/permissoes-correspondente/'
      path: '/dev/permissoes-correspondente'
      fullPath: '/dev/permissoes-correspondente/'
      preLoaderRoute: typeof DevPermissoesCorrespondenteIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/pessoas/': {
      id: '/dev/pessoas/'
      path: '/dev/pessoas'
      fullPath: '/dev/pessoas/'
      preLoaderRoute: typeof DevPessoasIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/pix-med-admin/': {
      id: '/dev/pix-med-admin/'
      path: '/dev/pix-med-admin'
      fullPath: '/dev/pix-med-admin/'
      preLoaderRoute: typeof DevPixMedAdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/produtos-conta/': {
      id: '/dev/produtos-conta/'
      path: '/dev/produtos-conta'
      fullPath: '/dev/produtos-conta/'
      preLoaderRoute: typeof DevProdutosContaIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/produtos-credito/': {
      id: '/dev/produtos-credito/'
      path: '/dev/produtos-credito'
      fullPath: '/dev/produtos-credito/'
      preLoaderRoute: typeof DevProdutosCreditoIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/produtos-liquidacao-automatica/': {
      id: '/dev/produtos-liquidacao-automatica/'
      path: '/dev/produtos-liquidacao-automatica'
      fullPath: '/dev/produtos-liquidacao-automatica/'
      preLoaderRoute: typeof DevProdutosLiquidacaoAutomaticaIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/regras-dinamicas/': {
      id: '/dev/regras-dinamicas/'
      path: '/dev/regras-dinamicas'
      fullPath: '/dev/regras-dinamicas/'
      preLoaderRoute: typeof DevRegrasDinamicasIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/regua-comunicacao/': {
      id: '/dev/regua-comunicacao/'
      path: '/dev/regua-comunicacao'
      fullPath: '/dev/regua-comunicacao/'
      preLoaderRoute: typeof DevReguaComunicacaoIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/solicitacoes-parceiros/': {
      id: '/dev/solicitacoes-parceiros/'
      path: '/dev/solicitacoes-parceiros'
      fullPath: '/dev/solicitacoes-parceiros/'
      preLoaderRoute: typeof DevSolicitacoesParceirosIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/usuarios-aplicacao/': {
      id: '/dev/usuarios-aplicacao/'
      path: '/dev/usuarios-aplicacao'
      fullPath: '/dev/usuarios-aplicacao/'
      preLoaderRoute: typeof DevUsuariosAplicacaoIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/usuarios/': {
      id: '/dev/usuarios/'
      path: '/dev/usuarios'
      fullPath: '/dev/usuarios/'
      preLoaderRoute: typeof DevUsuariosIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/mfa/': {
      id: '/login/mfa/'
      path: '/mfa'
      fullPath: '/login/mfa/'
      preLoaderRoute: typeof LoginMfaIndexRouteImport
      parentRoute: typeof LoginRouteRoute
    }
    '/login/mfa/setup': {
      id: '/login/mfa/setup'
      path: '/mfa/setup'
      fullPath: '/login/mfa/setup'
      preLoaderRoute: typeof LoginMfaSetupRouteImport
      parentRoute: typeof LoginRouteRoute
    }
    '/_app/aprovacoes/gestao-aprovacoes/': {
      id: '/_app/aprovacoes/gestao-aprovacoes/'
      path: '/aprovacoes/gestao-aprovacoes'
      fullPath: '/aprovacoes/gestao-aprovacoes/'
      preLoaderRoute: typeof AppAprovacoesGestaoAprovacoesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/aprovacoes/gestao-aprovacoes/internet-banking': {
      id: '/_app/aprovacoes/gestao-aprovacoes/internet-banking'
      path: '/aprovacoes/gestao-aprovacoes/internet-banking'
      fullPath: '/aprovacoes/gestao-aprovacoes/internet-banking'
      preLoaderRoute: typeof AppAprovacoesGestaoAprovacoesInternetBankingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/aprovacoes/gestao-aprovacoes/operacoes': {
      id: '/_app/aprovacoes/gestao-aprovacoes/operacoes'
      path: '/aprovacoes/gestao-aprovacoes/operacoes'
      fullPath: '/aprovacoes/gestao-aprovacoes/operacoes'
      preLoaderRoute: typeof AppAprovacoesGestaoAprovacoesOperacoesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/aprovacoes/gestao-aprovacoes/operadores': {
      id: '/_app/aprovacoes/gestao-aprovacoes/operadores'
      path: '/aprovacoes/gestao-aprovacoes/operadores'
      fullPath: '/aprovacoes/gestao-aprovacoes/operadores'
      preLoaderRoute: typeof AppAprovacoesGestaoAprovacoesOperadoresRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/aprovacoes/gestao-aprovacoes/solicitacoes': {
      id: '/_app/aprovacoes/gestao-aprovacoes/solicitacoes'
      path: '/aprovacoes/gestao-aprovacoes/solicitacoes'
      fullPath: '/aprovacoes/gestao-aprovacoes/solicitacoes'
      preLoaderRoute: typeof AppAprovacoesGestaoAprovacoesSolicitacoesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/configuracao-regras/': {
      id: '/_app/cadastro/configuracao-regras/'
      path: '/cadastro/configuracao-regras'
      fullPath: '/cadastro/configuracao-regras/'
      preLoaderRoute: typeof AppCadastroConfiguracaoRegrasIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/convenios/': {
      id: '/_app/cadastro/convenios/'
      path: '/cadastro/convenios'
      fullPath: '/cadastro/convenios/'
      preLoaderRoute: typeof AppCadastroConveniosIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/fundos/': {
      id: '/_app/cadastro/fundos/'
      path: '/cadastro/fundos'
      fullPath: '/cadastro/fundos/'
      preLoaderRoute: typeof AppCadastroFundosIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/gestao/': {
      id: '/_app/cadastro/gestao/'
      path: '/cadastro/gestao'
      fullPath: '/cadastro/gestao/'
      preLoaderRoute: typeof AppCadastroGestaoIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/produtos-conta/': {
      id: '/_app/cadastro/produtos-conta/'
      path: '/cadastro/produtos-conta'
      fullPath: '/cadastro/produtos-conta/'
      preLoaderRoute: typeof AppCadastroProdutosContaIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/produtos-credito/': {
      id: '/_app/cadastro/produtos-credito/'
      path: '/cadastro/produtos-credito'
      fullPath: '/cadastro/produtos-credito/'
      preLoaderRoute: typeof AppCadastroProdutosCreditoIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/produtos-liquidacao-automatica/': {
      id: '/_app/cadastro/produtos-liquidacao-automatica/'
      path: '/cadastro/produtos-liquidacao-automatica'
      fullPath: '/cadastro/produtos-liquidacao-automatica/'
      preLoaderRoute: typeof AppCadastroProdutosLiquidacaoAutomaticaIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/regras-dinamicas/': {
      id: '/_app/cadastro/regras-dinamicas/'
      path: '/cadastro/regras-dinamicas'
      fullPath: '/cadastro/regras-dinamicas/'
      preLoaderRoute: typeof AppCadastroRegrasDinamicasIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ccb/cessoes/': {
      id: '/_app/ccb/cessoes/'
      path: '/ccb/cessoes'
      fullPath: '/ccb/cessoes/'
      preLoaderRoute: typeof AppCcbCessoesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ccb/cessoes/nova': {
      id: '/_app/ccb/cessoes/nova'
      path: '/ccb/cessoes/nova'
      fullPath: '/ccb/cessoes/nova'
      preLoaderRoute: typeof AppCcbCessoesNovaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ccb/contratar/': {
      id: '/_app/ccb/contratar/'
      path: '/'
      fullPath: '/ccb/contratar/'
      preLoaderRoute: typeof AppCcbContratarIndexRouteImport
      parentRoute: typeof AppCcbContratarRouteRoute
    }
    '/_app/ccb/contratar/$': {
      id: '/_app/ccb/contratar/$'
      path: '/$'
      fullPath: '/ccb/contratar/$'
      preLoaderRoute: typeof AppCcbContratarSplatRouteImport
      parentRoute: typeof AppCcbContratarRouteRoute
    }
    '/_app/ccb/criar-cpf-teste/': {
      id: '/_app/ccb/criar-cpf-teste/'
      path: '/ccb/criar-cpf-teste'
      fullPath: '/ccb/criar-cpf-teste/'
      preLoaderRoute: typeof AppCcbCriarCpfTesteIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ccb/desconto/': {
      id: '/_app/ccb/desconto/'
      path: '/ccb/desconto'
      fullPath: '/ccb/desconto/'
      preLoaderRoute: typeof AppCcbDescontoIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ccb/excluidos/': {
      id: '/_app/ccb/excluidos/'
      path: '/ccb/excluidos'
      fullPath: '/ccb/excluidos/'
      preLoaderRoute: typeof AppCcbExcluidosIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ccb/excluir-autorizacao/': {
      id: '/_app/ccb/excluir-autorizacao/'
      path: '/ccb/excluir-autorizacao'
      fullPath: '/ccb/excluir-autorizacao/'
      preLoaderRoute: typeof AppCcbExcluirAutorizacaoIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ccb/gestao-autorizacoes/': {
      id: '/_app/ccb/gestao-autorizacoes/'
      path: '/ccb/gestao-autorizacoes'
      fullPath: '/ccb/gestao-autorizacoes/'
      preLoaderRoute: typeof AppCcbGestaoAutorizacoesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ccb/operacoes/': {
      id: '/_app/ccb/operacoes/'
      path: '/ccb/operacoes'
      fullPath: '/ccb/operacoes/'
      preLoaderRoute: typeof AppCcbOperacoesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ccb/operacoes/$creditNoteId': {
      id: '/_app/ccb/operacoes/$creditNoteId'
      path: '/ccb/operacoes/$creditNoteId'
      fullPath: '/ccb/operacoes/$creditNoteId'
      preLoaderRoute: typeof AppCcbOperacoesCreditNoteIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ccb/operacoes/nova': {
      id: '/_app/ccb/operacoes/nova'
      path: '/ccb/operacoes/nova'
      fullPath: '/ccb/operacoes/nova'
      preLoaderRoute: typeof AppCcbOperacoesNovaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ccb/simular/': {
      id: '/_app/ccb/simular/'
      path: '/ccb/simular'
      fullPath: '/ccb/simular/'
      preLoaderRoute: typeof AppCcbSimularIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/chatbot/$id/': {
      id: '/_app/chatbot/$id/'
      path: '/chatbot/$id'
      fullPath: '/chatbot/$id/'
      preLoaderRoute: typeof AppChatbotIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/chatbot/relatorios/': {
      id: '/_app/chatbot/relatorios/'
      path: '/chatbot/relatorios'
      fullPath: '/chatbot/relatorios/'
      preLoaderRoute: typeof AppChatbotRelatoriosIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/concilicao/fgts/': {
      id: '/_app/concilicao/fgts/'
      path: '/concilicao/fgts'
      fullPath: '/concilicao/fgts/'
      preLoaderRoute: typeof AppConcilicaoFgtsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/contas/': {
      id: '/_app/contas-digitais/contas/'
      path: '/contas-digitais/contas'
      fullPath: '/contas-digitais/contas/'
      preLoaderRoute: typeof AppContasDigitaisContasIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/gestao-spi/': {
      id: '/_app/contas-digitais/gestao-spi/'
      path: '/contas-digitais/gestao-spi'
      fullPath: '/contas-digitais/gestao-spi/'
      preLoaderRoute: typeof AppContasDigitaisGestaoSpiIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/pix-med-admin/': {
      id: '/_app/contas-digitais/pix-med-admin/'
      path: '/contas-digitais/pix-med-admin'
      fullPath: '/contas-digitais/pix-med-admin/'
      preLoaderRoute: typeof AppContasDigitaisPixMedAdminIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/solicitacoes/': {
      id: '/_app/contas-digitais/solicitacoes/'
      path: '/contas-digitais/solicitacoes'
      fullPath: '/contas-digitais/solicitacoes/'
      preLoaderRoute: typeof AppContasDigitaisSolicitacoesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/split-automatico/': {
      id: '/_app/contas-digitais/split-automatico/'
      path: '/contas-digitais/split-automatico'
      fullPath: '/contas-digitais/split-automatico/'
      preLoaderRoute: typeof AppContasDigitaisSplitAutomaticoIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/carteiras/': {
      id: '/_app/gestao-carteira/carteiras/'
      path: '/gestao-carteira/carteiras'
      fullPath: '/gestao-carteira/carteiras/'
      preLoaderRoute: typeof AppGestaoCarteiraCarteirasIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/cobrancas/': {
      id: '/_app/gestao-carteira/cobrancas/'
      path: '/gestao-carteira/cobrancas'
      fullPath: '/gestao-carteira/cobrancas/'
      preLoaderRoute: typeof AppGestaoCarteiraCobrancasIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/cobrancas/$billingId': {
      id: '/_app/gestao-carteira/cobrancas/$billingId'
      path: '/gestao-carteira/cobrancas/$billingId'
      fullPath: '/gestao-carteira/cobrancas/$billingId'
      preLoaderRoute: typeof AppGestaoCarteiraCobrancasBillingIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/conciliacao/': {
      id: '/_app/gestao-carteira/conciliacao/'
      path: '/gestao-carteira/conciliacao'
      fullPath: '/gestao-carteira/conciliacao/'
      preLoaderRoute: typeof AppGestaoCarteiraConciliacaoIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/dashboard/': {
      id: '/_app/gestao-carteira/dashboard/'
      path: '/gestao-carteira/dashboard'
      fullPath: '/gestao-carteira/dashboard/'
      preLoaderRoute: typeof AppGestaoCarteiraDashboardIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/execucao-garantias/': {
      id: '/_app/gestao-carteira/execucao-garantias/'
      path: '/gestao-carteira/execucao-garantias'
      fullPath: '/gestao-carteira/execucao-garantias/'
      preLoaderRoute: typeof AppGestaoCarteiraExecucaoGarantiasIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/parametros/': {
      id: '/_app/gestao-carteira/parametros/'
      path: '/gestao-carteira/parametros'
      fullPath: '/gestao-carteira/parametros/'
      preLoaderRoute: typeof AppGestaoCarteiraParametrosIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/parcelamentos/': {
      id: '/_app/gestao-carteira/parcelamentos/'
      path: '/gestao-carteira/parcelamentos'
      fullPath: '/gestao-carteira/parcelamentos/'
      preLoaderRoute: typeof AppGestaoCarteiraParcelamentosIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/parcelamentos/$installmentId': {
      id: '/_app/gestao-carteira/parcelamentos/$installmentId'
      path: '/gestao-carteira/parcelamentos/$installmentId'
      fullPath: '/gestao-carteira/parcelamentos/$installmentId'
      preLoaderRoute: typeof AppGestaoCarteiraParcelamentosInstallmentIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/recuperacao/': {
      id: '/_app/gestao-carteira/recuperacao/'
      path: '/gestao-carteira/recuperacao'
      fullPath: '/gestao-carteira/recuperacao/'
      preLoaderRoute: typeof AppGestaoCarteiraRecuperacaoIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/recuperacao/fila': {
      id: '/_app/gestao-carteira/recuperacao/fila'
      path: '/gestao-carteira/recuperacao/fila'
      fullPath: '/gestao-carteira/recuperacao/fila'
      preLoaderRoute: typeof AppGestaoCarteiraRecuperacaoFilaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/regua/': {
      id: '/_app/gestao-carteira/regua/'
      path: '/gestao-carteira/regua'
      fullPath: '/gestao-carteira/regua/'
      preLoaderRoute: typeof AppGestaoCarteiraReguaIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/meu-perfil/configuracoes/': {
      id: '/_app/meu-perfil/configuracoes/'
      path: '/configuracoes'
      fullPath: '/meu-perfil/configuracoes/'
      preLoaderRoute: typeof AppMeuPerfilConfiguracoesIndexRouteImport
      parentRoute: typeof AppMeuPerfilRouteRoute
    }
    '/_app/meu-perfil/permissoes-efetivas/': {
      id: '/_app/meu-perfil/permissoes-efetivas/'
      path: '/permissoes-efetivas'
      fullPath: '/meu-perfil/permissoes-efetivas/'
      preLoaderRoute: typeof AppMeuPerfilPermissoesEfetivasIndexRouteImport
      parentRoute: typeof AppMeuPerfilRouteRoute
    }
    '/_app/parceiros/solicitacoes/': {
      id: '/_app/parceiros/solicitacoes/'
      path: '/parceiros/solicitacoes'
      fullPath: '/parceiros/solicitacoes/'
      preLoaderRoute: typeof AppParceirosSolicitacoesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pessoas-fisicas/pendentes/': {
      id: '/_app/pessoas-fisicas/pendentes/'
      path: '/pessoas-fisicas/pendentes'
      fullPath: '/pessoas-fisicas/pendentes/'
      preLoaderRoute: typeof AppPessoasFisicasPendentesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pessoas-fisicas/todas/': {
      id: '/_app/pessoas-fisicas/todas/'
      path: '/pessoas-fisicas/todas'
      fullPath: '/pessoas-fisicas/todas/'
      preLoaderRoute: typeof AppPessoasFisicasTodasIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pessoas-juridicas/pendentes/': {
      id: '/_app/pessoas-juridicas/pendentes/'
      path: '/pessoas-juridicas/pendentes'
      fullPath: '/pessoas-juridicas/pendentes/'
      preLoaderRoute: typeof AppPessoasJuridicasPendentesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pessoas-juridicas/todas/': {
      id: '/_app/pessoas-juridicas/todas/'
      path: '/pessoas-juridicas/todas'
      fullPath: '/pessoas-juridicas/todas/'
      preLoaderRoute: typeof AppPessoasJuridicasTodasIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/seguranca/grupos/': {
      id: '/_app/seguranca/grupos/'
      path: '/seguranca/grupos'
      fullPath: '/seguranca/grupos/'
      preLoaderRoute: typeof AppSegurancaGruposIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/seguranca/recursos-correspondente/': {
      id: '/_app/seguranca/recursos-correspondente/'
      path: '/seguranca/recursos-correspondente'
      fullPath: '/seguranca/recursos-correspondente/'
      preLoaderRoute: typeof AppSegurancaRecursosCorrespondenteIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/seguranca/usuarios-aplicacao/': {
      id: '/_app/seguranca/usuarios-aplicacao/'
      path: '/seguranca/usuarios-aplicacao'
      fullPath: '/seguranca/usuarios-aplicacao/'
      preLoaderRoute: typeof AppSegurancaUsuariosAplicacaoIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/seguranca/usuarios/': {
      id: '/_app/seguranca/usuarios/'
      path: '/seguranca/usuarios'
      fullPath: '/seguranca/usuarios/'
      preLoaderRoute: typeof AppSegurancaUsuariosIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/configuracao-regras/$ruleId/': {
      id: '/_app/cadastro/configuracao-regras/$ruleId/'
      path: '/cadastro/configuracao-regras/$ruleId'
      fullPath: '/cadastro/configuracao-regras/$ruleId/'
      preLoaderRoute: typeof AppCadastroConfiguracaoRegrasRuleIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/convenios/$convenioId/': {
      id: '/_app/cadastro/convenios/$convenioId/'
      path: '/cadastro/convenios/$convenioId'
      fullPath: '/cadastro/convenios/$convenioId/'
      preLoaderRoute: typeof AppCadastroConveniosConvenioIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/fundos/$fundId/': {
      id: '/_app/cadastro/fundos/$fundId/'
      path: '/cadastro/fundos/$fundId'
      fullPath: '/cadastro/fundos/$fundId/'
      preLoaderRoute: typeof AppCadastroFundosFundIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/fundos/$fundId/cessoes': {
      id: '/_app/cadastro/fundos/$fundId/cessoes'
      path: '/cadastro/fundos/$fundId/cessoes'
      fullPath: '/cadastro/fundos/$fundId/cessoes'
      preLoaderRoute: typeof AppCadastroFundosFundIdCessoesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/fundos/$fundId/documentos': {
      id: '/_app/cadastro/fundos/$fundId/documentos'
      path: '/cadastro/fundos/$fundId/documentos'
      fullPath: '/cadastro/fundos/$fundId/documentos'
      preLoaderRoute: typeof AppCadastroFundosFundIdDocumentosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/fundos/$fundId/envolvidos': {
      id: '/_app/cadastro/fundos/$fundId/envolvidos'
      path: '/cadastro/fundos/$fundId/envolvidos'
      fullPath: '/cadastro/fundos/$fundId/envolvidos'
      preLoaderRoute: typeof AppCadastroFundosFundIdEnvolvidosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/gestao/produtos-cobranca/': {
      id: '/_app/cadastro/gestao/produtos-cobranca/'
      path: '/cadastro/gestao/produtos-cobranca'
      fullPath: '/cadastro/gestao/produtos-cobranca/'
      preLoaderRoute: typeof AppCadastroGestaoProdutosCobrancaIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/gestao/produtos-cobranca/parametros-custos': {
      id: '/_app/cadastro/gestao/produtos-cobranca/parametros-custos'
      path: '/cadastro/gestao/produtos-cobranca/parametros-custos'
      fullPath: '/cadastro/gestao/produtos-cobranca/parametros-custos'
      preLoaderRoute: typeof AppCadastroGestaoProdutosCobrancaParametrosCustosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/produtos-conta/$productId/': {
      id: '/_app/cadastro/produtos-conta/$productId/'
      path: '/cadastro/produtos-conta/$productId'
      fullPath: '/cadastro/produtos-conta/$productId/'
      preLoaderRoute: typeof AppCadastroProdutosContaProductIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/produtos-conta/$productId/documentos': {
      id: '/_app/cadastro/produtos-conta/$productId/documentos'
      path: '/cadastro/produtos-conta/$productId/documentos'
      fullPath: '/cadastro/produtos-conta/$productId/documentos'
      preLoaderRoute: typeof AppCadastroProdutosContaProductIdDocumentosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/produtos-conta/$productId/envolvidos': {
      id: '/_app/cadastro/produtos-conta/$productId/envolvidos'
      path: '/cadastro/produtos-conta/$productId/envolvidos'
      fullPath: '/cadastro/produtos-conta/$productId/envolvidos'
      preLoaderRoute: typeof AppCadastroProdutosContaProductIdEnvolvidosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/produtos-credito/$productId/': {
      id: '/_app/cadastro/produtos-credito/$productId/'
      path: '/cadastro/produtos-credito/$productId'
      fullPath: '/cadastro/produtos-credito/$productId/'
      preLoaderRoute: typeof AppCadastroProdutosCreditoProductIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/produtos-credito/$productId/custo-de-emissao': {
      id: '/_app/cadastro/produtos-credito/$productId/custo-de-emissao'
      path: '/cadastro/produtos-credito/$productId/custo-de-emissao'
      fullPath: '/cadastro/produtos-credito/$productId/custo-de-emissao'
      preLoaderRoute: typeof AppCadastroProdutosCreditoProductIdCustoDeEmissaoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/produtos-credito/$productId/documentos': {
      id: '/_app/cadastro/produtos-credito/$productId/documentos'
      path: '/cadastro/produtos-credito/$productId/documentos'
      fullPath: '/cadastro/produtos-credito/$productId/documentos'
      preLoaderRoute: typeof AppCadastroProdutosCreditoProductIdDocumentosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/produtos-credito/$productId/documentos-para-assinatura': {
      id: '/_app/cadastro/produtos-credito/$productId/documentos-para-assinatura'
      path: '/cadastro/produtos-credito/$productId/documentos-para-assinatura'
      fullPath: '/cadastro/produtos-credito/$productId/documentos-para-assinatura'
      preLoaderRoute: typeof AppCadastroProdutosCreditoProductIdDocumentosParaAssinaturaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/produtos-credito/$productId/envolvidos': {
      id: '/_app/cadastro/produtos-credito/$productId/envolvidos'
      path: '/cadastro/produtos-credito/$productId/envolvidos'
      fullPath: '/cadastro/produtos-credito/$productId/envolvidos'
      preLoaderRoute: typeof AppCadastroProdutosCreditoProductIdEnvolvidosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/produtos-credito/$productId/orgao': {
      id: '/_app/cadastro/produtos-credito/$productId/orgao'
      path: '/cadastro/produtos-credito/$productId/orgao'
      fullPath: '/cadastro/produtos-credito/$productId/orgao'
      preLoaderRoute: typeof AppCadastroProdutosCreditoProductIdOrgaoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/produtos-credito/$productId/templates': {
      id: '/_app/cadastro/produtos-credito/$productId/templates'
      path: '/cadastro/produtos-credito/$productId/templates'
      fullPath: '/cadastro/produtos-credito/$productId/templates'
      preLoaderRoute: typeof AppCadastroProdutosCreditoProductIdTemplatesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/regras-dinamicas/$ruleId/': {
      id: '/_app/cadastro/regras-dinamicas/$ruleId/'
      path: '/cadastro/regras-dinamicas/$ruleId'
      fullPath: '/cadastro/regras-dinamicas/$ruleId/'
      preLoaderRoute: typeof AppCadastroRegrasDinamicasRuleIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/regras-dinamicas/simular/': {
      id: '/_app/cadastro/regras-dinamicas/simular/'
      path: '/cadastro/regras-dinamicas/simular'
      fullPath: '/cadastro/regras-dinamicas/simular/'
      preLoaderRoute: typeof AppCadastroRegrasDinamicasSimularIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ccb/cessoes/$batchAssignmentId/': {
      id: '/_app/ccb/cessoes/$batchAssignmentId/'
      path: '/ccb/cessoes/$batchAssignmentId'
      fullPath: '/ccb/cessoes/$batchAssignmentId/'
      preLoaderRoute: typeof AppCcbCessoesBatchAssignmentIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ccb/cessoes/$batchAssignmentId/documentos': {
      id: '/_app/ccb/cessoes/$batchAssignmentId/documentos'
      path: '/ccb/cessoes/$batchAssignmentId/documentos'
      fullPath: '/ccb/cessoes/$batchAssignmentId/documentos'
      preLoaderRoute: typeof AppCcbCessoesBatchAssignmentIdDocumentosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ccb/cessoes/$batchAssignmentId/historico': {
      id: '/_app/ccb/cessoes/$batchAssignmentId/historico'
      path: '/ccb/cessoes/$batchAssignmentId/historico'
      fullPath: '/ccb/cessoes/$batchAssignmentId/historico'
      preLoaderRoute: typeof AppCcbCessoesBatchAssignmentIdHistoricoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ccb/cessoes/$batchAssignmentId/operacoes': {
      id: '/_app/ccb/cessoes/$batchAssignmentId/operacoes'
      path: '/ccb/cessoes/$batchAssignmentId/operacoes'
      fullPath: '/ccb/cessoes/$batchAssignmentId/operacoes'
      preLoaderRoute: typeof AppCcbCessoesBatchAssignmentIdOperacoesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ccb/cessoes/$batchAssignmentId/parcelas': {
      id: '/_app/ccb/cessoes/$batchAssignmentId/parcelas'
      path: '/ccb/cessoes/$batchAssignmentId/parcelas'
      fullPath: '/ccb/cessoes/$batchAssignmentId/parcelas'
      preLoaderRoute: typeof AppCcbCessoesBatchAssignmentIdParcelasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ccb/cessoes/submissoes-dimensa/': {
      id: '/_app/ccb/cessoes/submissoes-dimensa/'
      path: '/ccb/cessoes/submissoes-dimensa'
      fullPath: '/ccb/cessoes/submissoes-dimensa/'
      preLoaderRoute: typeof AppCcbCessoesSubmissoesDimensaIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ccb/contratar/consignado-inss/': {
      id: '/_app/ccb/contratar/consignado-inss/'
      path: '/consignado-inss'
      fullPath: '/ccb/contratar/consignado-inss/'
      preLoaderRoute: typeof AppCcbContratarConsignadoInssIndexRouteImport
      parentRoute: typeof AppCcbContratarRouteRoute
    }
    '/_app/ccb/contratar/consignado-privado-cdc/': {
      id: '/_app/ccb/contratar/consignado-privado-cdc/'
      path: '/consignado-privado-cdc'
      fullPath: '/ccb/contratar/consignado-privado-cdc/'
      preLoaderRoute: typeof AppCcbContratarConsignadoPrivadoCdcIndexRouteImport
      parentRoute: typeof AppCcbContratarRouteRoute
    }
    '/_app/ccb/contratar/consignado-privado/': {
      id: '/_app/ccb/contratar/consignado-privado/'
      path: '/consignado-privado'
      fullPath: '/ccb/contratar/consignado-privado/'
      preLoaderRoute: typeof AppCcbContratarConsignadoPrivadoIndexRouteImport
      parentRoute: typeof AppCcbContratarRouteRoute
    }
    '/_app/ccb/contratar/consignado-publico/': {
      id: '/_app/ccb/contratar/consignado-publico/'
      path: '/consignado-publico'
      fullPath: '/ccb/contratar/consignado-publico/'
      preLoaderRoute: typeof AppCcbContratarConsignadoPublicoIndexRouteImport
      parentRoute: typeof AppCcbContratarRouteRoute
    }
    '/_app/ccb/contratar/credito-pessoal/': {
      id: '/_app/ccb/contratar/credito-pessoal/'
      path: '/credito-pessoal'
      fullPath: '/ccb/contratar/credito-pessoal/'
      preLoaderRoute: typeof AppCcbContratarCreditoPessoalIndexRouteImport
      parentRoute: typeof AppCcbContratarRouteRoute
    }
    '/_app/ccb/contratar/veiculo/': {
      id: '/_app/ccb/contratar/veiculo/'
      path: '/veiculo'
      fullPath: '/ccb/contratar/veiculo/'
      preLoaderRoute: typeof AppCcbContratarVeiculoIndexRouteImport
      parentRoute: typeof AppCcbContratarRouteRoute
    }
    '/_app/chatbot/$id/atendimento/': {
      id: '/_app/chatbot/$id/atendimento/'
      path: '/chatbot/$id/atendimento'
      fullPath: '/chatbot/$id/atendimento/'
      preLoaderRoute: typeof AppChatbotIdAtendimentoIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/concilicao/fgts/calcular-liquidacao-antecipada/': {
      id: '/_app/concilicao/fgts/calcular-liquidacao-antecipada/'
      path: '/concilicao/fgts/calcular-liquidacao-antecipada'
      fullPath: '/concilicao/fgts/calcular-liquidacao-antecipada/'
      preLoaderRoute: typeof AppConcilicaoFgtsCalcularLiquidacaoAntecipadaIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/concilicao/fgts/gerar-arquivo-liquidacao-caixa/': {
      id: '/_app/concilicao/fgts/gerar-arquivo-liquidacao-caixa/'
      path: '/concilicao/fgts/gerar-arquivo-liquidacao-caixa'
      fullPath: '/concilicao/fgts/gerar-arquivo-liquidacao-caixa/'
      preLoaderRoute: typeof AppConcilicaoFgtsGerarArquivoLiquidacaoCaixaIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/concilicao/fgts/siape/': {
      id: '/_app/concilicao/fgts/siape/'
      path: '/concilicao/fgts/siape'
      fullPath: '/concilicao/fgts/siape/'
      preLoaderRoute: typeof AppConcilicaoFgtsSiapeIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/contas/$bankAccountId/': {
      id: '/_app/contas-digitais/contas/$bankAccountId/'
      path: '/contas-digitais/contas/$bankAccountId'
      fullPath: '/contas-digitais/contas/$bankAccountId/'
      preLoaderRoute: typeof AppContasDigitaisContasBankAccountIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/contas/$bankAccountId/$tab': {
      id: '/_app/contas-digitais/contas/$bankAccountId/$tab'
      path: '/contas-digitais/contas/$bankAccountId/$tab'
      fullPath: '/contas-digitais/contas/$bankAccountId/$tab'
      preLoaderRoute: typeof AppContasDigitaisContasBankAccountIdTabRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/gestao-spi/consultas/': {
      id: '/_app/contas-digitais/gestao-spi/consultas/'
      path: '/contas-digitais/gestao-spi/consultas'
      fullPath: '/contas-digitais/gestao-spi/consultas/'
      preLoaderRoute: typeof AppContasDigitaisGestaoSpiConsultasIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/solicitacoes/$bankAccountId/': {
      id: '/_app/contas-digitais/solicitacoes/$bankAccountId/'
      path: '/contas-digitais/solicitacoes/$bankAccountId'
      fullPath: '/contas-digitais/solicitacoes/$bankAccountId/'
      preLoaderRoute: typeof AppContasDigitaisSolicitacoesBankAccountIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/solicitacoes/$bankAccountId/acessos-concedidos': {
      id: '/_app/contas-digitais/solicitacoes/$bankAccountId/acessos-concedidos'
      path: '/contas-digitais/solicitacoes/$bankAccountId/acessos-concedidos'
      fullPath: '/contas-digitais/solicitacoes/$bankAccountId/acessos-concedidos'
      preLoaderRoute: typeof AppContasDigitaisSolicitacoesBankAccountIdAcessosConcedidosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/solicitacoes/$bankAccountId/documentos': {
      id: '/_app/contas-digitais/solicitacoes/$bankAccountId/documentos'
      path: '/contas-digitais/solicitacoes/$bankAccountId/documentos'
      fullPath: '/contas-digitais/solicitacoes/$bankAccountId/documentos'
      preLoaderRoute: typeof AppContasDigitaisSolicitacoesBankAccountIdDocumentosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/solicitacoes/$bankAccountId/envolvidos': {
      id: '/_app/contas-digitais/solicitacoes/$bankAccountId/envolvidos'
      path: '/contas-digitais/solicitacoes/$bankAccountId/envolvidos'
      fullPath: '/contas-digitais/solicitacoes/$bankAccountId/envolvidos'
      preLoaderRoute: typeof AppContasDigitaisSolicitacoesBankAccountIdEnvolvidosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/solicitacoes/$bankAccountId/historico': {
      id: '/_app/contas-digitais/solicitacoes/$bankAccountId/historico'
      path: '/contas-digitais/solicitacoes/$bankAccountId/historico'
      fullPath: '/contas-digitais/solicitacoes/$bankAccountId/historico'
      preLoaderRoute: typeof AppContasDigitaisSolicitacoesBankAccountIdHistoricoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/solicitacoes/$bankAccountId/kyc': {
      id: '/_app/contas-digitais/solicitacoes/$bankAccountId/kyc'
      path: '/contas-digitais/solicitacoes/$bankAccountId/kyc'
      fullPath: '/contas-digitais/solicitacoes/$bankAccountId/kyc'
      preLoaderRoute: typeof AppContasDigitaisSolicitacoesBankAccountIdKycRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/split-automatico/$operationId/': {
      id: '/_app/contas-digitais/split-automatico/$operationId/'
      path: '/contas-digitais/split-automatico/$operationId'
      fullPath: '/contas-digitais/split-automatico/$operationId/'
      preLoaderRoute: typeof AppContasDigitaisSplitAutomaticoOperationIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/split-automatico/$operationId/detalhes': {
      id: '/_app/contas-digitais/split-automatico/$operationId/detalhes'
      path: '/contas-digitais/split-automatico/$operationId/detalhes'
      fullPath: '/contas-digitais/split-automatico/$operationId/detalhes'
      preLoaderRoute: typeof AppContasDigitaisSplitAutomaticoOperationIdDetalhesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/carteiras/$walletId/': {
      id: '/_app/gestao-carteira/carteiras/$walletId/'
      path: '/gestao-carteira/carteiras/$walletId'
      fullPath: '/gestao-carteira/carteiras/$walletId/'
      preLoaderRoute: typeof AppGestaoCarteiraCarteirasWalletIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/carteiras/$walletId/arquivos-remessa': {
      id: '/_app/gestao-carteira/carteiras/$walletId/arquivos-remessa'
      path: '/gestao-carteira/carteiras/$walletId/arquivos-remessa'
      fullPath: '/gestao-carteira/carteiras/$walletId/arquivos-remessa'
      preLoaderRoute: typeof AppGestaoCarteiraCarteirasWalletIdArquivosRemessaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/carteiras/$walletId/arquivos-retorno': {
      id: '/_app/gestao-carteira/carteiras/$walletId/arquivos-retorno'
      path: '/gestao-carteira/carteiras/$walletId/arquivos-retorno'
      fullPath: '/gestao-carteira/carteiras/$walletId/arquivos-retorno'
      preLoaderRoute: typeof AppGestaoCarteiraCarteirasWalletIdArquivosRetornoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/carteiras/$walletId/tarifas-convenio': {
      id: '/_app/gestao-carteira/carteiras/$walletId/tarifas-convenio'
      path: '/gestao-carteira/carteiras/$walletId/tarifas-convenio'
      fullPath: '/gestao-carteira/carteiras/$walletId/tarifas-convenio'
      preLoaderRoute: typeof AppGestaoCarteiraCarteirasWalletIdTarifasConvenioRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/conciliacao/dataprev/': {
      id: '/_app/gestao-carteira/conciliacao/dataprev/'
      path: '/gestao-carteira/conciliacao/dataprev'
      fullPath: '/gestao-carteira/conciliacao/dataprev/'
      preLoaderRoute: typeof AppGestaoCarteiraConciliacaoDataprevIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/conciliacao/dataprev/nova-conciliacao': {
      id: '/_app/gestao-carteira/conciliacao/dataprev/nova-conciliacao'
      path: '/gestao-carteira/conciliacao/dataprev/nova-conciliacao'
      fullPath: '/gestao-carteira/conciliacao/dataprev/nova-conciliacao'
      preLoaderRoute: typeof AppGestaoCarteiraConciliacaoDataprevNovaConciliacaoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/recuperacao/acordos/': {
      id: '/_app/gestao-carteira/recuperacao/acordos/'
      path: '/gestao-carteira/recuperacao/acordos'
      fullPath: '/gestao-carteira/recuperacao/acordos/'
      preLoaderRoute: typeof AppGestaoCarteiraRecuperacaoAcordosIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/recuperacao/acordos/$agreementId': {
      id: '/_app/gestao-carteira/recuperacao/acordos/$agreementId'
      path: '/gestao-carteira/recuperacao/acordos/$agreementId'
      fullPath: '/gestao-carteira/recuperacao/acordos/$agreementId'
      preLoaderRoute: typeof AppGestaoCarteiraRecuperacaoAcordosAgreementIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/recuperacao/devedor/$installmentId': {
      id: '/_app/gestao-carteira/recuperacao/devedor/$installmentId'
      path: '/gestao-carteira/recuperacao/devedor/$installmentId'
      fullPath: '/gestao-carteira/recuperacao/devedor/$installmentId'
      preLoaderRoute: typeof AppGestaoCarteiraRecuperacaoDevedorInstallmentIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/parceiros/solicitacoes/$id/': {
      id: '/_app/parceiros/solicitacoes/$id/'
      path: '/parceiros/solicitacoes/$id'
      fullPath: '/parceiros/solicitacoes/$id/'
      preLoaderRoute: typeof AppParceirosSolicitacoesIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pessoas-fisicas/todas/$personId/': {
      id: '/_app/pessoas-fisicas/todas/$personId/'
      path: '/pessoas-fisicas/todas/$personId'
      fullPath: '/pessoas-fisicas/todas/$personId/'
      preLoaderRoute: typeof AppPessoasFisicasTodasPersonIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pessoas-fisicas/todas/$personId/compliance': {
      id: '/_app/pessoas-fisicas/todas/$personId/compliance'
      path: '/pessoas-fisicas/todas/$personId/compliance'
      fullPath: '/pessoas-fisicas/todas/$personId/compliance'
      preLoaderRoute: typeof AppPessoasFisicasTodasPersonIdComplianceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pessoas-fisicas/todas/$personId/credito': {
      id: '/_app/pessoas-fisicas/todas/$personId/credito'
      path: '/pessoas-fisicas/todas/$personId/credito'
      fullPath: '/pessoas-fisicas/todas/$personId/credito'
      preLoaderRoute: typeof AppPessoasFisicasTodasPersonIdCreditoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pessoas-fisicas/todas/$personId/dados-bancarios': {
      id: '/_app/pessoas-fisicas/todas/$personId/dados-bancarios'
      path: '/pessoas-fisicas/todas/$personId/dados-bancarios'
      fullPath: '/pessoas-fisicas/todas/$personId/dados-bancarios'
      preLoaderRoute: typeof AppPessoasFisicasTodasPersonIdDadosBancariosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pessoas-fisicas/todas/$personId/documentos': {
      id: '/_app/pessoas-fisicas/todas/$personId/documentos'
      path: '/pessoas-fisicas/todas/$personId/documentos'
      fullPath: '/pessoas-fisicas/todas/$personId/documentos'
      preLoaderRoute: typeof AppPessoasFisicasTodasPersonIdDocumentosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pessoas-fisicas/todas/$personId/operacoes': {
      id: '/_app/pessoas-fisicas/todas/$personId/operacoes'
      path: '/pessoas-fisicas/todas/$personId/operacoes'
      fullPath: '/pessoas-fisicas/todas/$personId/operacoes'
      preLoaderRoute: typeof AppPessoasFisicasTodasPersonIdOperacoesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pessoas-juridicas/todas/$personId/': {
      id: '/_app/pessoas-juridicas/todas/$personId/'
      path: '/pessoas-juridicas/todas/$personId'
      fullPath: '/pessoas-juridicas/todas/$personId/'
      preLoaderRoute: typeof AppPessoasJuridicasTodasPersonIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pessoas-juridicas/todas/$personId/compliance': {
      id: '/_app/pessoas-juridicas/todas/$personId/compliance'
      path: '/pessoas-juridicas/todas/$personId/compliance'
      fullPath: '/pessoas-juridicas/todas/$personId/compliance'
      preLoaderRoute: typeof AppPessoasJuridicasTodasPersonIdComplianceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pessoas-juridicas/todas/$personId/credito': {
      id: '/_app/pessoas-juridicas/todas/$personId/credito'
      path: '/pessoas-juridicas/todas/$personId/credito'
      fullPath: '/pessoas-juridicas/todas/$personId/credito'
      preLoaderRoute: typeof AppPessoasJuridicasTodasPersonIdCreditoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pessoas-juridicas/todas/$personId/dados-bancarios': {
      id: '/_app/pessoas-juridicas/todas/$personId/dados-bancarios'
      path: '/pessoas-juridicas/todas/$personId/dados-bancarios'
      fullPath: '/pessoas-juridicas/todas/$personId/dados-bancarios'
      preLoaderRoute: typeof AppPessoasJuridicasTodasPersonIdDadosBancariosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pessoas-juridicas/todas/$personId/documentos': {
      id: '/_app/pessoas-juridicas/todas/$personId/documentos'
      path: '/pessoas-juridicas/todas/$personId/documentos'
      fullPath: '/pessoas-juridicas/todas/$personId/documentos'
      preLoaderRoute: typeof AppPessoasJuridicasTodasPersonIdDocumentosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pessoas-juridicas/todas/$personId/operacoes': {
      id: '/_app/pessoas-juridicas/todas/$personId/operacoes'
      path: '/pessoas-juridicas/todas/$personId/operacoes'
      fullPath: '/pessoas-juridicas/todas/$personId/operacoes'
      preLoaderRoute: typeof AppPessoasJuridicasTodasPersonIdOperacoesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/pessoas-juridicas/todas/$personId/signatarios': {
      id: '/_app/pessoas-juridicas/todas/$personId/signatarios'
      path: '/pessoas-juridicas/todas/$personId/signatarios'
      fullPath: '/pessoas-juridicas/todas/$personId/signatarios'
      preLoaderRoute: typeof AppPessoasJuridicasTodasPersonIdSignatariosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/seguranca/grupos/$groupId/': {
      id: '/_app/seguranca/grupos/$groupId/'
      path: '/seguranca/grupos/$groupId'
      fullPath: '/seguranca/grupos/$groupId/'
      preLoaderRoute: typeof AppSegurancaGruposGroupIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/seguranca/grupos/$groupId/membros': {
      id: '/_app/seguranca/grupos/$groupId/membros'
      path: '/seguranca/grupos/$groupId/membros'
      fullPath: '/seguranca/grupos/$groupId/membros'
      preLoaderRoute: typeof AppSegurancaGruposGroupIdMembrosRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/seguranca/grupos/$groupId/permissoes': {
      id: '/_app/seguranca/grupos/$groupId/permissoes'
      path: '/seguranca/grupos/$groupId/permissoes'
      fullPath: '/seguranca/grupos/$groupId/permissoes'
      preLoaderRoute: typeof AppSegurancaGruposGroupIdPermissoesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/seguranca/recursos-correspondente/$id/': {
      id: '/_app/seguranca/recursos-correspondente/$id/'
      path: '/seguranca/recursos-correspondente/$id'
      fullPath: '/seguranca/recursos-correspondente/$id/'
      preLoaderRoute: typeof AppSegurancaRecursosCorrespondenteIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/seguranca/usuarios-aplicacao/$aplicacaoId/': {
      id: '/_app/seguranca/usuarios-aplicacao/$aplicacaoId/'
      path: '/seguranca/usuarios-aplicacao/$aplicacaoId'
      fullPath: '/seguranca/usuarios-aplicacao/$aplicacaoId/'
      preLoaderRoute: typeof AppSegurancaUsuariosAplicacaoAplicacaoIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/seguranca/usuarios/$userId/': {
      id: '/_app/seguranca/usuarios/$userId/'
      path: '/seguranca/usuarios/$userId'
      fullPath: '/seguranca/usuarios/$userId/'
      preLoaderRoute: typeof AppSegurancaUsuariosUserIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/seguranca/usuarios/$userId/grupos': {
      id: '/_app/seguranca/usuarios/$userId/grupos'
      path: '/seguranca/usuarios/$userId/grupos'
      fullPath: '/seguranca/usuarios/$userId/grupos'
      preLoaderRoute: typeof AppSegurancaUsuariosUserIdGruposRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/seguranca/usuarios/$userId/permissoes': {
      id: '/_app/seguranca/usuarios/$userId/permissoes'
      path: '/seguranca/usuarios/$userId/permissoes'
      fullPath: '/seguranca/usuarios/$userId/permissoes'
      preLoaderRoute: typeof AppSegurancaUsuariosUserIdPermissoesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/cadastro/configuracao-regras/$ruleId/produtos/': {
      id: '/_app/cadastro/configuracao-regras/$ruleId/produtos/'
      path: '/cadastro/configuracao-regras/$ruleId/produtos'
      fullPath: '/cadastro/configuracao-regras/$ruleId/produtos/'
      preLoaderRoute: typeof AppCadastroConfiguracaoRegrasRuleIdProdutosIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/ccb/contratar/consignado-inss/novo/': {
      id: '/_app/ccb/contratar/consignado-inss/novo/'
      path: '/consignado-inss/novo'
      fullPath: '/ccb/contratar/consignado-inss/novo/'
      preLoaderRoute: typeof AppCcbContratarConsignadoInssNovoIndexRouteImport
      parentRoute: typeof AppCcbContratarRouteRoute
    }
    '/_app/ccb/contratar/consignado-inss/refinanciamento/': {
      id: '/_app/ccb/contratar/consignado-inss/refinanciamento/'
      path: '/consignado-inss/refinanciamento'
      fullPath: '/ccb/contratar/consignado-inss/refinanciamento/'
      preLoaderRoute: typeof AppCcbContratarConsignadoInssRefinanciamentoIndexRouteImport
      parentRoute: typeof AppCcbContratarRouteRoute
    }
    '/_app/ccb/contratar/consignado-privado/novo/': {
      id: '/_app/ccb/contratar/consignado-privado/novo/'
      path: '/consignado-privado/novo'
      fullPath: '/ccb/contratar/consignado-privado/novo/'
      preLoaderRoute: typeof AppCcbContratarConsignadoPrivadoNovoIndexRouteImport
      parentRoute: typeof AppCcbContratarRouteRoute
    }
    '/_app/ccb/contratar/consignado-privado/refinanciamento/': {
      id: '/_app/ccb/contratar/consignado-privado/refinanciamento/'
      path: '/consignado-privado/refinanciamento'
      fullPath: '/ccb/contratar/consignado-privado/refinanciamento/'
      preLoaderRoute: typeof AppCcbContratarConsignadoPrivadoRefinanciamentoIndexRouteImport
      parentRoute: typeof AppCcbContratarRouteRoute
    }
    '/_app/ccb/contratar/consignado-publico/novo-compra-de-divida/': {
      id: '/_app/ccb/contratar/consignado-publico/novo-compra-de-divida/'
      path: '/consignado-publico/novo-compra-de-divida'
      fullPath: '/ccb/contratar/consignado-publico/novo-compra-de-divida/'
      preLoaderRoute: typeof AppCcbContratarConsignadoPublicoNovoCompraDeDividaIndexRouteImport
      parentRoute: typeof AppCcbContratarRouteRoute
    }
    '/_app/ccb/contratar/consignado-publico/novo/': {
      id: '/_app/ccb/contratar/consignado-publico/novo/'
      path: '/consignado-publico/novo'
      fullPath: '/ccb/contratar/consignado-publico/novo/'
      preLoaderRoute: typeof AppCcbContratarConsignadoPublicoNovoIndexRouteImport
      parentRoute: typeof AppCcbContratarRouteRoute
    }
    '/_app/ccb/contratar/consignado-publico/refinanciamento/': {
      id: '/_app/ccb/contratar/consignado-publico/refinanciamento/'
      path: '/consignado-publico/refinanciamento'
      fullPath: '/ccb/contratar/consignado-publico/refinanciamento/'
      preLoaderRoute: typeof AppCcbContratarConsignadoPublicoRefinanciamentoIndexRouteImport
      parentRoute: typeof AppCcbContratarRouteRoute
    }
    '/_app/ccb/contratar/veiculo/car-equity/': {
      id: '/_app/ccb/contratar/veiculo/car-equity/'
      path: '/veiculo/car-equity'
      fullPath: '/ccb/contratar/veiculo/car-equity/'
      preLoaderRoute: typeof AppCcbContratarVeiculoCarEquityIndexRouteImport
      parentRoute: typeof AppCcbContratarRouteRoute
    }
    '/_app/ccb/contratar/veiculo/financiamento/': {
      id: '/_app/ccb/contratar/veiculo/financiamento/'
      path: '/veiculo/financiamento'
      fullPath: '/ccb/contratar/veiculo/financiamento/'
      preLoaderRoute: typeof AppCcbContratarVeiculoFinanciamentoIndexRouteImport
      parentRoute: typeof AppCcbContratarRouteRoute
    }
    '/_app/contas-digitais/contas/$bankAccountId/pix/gerenciar-chaves': {
      id: '/_app/contas-digitais/contas/$bankAccountId/pix/gerenciar-chaves'
      path: '/contas-digitais/contas/$bankAccountId/pix/gerenciar-chaves'
      fullPath: '/contas-digitais/contas/$bankAccountId/pix/gerenciar-chaves'
      preLoaderRoute: typeof AppContasDigitaisContasBankAccountIdPixGerenciarChavesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/contas/$bankAccountId/visualizar/': {
      id: '/_app/contas-digitais/contas/$bankAccountId/visualizar/'
      path: '/contas-digitais/contas/$bankAccountId/visualizar'
      fullPath: '/contas-digitais/contas/$bankAccountId/visualizar/'
      preLoaderRoute: typeof AppContasDigitaisContasBankAccountIdVisualizarIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/contas/$bankAccountId/visualizar/$tab': {
      id: '/_app/contas-digitais/contas/$bankAccountId/visualizar/$tab'
      path: '/contas-digitais/contas/$bankAccountId/visualizar/$tab'
      fullPath: '/contas-digitais/contas/$bankAccountId/visualizar/$tab'
      preLoaderRoute: typeof AppContasDigitaisContasBankAccountIdVisualizarTabRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/carteiras/arquivos/$fileId/remessa': {
      id: '/_app/gestao-carteira/carteiras/arquivos/$fileId/remessa'
      path: '/gestao-carteira/carteiras/arquivos/$fileId/remessa'
      fullPath: '/gestao-carteira/carteiras/arquivos/$fileId/remessa'
      preLoaderRoute: typeof AppGestaoCarteiraCarteirasArquivosFileIdRemessaRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/carteiras/arquivos/$fileId/retorno': {
      id: '/_app/gestao-carteira/carteiras/arquivos/$fileId/retorno'
      path: '/gestao-carteira/carteiras/arquivos/$fileId/retorno'
      fullPath: '/gestao-carteira/carteiras/arquivos/$fileId/retorno'
      preLoaderRoute: typeof AppGestaoCarteiraCarteirasArquivosFileIdRetornoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/conciliacao/dataprev/$conciliationId/': {
      id: '/_app/gestao-carteira/conciliacao/dataprev/$conciliationId/'
      path: '/gestao-carteira/conciliacao/dataprev/$conciliationId'
      fullPath: '/gestao-carteira/conciliacao/dataprev/$conciliationId/'
      preLoaderRoute: typeof AppGestaoCarteiraConciliacaoDataprevConciliationIdIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/conciliacao/dataprev/$conciliationId/historico': {
      id: '/_app/gestao-carteira/conciliacao/dataprev/$conciliationId/historico'
      path: '/gestao-carteira/conciliacao/dataprev/$conciliationId/historico'
      fullPath: '/gestao-carteira/conciliacao/dataprev/$conciliationId/historico'
      preLoaderRoute: typeof AppGestaoCarteiraConciliacaoDataprevConciliationIdHistoricoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/conciliacao/dataprev/$conciliationId/inconsistencias': {
      id: '/_app/gestao-carteira/conciliacao/dataprev/$conciliationId/inconsistencias'
      path: '/gestao-carteira/conciliacao/dataprev/$conciliationId/inconsistencias'
      fullPath: '/gestao-carteira/conciliacao/dataprev/$conciliationId/inconsistencias'
      preLoaderRoute: typeof AppGestaoCarteiraConciliacaoDataprevConciliationIdInconsistenciasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/conciliacao/dataprev/$conciliationId/linha-de-repasse': {
      id: '/_app/gestao-carteira/conciliacao/dataprev/$conciliationId/linha-de-repasse'
      path: '/gestao-carteira/conciliacao/dataprev/$conciliationId/linha-de-repasse'
      fullPath: '/gestao-carteira/conciliacao/dataprev/$conciliationId/linha-de-repasse'
      preLoaderRoute: typeof AppGestaoCarteiraConciliacaoDataprevConciliationIdLinhaDeRepasseRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/conciliacao/dataprev/$conciliationId/nao-encerradas': {
      id: '/_app/gestao-carteira/conciliacao/dataprev/$conciliationId/nao-encerradas'
      path: '/gestao-carteira/conciliacao/dataprev/$conciliationId/nao-encerradas'
      fullPath: '/gestao-carteira/conciliacao/dataprev/$conciliationId/nao-encerradas'
      preLoaderRoute: typeof AppGestaoCarteiraConciliacaoDataprevConciliationIdNaoEncerradasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/conciliacao/dataprev/bolsao/': {
      id: '/_app/gestao-carteira/conciliacao/dataprev/bolsao/'
      path: '/gestao-carteira/conciliacao/dataprev/bolsao'
      fullPath: '/gestao-carteira/conciliacao/dataprev/bolsao/'
      preLoaderRoute: typeof AppGestaoCarteiraConciliacaoDataprevBolsaoIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/gestao-carteira/conciliacao/dataprev/bolsao/$id': {
      id: '/_app/gestao-carteira/conciliacao/dataprev/bolsao/$id'
      path: '/gestao-carteira/conciliacao/dataprev/bolsao/$id'
      fullPath: '/gestao-carteira/conciliacao/dataprev/bolsao/$id'
      preLoaderRoute: typeof AppGestaoCarteiraConciliacaoDataprevBolsaoIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/': {
      id: '/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/'
      path: '/contas-digitais/contas/$bankAccountId/pix/pix-automatico'
      fullPath: '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/'
      preLoaderRoute: typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/ativas': {
      id: '/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/ativas'
      path: '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/ativas'
      fullPath: '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/ativas'
      preLoaderRoute: typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoAtivasRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/historico': {
      id: '/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/historico'
      path: '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/historico'
      fullPath: '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/historico'
      preLoaderRoute: typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoHistoricoRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/pendentes': {
      id: '/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/pendentes'
      path: '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/pendentes'
      fullPath: '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/pendentes'
      preLoaderRoute: typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoPendentesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/contas/$bankAccountId/pix/pix-med/': {
      id: '/_app/contas-digitais/contas/$bankAccountId/pix/pix-med/'
      path: '/contas-digitais/contas/$bankAccountId/pix/pix-med'
      fullPath: '/contas-digitais/contas/$bankAccountId/pix/pix-med/'
      preLoaderRoute: typeof AppContasDigitaisContasBankAccountIdPixPixMedIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/contas/$bankAccountId/pix/pix-med/consultar': {
      id: '/_app/contas-digitais/contas/$bankAccountId/pix/pix-med/consultar'
      path: '/contas-digitais/contas/$bankAccountId/pix/pix-med/consultar'
      fullPath: '/contas-digitais/contas/$bankAccountId/pix/pix-med/consultar'
      preLoaderRoute: typeof AppContasDigitaisContasBankAccountIdPixPixMedConsultarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/contas/$bankAccountId/pix/pix-med/contestar': {
      id: '/_app/contas-digitais/contas/$bankAccountId/pix/pix-med/contestar'
      path: '/contas-digitais/contas/$bankAccountId/pix/pix-med/contestar'
      fullPath: '/contas-digitais/contas/$bankAccountId/pix/pix-med/contestar'
      preLoaderRoute: typeof AppContasDigitaisContasBankAccountIdPixPixMedContestarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/contas/$bankAccountId/pix/pix-med/informacoes': {
      id: '/_app/contas-digitais/contas/$bankAccountId/pix/pix-med/informacoes'
      path: '/contas-digitais/contas/$bankAccountId/pix/pix-med/informacoes'
      fullPath: '/contas-digitais/contas/$bankAccountId/pix/pix-med/informacoes'
      preLoaderRoute: typeof AppContasDigitaisContasBankAccountIdPixPixMedInformacoesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados/': {
      id: '/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados/'
      path: '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados'
      fullPath: '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados/'
      preLoaderRoute: typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoAgendadosIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados/realizados': {
      id: '/_app/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados/realizados'
      path: '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados/realizados'
      fullPath: '/contas-digitais/contas/$bankAccountId/pix/pix-automatico/agendados/realizados'
      preLoaderRoute: typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoAgendadosRealizadosRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface LoginRouteRouteChildren {
  LoginAlterarSenhaRoute: typeof LoginAlterarSenhaRoute
  LoginConfirmarEmailRoute: typeof LoginConfirmarEmailRoute
  LoginConfirmarSenhaRoute: typeof LoginConfirmarSenhaRoute
  LoginLogoutRoute: typeof LoginLogoutRoute
  LoginRecuperarSenhaRoute: typeof LoginRecuperarSenhaRoute
  LoginIndexRoute: typeof LoginIndexRoute
  LoginMfaSetupRoute: typeof LoginMfaSetupRoute
  LoginMfaIndexRoute: typeof LoginMfaIndexRoute
}

const LoginRouteRouteChildren: LoginRouteRouteChildren = {
  LoginAlterarSenhaRoute: LoginAlterarSenhaRoute,
  LoginConfirmarEmailRoute: LoginConfirmarEmailRoute,
  LoginConfirmarSenhaRoute: LoginConfirmarSenhaRoute,
  LoginLogoutRoute: LoginLogoutRoute,
  LoginRecuperarSenhaRoute: LoginRecuperarSenhaRoute,
  LoginIndexRoute: LoginIndexRoute,
  LoginMfaSetupRoute: LoginMfaSetupRoute,
  LoginMfaIndexRoute: LoginMfaIndexRoute,
}

const LoginRouteRouteWithChildren = LoginRouteRoute._addFileChildren(
  LoginRouteRouteChildren,
)

interface AppMeuPerfilRouteRouteChildren {
  AppMeuPerfilIndexRoute: typeof AppMeuPerfilIndexRoute
  AppMeuPerfilConfiguracoesIndexRoute: typeof AppMeuPerfilConfiguracoesIndexRoute
  AppMeuPerfilPermissoesEfetivasIndexRoute: typeof AppMeuPerfilPermissoesEfetivasIndexRoute
}

const AppMeuPerfilRouteRouteChildren: AppMeuPerfilRouteRouteChildren = {
  AppMeuPerfilIndexRoute: AppMeuPerfilIndexRoute,
  AppMeuPerfilConfiguracoesIndexRoute: AppMeuPerfilConfiguracoesIndexRoute,
  AppMeuPerfilPermissoesEfetivasIndexRoute:
    AppMeuPerfilPermissoesEfetivasIndexRoute,
}

const AppMeuPerfilRouteRouteWithChildren =
  AppMeuPerfilRouteRoute._addFileChildren(AppMeuPerfilRouteRouteChildren)

interface AppCcbContratarRouteRouteChildren {
  AppCcbContratarSplatRoute: typeof AppCcbContratarSplatRoute
  AppCcbContratarIndexRoute: typeof AppCcbContratarIndexRoute
  AppCcbContratarConsignadoInssIndexRoute: typeof AppCcbContratarConsignadoInssIndexRoute
  AppCcbContratarConsignadoPrivadoCdcIndexRoute: typeof AppCcbContratarConsignadoPrivadoCdcIndexRoute
  AppCcbContratarConsignadoPrivadoIndexRoute: typeof AppCcbContratarConsignadoPrivadoIndexRoute
  AppCcbContratarConsignadoPublicoIndexRoute: typeof AppCcbContratarConsignadoPublicoIndexRoute
  AppCcbContratarCreditoPessoalIndexRoute: typeof AppCcbContratarCreditoPessoalIndexRoute
  AppCcbContratarVeiculoIndexRoute: typeof AppCcbContratarVeiculoIndexRoute
  AppCcbContratarConsignadoInssNovoIndexRoute: typeof AppCcbContratarConsignadoInssNovoIndexRoute
  AppCcbContratarConsignadoInssRefinanciamentoIndexRoute: typeof AppCcbContratarConsignadoInssRefinanciamentoIndexRoute
  AppCcbContratarConsignadoPrivadoNovoIndexRoute: typeof AppCcbContratarConsignadoPrivadoNovoIndexRoute
  AppCcbContratarConsignadoPrivadoRefinanciamentoIndexRoute: typeof AppCcbContratarConsignadoPrivadoRefinanciamentoIndexRoute
  AppCcbContratarConsignadoPublicoNovoCompraDeDividaIndexRoute: typeof AppCcbContratarConsignadoPublicoNovoCompraDeDividaIndexRoute
  AppCcbContratarConsignadoPublicoNovoIndexRoute: typeof AppCcbContratarConsignadoPublicoNovoIndexRoute
  AppCcbContratarConsignadoPublicoRefinanciamentoIndexRoute: typeof AppCcbContratarConsignadoPublicoRefinanciamentoIndexRoute
  AppCcbContratarVeiculoCarEquityIndexRoute: typeof AppCcbContratarVeiculoCarEquityIndexRoute
  AppCcbContratarVeiculoFinanciamentoIndexRoute: typeof AppCcbContratarVeiculoFinanciamentoIndexRoute
}

const AppCcbContratarRouteRouteChildren: AppCcbContratarRouteRouteChildren = {
  AppCcbContratarSplatRoute: AppCcbContratarSplatRoute,
  AppCcbContratarIndexRoute: AppCcbContratarIndexRoute,
  AppCcbContratarConsignadoInssIndexRoute:
    AppCcbContratarConsignadoInssIndexRoute,
  AppCcbContratarConsignadoPrivadoCdcIndexRoute:
    AppCcbContratarConsignadoPrivadoCdcIndexRoute,
  AppCcbContratarConsignadoPrivadoIndexRoute:
    AppCcbContratarConsignadoPrivadoIndexRoute,
  AppCcbContratarConsignadoPublicoIndexRoute:
    AppCcbContratarConsignadoPublicoIndexRoute,
  AppCcbContratarCreditoPessoalIndexRoute:
    AppCcbContratarCreditoPessoalIndexRoute,
  AppCcbContratarVeiculoIndexRoute: AppCcbContratarVeiculoIndexRoute,
  AppCcbContratarConsignadoInssNovoIndexRoute:
    AppCcbContratarConsignadoInssNovoIndexRoute,
  AppCcbContratarConsignadoInssRefinanciamentoIndexRoute:
    AppCcbContratarConsignadoInssRefinanciamentoIndexRoute,
  AppCcbContratarConsignadoPrivadoNovoIndexRoute:
    AppCcbContratarConsignadoPrivadoNovoIndexRoute,
  AppCcbContratarConsignadoPrivadoRefinanciamentoIndexRoute:
    AppCcbContratarConsignadoPrivadoRefinanciamentoIndexRoute,
  AppCcbContratarConsignadoPublicoNovoCompraDeDividaIndexRoute:
    AppCcbContratarConsignadoPublicoNovoCompraDeDividaIndexRoute,
  AppCcbContratarConsignadoPublicoNovoIndexRoute:
    AppCcbContratarConsignadoPublicoNovoIndexRoute,
  AppCcbContratarConsignadoPublicoRefinanciamentoIndexRoute:
    AppCcbContratarConsignadoPublicoRefinanciamentoIndexRoute,
  AppCcbContratarVeiculoCarEquityIndexRoute:
    AppCcbContratarVeiculoCarEquityIndexRoute,
  AppCcbContratarVeiculoFinanciamentoIndexRoute:
    AppCcbContratarVeiculoFinanciamentoIndexRoute,
}

const AppCcbContratarRouteRouteWithChildren =
  AppCcbContratarRouteRoute._addFileChildren(AppCcbContratarRouteRouteChildren)

interface AppRouteChildren {
  AppMeuPerfilRouteRoute: typeof AppMeuPerfilRouteRouteWithChildren
  AppEmConstrucaoRoute: typeof AppEmConstrucaoRoute
  AppLegadoIndisponivelRoute: typeof AppLegadoIndisponivelRoute
  AppIndexRoute: typeof AppIndexRoute
  AppCcbContratarRouteRoute: typeof AppCcbContratarRouteRouteWithChildren
  AppAprovacoesIndexRoute: typeof AppAprovacoesIndexRoute
  AppChatbotIndexRoute: typeof AppChatbotIndexRoute
  AppConcilicaoIndexRoute: typeof AppConcilicaoIndexRoute
  AppDashboardIndexRoute: typeof AppDashboardIndexRoute
  AppGestaoCarteiraIndexRoute: typeof AppGestaoCarteiraIndexRoute
  AppPessoasFisicasIndexRoute: typeof AppPessoasFisicasIndexRoute
  AppPessoasJuridicasIndexRoute: typeof AppPessoasJuridicasIndexRoute
  AppSegurancaIndexRoute: typeof AppSegurancaIndexRoute
  AppAprovacoesGestaoAprovacoesInternetBankingRoute: typeof AppAprovacoesGestaoAprovacoesInternetBankingRoute
  AppAprovacoesGestaoAprovacoesOperacoesRoute: typeof AppAprovacoesGestaoAprovacoesOperacoesRoute
  AppAprovacoesGestaoAprovacoesOperadoresRoute: typeof AppAprovacoesGestaoAprovacoesOperadoresRoute
  AppAprovacoesGestaoAprovacoesSolicitacoesRoute: typeof AppAprovacoesGestaoAprovacoesSolicitacoesRoute
  AppCcbCessoesNovaRoute: typeof AppCcbCessoesNovaRoute
  AppCcbOperacoesCreditNoteIdRoute: typeof AppCcbOperacoesCreditNoteIdRoute
  AppCcbOperacoesNovaRoute: typeof AppCcbOperacoesNovaRoute
  AppGestaoCarteiraCobrancasBillingIdRoute: typeof AppGestaoCarteiraCobrancasBillingIdRoute
  AppGestaoCarteiraParcelamentosInstallmentIdRoute: typeof AppGestaoCarteiraParcelamentosInstallmentIdRoute
  AppGestaoCarteiraRecuperacaoFilaRoute: typeof AppGestaoCarteiraRecuperacaoFilaRoute
  AppAprovacoesGestaoAprovacoesIndexRoute: typeof AppAprovacoesGestaoAprovacoesIndexRoute
  AppCadastroConfiguracaoRegrasIndexRoute: typeof AppCadastroConfiguracaoRegrasIndexRoute
  AppCadastroConveniosIndexRoute: typeof AppCadastroConveniosIndexRoute
  AppCadastroFundosIndexRoute: typeof AppCadastroFundosIndexRoute
  AppCadastroGestaoIndexRoute: typeof AppCadastroGestaoIndexRoute
  AppCadastroProdutosContaIndexRoute: typeof AppCadastroProdutosContaIndexRoute
  AppCadastroProdutosCreditoIndexRoute: typeof AppCadastroProdutosCreditoIndexRoute
  AppCadastroProdutosLiquidacaoAutomaticaIndexRoute: typeof AppCadastroProdutosLiquidacaoAutomaticaIndexRoute
  AppCadastroRegrasDinamicasIndexRoute: typeof AppCadastroRegrasDinamicasIndexRoute
  AppCcbCessoesIndexRoute: typeof AppCcbCessoesIndexRoute
  AppCcbCriarCpfTesteIndexRoute: typeof AppCcbCriarCpfTesteIndexRoute
  AppCcbDescontoIndexRoute: typeof AppCcbDescontoIndexRoute
  AppCcbExcluidosIndexRoute: typeof AppCcbExcluidosIndexRoute
  AppCcbExcluirAutorizacaoIndexRoute: typeof AppCcbExcluirAutorizacaoIndexRoute
  AppCcbGestaoAutorizacoesIndexRoute: typeof AppCcbGestaoAutorizacoesIndexRoute
  AppCcbOperacoesIndexRoute: typeof AppCcbOperacoesIndexRoute
  AppCcbSimularIndexRoute: typeof AppCcbSimularIndexRoute
  AppChatbotIdIndexRoute: typeof AppChatbotIdIndexRoute
  AppChatbotRelatoriosIndexRoute: typeof AppChatbotRelatoriosIndexRoute
  AppConcilicaoFgtsIndexRoute: typeof AppConcilicaoFgtsIndexRoute
  AppContasDigitaisContasIndexRoute: typeof AppContasDigitaisContasIndexRoute
  AppContasDigitaisGestaoSpiIndexRoute: typeof AppContasDigitaisGestaoSpiIndexRoute
  AppContasDigitaisPixMedAdminIndexRoute: typeof AppContasDigitaisPixMedAdminIndexRoute
  AppContasDigitaisSolicitacoesIndexRoute: typeof AppContasDigitaisSolicitacoesIndexRoute
  AppContasDigitaisSplitAutomaticoIndexRoute: typeof AppContasDigitaisSplitAutomaticoIndexRoute
  AppGestaoCarteiraCarteirasIndexRoute: typeof AppGestaoCarteiraCarteirasIndexRoute
  AppGestaoCarteiraCobrancasIndexRoute: typeof AppGestaoCarteiraCobrancasIndexRoute
  AppGestaoCarteiraConciliacaoIndexRoute: typeof AppGestaoCarteiraConciliacaoIndexRoute
  AppGestaoCarteiraDashboardIndexRoute: typeof AppGestaoCarteiraDashboardIndexRoute
  AppGestaoCarteiraExecucaoGarantiasIndexRoute: typeof AppGestaoCarteiraExecucaoGarantiasIndexRoute
  AppGestaoCarteiraParametrosIndexRoute: typeof AppGestaoCarteiraParametrosIndexRoute
  AppGestaoCarteiraParcelamentosIndexRoute: typeof AppGestaoCarteiraParcelamentosIndexRoute
  AppGestaoCarteiraRecuperacaoIndexRoute: typeof AppGestaoCarteiraRecuperacaoIndexRoute
  AppGestaoCarteiraReguaIndexRoute: typeof AppGestaoCarteiraReguaIndexRoute
  AppParceirosSolicitacoesIndexRoute: typeof AppParceirosSolicitacoesIndexRoute
  AppPessoasFisicasPendentesIndexRoute: typeof AppPessoasFisicasPendentesIndexRoute
  AppPessoasFisicasTodasIndexRoute: typeof AppPessoasFisicasTodasIndexRoute
  AppPessoasJuridicasPendentesIndexRoute: typeof AppPessoasJuridicasPendentesIndexRoute
  AppPessoasJuridicasTodasIndexRoute: typeof AppPessoasJuridicasTodasIndexRoute
  AppSegurancaGruposIndexRoute: typeof AppSegurancaGruposIndexRoute
  AppSegurancaRecursosCorrespondenteIndexRoute: typeof AppSegurancaRecursosCorrespondenteIndexRoute
  AppSegurancaUsuariosAplicacaoIndexRoute: typeof AppSegurancaUsuariosAplicacaoIndexRoute
  AppSegurancaUsuariosIndexRoute: typeof AppSegurancaUsuariosIndexRoute
  AppCadastroFundosFundIdCessoesRoute: typeof AppCadastroFundosFundIdCessoesRoute
  AppCadastroFundosFundIdDocumentosRoute: typeof AppCadastroFundosFundIdDocumentosRoute
  AppCadastroFundosFundIdEnvolvidosRoute: typeof AppCadastroFundosFundIdEnvolvidosRoute
  AppCadastroGestaoProdutosCobrancaParametrosCustosRoute: typeof AppCadastroGestaoProdutosCobrancaParametrosCustosRoute
  AppCadastroProdutosContaProductIdDocumentosRoute: typeof AppCadastroProdutosContaProductIdDocumentosRoute
  AppCadastroProdutosContaProductIdEnvolvidosRoute: typeof AppCadastroProdutosContaProductIdEnvolvidosRoute
  AppCadastroProdutosCreditoProductIdCustoDeEmissaoRoute: typeof AppCadastroProdutosCreditoProductIdCustoDeEmissaoRoute
  AppCadastroProdutosCreditoProductIdDocumentosRoute: typeof AppCadastroProdutosCreditoProductIdDocumentosRoute
  AppCadastroProdutosCreditoProductIdDocumentosParaAssinaturaRoute: typeof AppCadastroProdutosCreditoProductIdDocumentosParaAssinaturaRoute
  AppCadastroProdutosCreditoProductIdEnvolvidosRoute: typeof AppCadastroProdutosCreditoProductIdEnvolvidosRoute
  AppCadastroProdutosCreditoProductIdOrgaoRoute: typeof AppCadastroProdutosCreditoProductIdOrgaoRoute
  AppCadastroProdutosCreditoProductIdTemplatesRoute: typeof AppCadastroProdutosCreditoProductIdTemplatesRoute
  AppCcbCessoesBatchAssignmentIdDocumentosRoute: typeof AppCcbCessoesBatchAssignmentIdDocumentosRoute
  AppCcbCessoesBatchAssignmentIdHistoricoRoute: typeof AppCcbCessoesBatchAssignmentIdHistoricoRoute
  AppCcbCessoesBatchAssignmentIdOperacoesRoute: typeof AppCcbCessoesBatchAssignmentIdOperacoesRoute
  AppCcbCessoesBatchAssignmentIdParcelasRoute: typeof AppCcbCessoesBatchAssignmentIdParcelasRoute
  AppContasDigitaisContasBankAccountIdTabRoute: typeof AppContasDigitaisContasBankAccountIdTabRoute
  AppContasDigitaisSolicitacoesBankAccountIdAcessosConcedidosRoute: typeof AppContasDigitaisSolicitacoesBankAccountIdAcessosConcedidosRoute
  AppContasDigitaisSolicitacoesBankAccountIdDocumentosRoute: typeof AppContasDigitaisSolicitacoesBankAccountIdDocumentosRoute
  AppContasDigitaisSolicitacoesBankAccountIdEnvolvidosRoute: typeof AppContasDigitaisSolicitacoesBankAccountIdEnvolvidosRoute
  AppContasDigitaisSolicitacoesBankAccountIdHistoricoRoute: typeof AppContasDigitaisSolicitacoesBankAccountIdHistoricoRoute
  AppContasDigitaisSolicitacoesBankAccountIdKycRoute: typeof AppContasDigitaisSolicitacoesBankAccountIdKycRoute
  AppContasDigitaisSplitAutomaticoOperationIdDetalhesRoute: typeof AppContasDigitaisSplitAutomaticoOperationIdDetalhesRoute
  AppGestaoCarteiraCarteirasWalletIdArquivosRemessaRoute: typeof AppGestaoCarteiraCarteirasWalletIdArquivosRemessaRoute
  AppGestaoCarteiraCarteirasWalletIdArquivosRetornoRoute: typeof AppGestaoCarteiraCarteirasWalletIdArquivosRetornoRoute
  AppGestaoCarteiraCarteirasWalletIdTarifasConvenioRoute: typeof AppGestaoCarteiraCarteirasWalletIdTarifasConvenioRoute
  AppGestaoCarteiraConciliacaoDataprevNovaConciliacaoRoute: typeof AppGestaoCarteiraConciliacaoDataprevNovaConciliacaoRoute
  AppGestaoCarteiraRecuperacaoAcordosAgreementIdRoute: typeof AppGestaoCarteiraRecuperacaoAcordosAgreementIdRoute
  AppGestaoCarteiraRecuperacaoDevedorInstallmentIdRoute: typeof AppGestaoCarteiraRecuperacaoDevedorInstallmentIdRoute
  AppPessoasFisicasTodasPersonIdComplianceRoute: typeof AppPessoasFisicasTodasPersonIdComplianceRoute
  AppPessoasFisicasTodasPersonIdCreditoRoute: typeof AppPessoasFisicasTodasPersonIdCreditoRoute
  AppPessoasFisicasTodasPersonIdDadosBancariosRoute: typeof AppPessoasFisicasTodasPersonIdDadosBancariosRoute
  AppPessoasFisicasTodasPersonIdDocumentosRoute: typeof AppPessoasFisicasTodasPersonIdDocumentosRoute
  AppPessoasFisicasTodasPersonIdOperacoesRoute: typeof AppPessoasFisicasTodasPersonIdOperacoesRoute
  AppPessoasJuridicasTodasPersonIdComplianceRoute: typeof AppPessoasJuridicasTodasPersonIdComplianceRoute
  AppPessoasJuridicasTodasPersonIdCreditoRoute: typeof AppPessoasJuridicasTodasPersonIdCreditoRoute
  AppPessoasJuridicasTodasPersonIdDadosBancariosRoute: typeof AppPessoasJuridicasTodasPersonIdDadosBancariosRoute
  AppPessoasJuridicasTodasPersonIdDocumentosRoute: typeof AppPessoasJuridicasTodasPersonIdDocumentosRoute
  AppPessoasJuridicasTodasPersonIdOperacoesRoute: typeof AppPessoasJuridicasTodasPersonIdOperacoesRoute
  AppPessoasJuridicasTodasPersonIdSignatariosRoute: typeof AppPessoasJuridicasTodasPersonIdSignatariosRoute
  AppSegurancaGruposGroupIdMembrosRoute: typeof AppSegurancaGruposGroupIdMembrosRoute
  AppSegurancaGruposGroupIdPermissoesRoute: typeof AppSegurancaGruposGroupIdPermissoesRoute
  AppSegurancaUsuariosUserIdGruposRoute: typeof AppSegurancaUsuariosUserIdGruposRoute
  AppSegurancaUsuariosUserIdPermissoesRoute: typeof AppSegurancaUsuariosUserIdPermissoesRoute
  AppCadastroConfiguracaoRegrasRuleIdIndexRoute: typeof AppCadastroConfiguracaoRegrasRuleIdIndexRoute
  AppCadastroConveniosConvenioIdIndexRoute: typeof AppCadastroConveniosConvenioIdIndexRoute
  AppCadastroFundosFundIdIndexRoute: typeof AppCadastroFundosFundIdIndexRoute
  AppCadastroGestaoProdutosCobrancaIndexRoute: typeof AppCadastroGestaoProdutosCobrancaIndexRoute
  AppCadastroProdutosContaProductIdIndexRoute: typeof AppCadastroProdutosContaProductIdIndexRoute
  AppCadastroProdutosCreditoProductIdIndexRoute: typeof AppCadastroProdutosCreditoProductIdIndexRoute
  AppCadastroRegrasDinamicasRuleIdIndexRoute: typeof AppCadastroRegrasDinamicasRuleIdIndexRoute
  AppCadastroRegrasDinamicasSimularIndexRoute: typeof AppCadastroRegrasDinamicasSimularIndexRoute
  AppCcbCessoesBatchAssignmentIdIndexRoute: typeof AppCcbCessoesBatchAssignmentIdIndexRoute
  AppCcbCessoesSubmissoesDimensaIndexRoute: typeof AppCcbCessoesSubmissoesDimensaIndexRoute
  AppChatbotIdAtendimentoIndexRoute: typeof AppChatbotIdAtendimentoIndexRoute
  AppConcilicaoFgtsCalcularLiquidacaoAntecipadaIndexRoute: typeof AppConcilicaoFgtsCalcularLiquidacaoAntecipadaIndexRoute
  AppConcilicaoFgtsGerarArquivoLiquidacaoCaixaIndexRoute: typeof AppConcilicaoFgtsGerarArquivoLiquidacaoCaixaIndexRoute
  AppConcilicaoFgtsSiapeIndexRoute: typeof AppConcilicaoFgtsSiapeIndexRoute
  AppContasDigitaisContasBankAccountIdIndexRoute: typeof AppContasDigitaisContasBankAccountIdIndexRoute
  AppContasDigitaisGestaoSpiConsultasIndexRoute: typeof AppContasDigitaisGestaoSpiConsultasIndexRoute
  AppContasDigitaisSolicitacoesBankAccountIdIndexRoute: typeof AppContasDigitaisSolicitacoesBankAccountIdIndexRoute
  AppContasDigitaisSplitAutomaticoOperationIdIndexRoute: typeof AppContasDigitaisSplitAutomaticoOperationIdIndexRoute
  AppGestaoCarteiraCarteirasWalletIdIndexRoute: typeof AppGestaoCarteiraCarteirasWalletIdIndexRoute
  AppGestaoCarteiraConciliacaoDataprevIndexRoute: typeof AppGestaoCarteiraConciliacaoDataprevIndexRoute
  AppGestaoCarteiraRecuperacaoAcordosIndexRoute: typeof AppGestaoCarteiraRecuperacaoAcordosIndexRoute
  AppParceirosSolicitacoesIdIndexRoute: typeof AppParceirosSolicitacoesIdIndexRoute
  AppPessoasFisicasTodasPersonIdIndexRoute: typeof AppPessoasFisicasTodasPersonIdIndexRoute
  AppPessoasJuridicasTodasPersonIdIndexRoute: typeof AppPessoasJuridicasTodasPersonIdIndexRoute
  AppSegurancaGruposGroupIdIndexRoute: typeof AppSegurancaGruposGroupIdIndexRoute
  AppSegurancaRecursosCorrespondenteIdIndexRoute: typeof AppSegurancaRecursosCorrespondenteIdIndexRoute
  AppSegurancaUsuariosAplicacaoAplicacaoIdIndexRoute: typeof AppSegurancaUsuariosAplicacaoAplicacaoIdIndexRoute
  AppSegurancaUsuariosUserIdIndexRoute: typeof AppSegurancaUsuariosUserIdIndexRoute
  AppContasDigitaisContasBankAccountIdPixGerenciarChavesRoute: typeof AppContasDigitaisContasBankAccountIdPixGerenciarChavesRoute
  AppContasDigitaisContasBankAccountIdVisualizarTabRoute: typeof AppContasDigitaisContasBankAccountIdVisualizarTabRoute
  AppGestaoCarteiraCarteirasArquivosFileIdRemessaRoute: typeof AppGestaoCarteiraCarteirasArquivosFileIdRemessaRoute
  AppGestaoCarteiraCarteirasArquivosFileIdRetornoRoute: typeof AppGestaoCarteiraCarteirasArquivosFileIdRetornoRoute
  AppGestaoCarteiraConciliacaoDataprevConciliationIdHistoricoRoute: typeof AppGestaoCarteiraConciliacaoDataprevConciliationIdHistoricoRoute
  AppGestaoCarteiraConciliacaoDataprevConciliationIdInconsistenciasRoute: typeof AppGestaoCarteiraConciliacaoDataprevConciliationIdInconsistenciasRoute
  AppGestaoCarteiraConciliacaoDataprevConciliationIdLinhaDeRepasseRoute: typeof AppGestaoCarteiraConciliacaoDataprevConciliationIdLinhaDeRepasseRoute
  AppGestaoCarteiraConciliacaoDataprevConciliationIdNaoEncerradasRoute: typeof AppGestaoCarteiraConciliacaoDataprevConciliationIdNaoEncerradasRoute
  AppGestaoCarteiraConciliacaoDataprevBolsaoIdRoute: typeof AppGestaoCarteiraConciliacaoDataprevBolsaoIdRoute
  AppCadastroConfiguracaoRegrasRuleIdProdutosIndexRoute: typeof AppCadastroConfiguracaoRegrasRuleIdProdutosIndexRoute
  AppContasDigitaisContasBankAccountIdVisualizarIndexRoute: typeof AppContasDigitaisContasBankAccountIdVisualizarIndexRoute
  AppGestaoCarteiraConciliacaoDataprevConciliationIdIndexRoute: typeof AppGestaoCarteiraConciliacaoDataprevConciliationIdIndexRoute
  AppGestaoCarteiraConciliacaoDataprevBolsaoIndexRoute: typeof AppGestaoCarteiraConciliacaoDataprevBolsaoIndexRoute
  AppContasDigitaisContasBankAccountIdPixPixAutomaticoAtivasRoute: typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoAtivasRoute
  AppContasDigitaisContasBankAccountIdPixPixAutomaticoHistoricoRoute: typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoHistoricoRoute
  AppContasDigitaisContasBankAccountIdPixPixAutomaticoPendentesRoute: typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoPendentesRoute
  AppContasDigitaisContasBankAccountIdPixPixMedConsultarRoute: typeof AppContasDigitaisContasBankAccountIdPixPixMedConsultarRoute
  AppContasDigitaisContasBankAccountIdPixPixMedContestarRoute: typeof AppContasDigitaisContasBankAccountIdPixPixMedContestarRoute
  AppContasDigitaisContasBankAccountIdPixPixMedInformacoesRoute: typeof AppContasDigitaisContasBankAccountIdPixPixMedInformacoesRoute
  AppContasDigitaisContasBankAccountIdPixPixAutomaticoIndexRoute: typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoIndexRoute
  AppContasDigitaisContasBankAccountIdPixPixMedIndexRoute: typeof AppContasDigitaisContasBankAccountIdPixPixMedIndexRoute
  AppContasDigitaisContasBankAccountIdPixPixAutomaticoAgendadosRealizadosRoute: typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoAgendadosRealizadosRoute
  AppContasDigitaisContasBankAccountIdPixPixAutomaticoAgendadosIndexRoute: typeof AppContasDigitaisContasBankAccountIdPixPixAutomaticoAgendadosIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppMeuPerfilRouteRoute: AppMeuPerfilRouteRouteWithChildren,
  AppEmConstrucaoRoute: AppEmConstrucaoRoute,
  AppLegadoIndisponivelRoute: AppLegadoIndisponivelRoute,
  AppIndexRoute: AppIndexRoute,
  AppCcbContratarRouteRoute: AppCcbContratarRouteRouteWithChildren,
  AppAprovacoesIndexRoute: AppAprovacoesIndexRoute,
  AppChatbotIndexRoute: AppChatbotIndexRoute,
  AppConcilicaoIndexRoute: AppConcilicaoIndexRoute,
  AppDashboardIndexRoute: AppDashboardIndexRoute,
  AppGestaoCarteiraIndexRoute: AppGestaoCarteiraIndexRoute,
  AppPessoasFisicasIndexRoute: AppPessoasFisicasIndexRoute,
  AppPessoasJuridicasIndexRoute: AppPessoasJuridicasIndexRoute,
  AppSegurancaIndexRoute: AppSegurancaIndexRoute,
  AppAprovacoesGestaoAprovacoesInternetBankingRoute:
    AppAprovacoesGestaoAprovacoesInternetBankingRoute,
  AppAprovacoesGestaoAprovacoesOperacoesRoute:
    AppAprovacoesGestaoAprovacoesOperacoesRoute,
  AppAprovacoesGestaoAprovacoesOperadoresRoute:
    AppAprovacoesGestaoAprovacoesOperadoresRoute,
  AppAprovacoesGestaoAprovacoesSolicitacoesRoute:
    AppAprovacoesGestaoAprovacoesSolicitacoesRoute,
  AppCcbCessoesNovaRoute: AppCcbCessoesNovaRoute,
  AppCcbOperacoesCreditNoteIdRoute: AppCcbOperacoesCreditNoteIdRoute,
  AppCcbOperacoesNovaRoute: AppCcbOperacoesNovaRoute,
  AppGestaoCarteiraCobrancasBillingIdRoute:
    AppGestaoCarteiraCobrancasBillingIdRoute,
  AppGestaoCarteiraParcelamentosInstallmentIdRoute:
    AppGestaoCarteiraParcelamentosInstallmentIdRoute,
  AppGestaoCarteiraRecuperacaoFilaRoute: AppGestaoCarteiraRecuperacaoFilaRoute,
  AppAprovacoesGestaoAprovacoesIndexRoute:
    AppAprovacoesGestaoAprovacoesIndexRoute,
  AppCadastroConfiguracaoRegrasIndexRoute:
    AppCadastroConfiguracaoRegrasIndexRoute,
  AppCadastroConveniosIndexRoute: AppCadastroConveniosIndexRoute,
  AppCadastroFundosIndexRoute: AppCadastroFundosIndexRoute,
  AppCadastroGestaoIndexRoute: AppCadastroGestaoIndexRoute,
  AppCadastroProdutosContaIndexRoute: AppCadastroProdutosContaIndexRoute,
  AppCadastroProdutosCreditoIndexRoute: AppCadastroProdutosCreditoIndexRoute,
  AppCadastroProdutosLiquidacaoAutomaticaIndexRoute:
    AppCadastroProdutosLiquidacaoAutomaticaIndexRoute,
  AppCadastroRegrasDinamicasIndexRoute: AppCadastroRegrasDinamicasIndexRoute,
  AppCcbCessoesIndexRoute: AppCcbCessoesIndexRoute,
  AppCcbCriarCpfTesteIndexRoute: AppCcbCriarCpfTesteIndexRoute,
  AppCcbDescontoIndexRoute: AppCcbDescontoIndexRoute,
  AppCcbExcluidosIndexRoute: AppCcbExcluidosIndexRoute,
  AppCcbExcluirAutorizacaoIndexRoute: AppCcbExcluirAutorizacaoIndexRoute,
  AppCcbGestaoAutorizacoesIndexRoute: AppCcbGestaoAutorizacoesIndexRoute,
  AppCcbOperacoesIndexRoute: AppCcbOperacoesIndexRoute,
  AppCcbSimularIndexRoute: AppCcbSimularIndexRoute,
  AppChatbotIdIndexRoute: AppChatbotIdIndexRoute,
  AppChatbotRelatoriosIndexRoute: AppChatbotRelatoriosIndexRoute,
  AppConcilicaoFgtsIndexRoute: AppConcilicaoFgtsIndexRoute,
  AppContasDigitaisContasIndexRoute: AppContasDigitaisContasIndexRoute,
  AppContasDigitaisGestaoSpiIndexRoute: AppContasDigitaisGestaoSpiIndexRoute,
  AppContasDigitaisPixMedAdminIndexRoute:
    AppContasDigitaisPixMedAdminIndexRoute,
  AppContasDigitaisSolicitacoesIndexRoute:
    AppContasDigitaisSolicitacoesIndexRoute,
  AppContasDigitaisSplitAutomaticoIndexRoute:
    AppContasDigitaisSplitAutomaticoIndexRoute,
  AppGestaoCarteiraCarteirasIndexRoute: AppGestaoCarteiraCarteirasIndexRoute,
  AppGestaoCarteiraCobrancasIndexRoute: AppGestaoCarteiraCobrancasIndexRoute,
  AppGestaoCarteiraConciliacaoIndexRoute:
    AppGestaoCarteiraConciliacaoIndexRoute,
  AppGestaoCarteiraDashboardIndexRoute: AppGestaoCarteiraDashboardIndexRoute,
  AppGestaoCarteiraExecucaoGarantiasIndexRoute:
    AppGestaoCarteiraExecucaoGarantiasIndexRoute,
  AppGestaoCarteiraParametrosIndexRoute: AppGestaoCarteiraParametrosIndexRoute,
  AppGestaoCarteiraParcelamentosIndexRoute:
    AppGestaoCarteiraParcelamentosIndexRoute,
  AppGestaoCarteiraRecuperacaoIndexRoute:
    AppGestaoCarteiraRecuperacaoIndexRoute,
  AppGestaoCarteiraReguaIndexRoute: AppGestaoCarteiraReguaIndexRoute,
  AppParceirosSolicitacoesIndexRoute: AppParceirosSolicitacoesIndexRoute,
  AppPessoasFisicasPendentesIndexRoute: AppPessoasFisicasPendentesIndexRoute,
  AppPessoasFisicasTodasIndexRoute: AppPessoasFisicasTodasIndexRoute,
  AppPessoasJuridicasPendentesIndexRoute:
    AppPessoasJuridicasPendentesIndexRoute,
  AppPessoasJuridicasTodasIndexRoute: AppPessoasJuridicasTodasIndexRoute,
  AppSegurancaGruposIndexRoute: AppSegurancaGruposIndexRoute,
  AppSegurancaRecursosCorrespondenteIndexRoute:
    AppSegurancaRecursosCorrespondenteIndexRoute,
  AppSegurancaUsuariosAplicacaoIndexRoute:
    AppSegurancaUsuariosAplicacaoIndexRoute,
  AppSegurancaUsuariosIndexRoute: AppSegurancaUsuariosIndexRoute,
  AppCadastroFundosFundIdCessoesRoute: AppCadastroFundosFundIdCessoesRoute,
  AppCadastroFundosFundIdDocumentosRoute:
    AppCadastroFundosFundIdDocumentosRoute,
  AppCadastroFundosFundIdEnvolvidosRoute:
    AppCadastroFundosFundIdEnvolvidosRoute,
  AppCadastroGestaoProdutosCobrancaParametrosCustosRoute:
    AppCadastroGestaoProdutosCobrancaParametrosCustosRoute,
  AppCadastroProdutosContaProductIdDocumentosRoute:
    AppCadastroProdutosContaProductIdDocumentosRoute,
  AppCadastroProdutosContaProductIdEnvolvidosRoute:
    AppCadastroProdutosContaProductIdEnvolvidosRoute,
  AppCadastroProdutosCreditoProductIdCustoDeEmissaoRoute:
    AppCadastroProdutosCreditoProductIdCustoDeEmissaoRoute,
  AppCadastroProdutosCreditoProductIdDocumentosRoute:
    AppCadastroProdutosCreditoProductIdDocumentosRoute,
  AppCadastroProdutosCreditoProductIdDocumentosParaAssinaturaRoute:
    AppCadastroProdutosCreditoProductIdDocumentosParaAssinaturaRoute,
  AppCadastroProdutosCreditoProductIdEnvolvidosRoute:
    AppCadastroProdutosCreditoProductIdEnvolvidosRoute,
  AppCadastroProdutosCreditoProductIdOrgaoRoute:
    AppCadastroProdutosCreditoProductIdOrgaoRoute,
  AppCadastroProdutosCreditoProductIdTemplatesRoute:
    AppCadastroProdutosCreditoProductIdTemplatesRoute,
  AppCcbCessoesBatchAssignmentIdDocumentosRoute:
    AppCcbCessoesBatchAssignmentIdDocumentosRoute,
  AppCcbCessoesBatchAssignmentIdHistoricoRoute:
    AppCcbCessoesBatchAssignmentIdHistoricoRoute,
  AppCcbCessoesBatchAssignmentIdOperacoesRoute:
    AppCcbCessoesBatchAssignmentIdOperacoesRoute,
  AppCcbCessoesBatchAssignmentIdParcelasRoute:
    AppCcbCessoesBatchAssignmentIdParcelasRoute,
  AppContasDigitaisContasBankAccountIdTabRoute:
    AppContasDigitaisContasBankAccountIdTabRoute,
  AppContasDigitaisSolicitacoesBankAccountIdAcessosConcedidosRoute:
    AppContasDigitaisSolicitacoesBankAccountIdAcessosConcedidosRoute,
  AppContasDigitaisSolicitacoesBankAccountIdDocumentosRoute:
    AppContasDigitaisSolicitacoesBankAccountIdDocumentosRoute,
  AppContasDigitaisSolicitacoesBankAccountIdEnvolvidosRoute:
    AppContasDigitaisSolicitacoesBankAccountIdEnvolvidosRoute,
  AppContasDigitaisSolicitacoesBankAccountIdHistoricoRoute:
    AppContasDigitaisSolicitacoesBankAccountIdHistoricoRoute,
  AppContasDigitaisSolicitacoesBankAccountIdKycRoute:
    AppContasDigitaisSolicitacoesBankAccountIdKycRoute,
  AppContasDigitaisSplitAutomaticoOperationIdDetalhesRoute:
    AppContasDigitaisSplitAutomaticoOperationIdDetalhesRoute,
  AppGestaoCarteiraCarteirasWalletIdArquivosRemessaRoute:
    AppGestaoCarteiraCarteirasWalletIdArquivosRemessaRoute,
  AppGestaoCarteiraCarteirasWalletIdArquivosRetornoRoute:
    AppGestaoCarteiraCarteirasWalletIdArquivosRetornoRoute,
  AppGestaoCarteiraCarteirasWalletIdTarifasConvenioRoute:
    AppGestaoCarteiraCarteirasWalletIdTarifasConvenioRoute,
  AppGestaoCarteiraConciliacaoDataprevNovaConciliacaoRoute:
    AppGestaoCarteiraConciliacaoDataprevNovaConciliacaoRoute,
  AppGestaoCarteiraRecuperacaoAcordosAgreementIdRoute:
    AppGestaoCarteiraRecuperacaoAcordosAgreementIdRoute,
  AppGestaoCarteiraRecuperacaoDevedorInstallmentIdRoute:
    AppGestaoCarteiraRecuperacaoDevedorInstallmentIdRoute,
  AppPessoasFisicasTodasPersonIdComplianceRoute:
    AppPessoasFisicasTodasPersonIdComplianceRoute,
  AppPessoasFisicasTodasPersonIdCreditoRoute:
    AppPessoasFisicasTodasPersonIdCreditoRoute,
  AppPessoasFisicasTodasPersonIdDadosBancariosRoute:
    AppPessoasFisicasTodasPersonIdDadosBancariosRoute,
  AppPessoasFisicasTodasPersonIdDocumentosRoute:
    AppPessoasFisicasTodasPersonIdDocumentosRoute,
  AppPessoasFisicasTodasPersonIdOperacoesRoute:
    AppPessoasFisicasTodasPersonIdOperacoesRoute,
  AppPessoasJuridicasTodasPersonIdComplianceRoute:
    AppPessoasJuridicasTodasPersonIdComplianceRoute,
  AppPessoasJuridicasTodasPersonIdCreditoRoute:
    AppPessoasJuridicasTodasPersonIdCreditoRoute,
  AppPessoasJuridicasTodasPersonIdDadosBancariosRoute:
    AppPessoasJuridicasTodasPersonIdDadosBancariosRoute,
  AppPessoasJuridicasTodasPersonIdDocumentosRoute:
    AppPessoasJuridicasTodasPersonIdDocumentosRoute,
  AppPessoasJuridicasTodasPersonIdOperacoesRoute:
    AppPessoasJuridicasTodasPersonIdOperacoesRoute,
  AppPessoasJuridicasTodasPersonIdSignatariosRoute:
    AppPessoasJuridicasTodasPersonIdSignatariosRoute,
  AppSegurancaGruposGroupIdMembrosRoute: AppSegurancaGruposGroupIdMembrosRoute,
  AppSegurancaGruposGroupIdPermissoesRoute:
    AppSegurancaGruposGroupIdPermissoesRoute,
  AppSegurancaUsuariosUserIdGruposRoute: AppSegurancaUsuariosUserIdGruposRoute,
  AppSegurancaUsuariosUserIdPermissoesRoute:
    AppSegurancaUsuariosUserIdPermissoesRoute,
  AppCadastroConfiguracaoRegrasRuleIdIndexRoute:
    AppCadastroConfiguracaoRegrasRuleIdIndexRoute,
  AppCadastroConveniosConvenioIdIndexRoute:
    AppCadastroConveniosConvenioIdIndexRoute,
  AppCadastroFundosFundIdIndexRoute: AppCadastroFundosFundIdIndexRoute,
  AppCadastroGestaoProdutosCobrancaIndexRoute:
    AppCadastroGestaoProdutosCobrancaIndexRoute,
  AppCadastroProdutosContaProductIdIndexRoute:
    AppCadastroProdutosContaProductIdIndexRoute,
  AppCadastroProdutosCreditoProductIdIndexRoute:
    AppCadastroProdutosCreditoProductIdIndexRoute,
  AppCadastroRegrasDinamicasRuleIdIndexRoute:
    AppCadastroRegrasDinamicasRuleIdIndexRoute,
  AppCadastroRegrasDinamicasSimularIndexRoute:
    AppCadastroRegrasDinamicasSimularIndexRoute,
  AppCcbCessoesBatchAssignmentIdIndexRoute:
    AppCcbCessoesBatchAssignmentIdIndexRoute,
  AppCcbCessoesSubmissoesDimensaIndexRoute:
    AppCcbCessoesSubmissoesDimensaIndexRoute,
  AppChatbotIdAtendimentoIndexRoute: AppChatbotIdAtendimentoIndexRoute,
  AppConcilicaoFgtsCalcularLiquidacaoAntecipadaIndexRoute:
    AppConcilicaoFgtsCalcularLiquidacaoAntecipadaIndexRoute,
  AppConcilicaoFgtsGerarArquivoLiquidacaoCaixaIndexRoute:
    AppConcilicaoFgtsGerarArquivoLiquidacaoCaixaIndexRoute,
  AppConcilicaoFgtsSiapeIndexRoute: AppConcilicaoFgtsSiapeIndexRoute,
  AppContasDigitaisContasBankAccountIdIndexRoute:
    AppContasDigitaisContasBankAccountIdIndexRoute,
  AppContasDigitaisGestaoSpiConsultasIndexRoute:
    AppContasDigitaisGestaoSpiConsultasIndexRoute,
  AppContasDigitaisSolicitacoesBankAccountIdIndexRoute:
    AppContasDigitaisSolicitacoesBankAccountIdIndexRoute,
  AppContasDigitaisSplitAutomaticoOperationIdIndexRoute:
    AppContasDigitaisSplitAutomaticoOperationIdIndexRoute,
  AppGestaoCarteiraCarteirasWalletIdIndexRoute:
    AppGestaoCarteiraCarteirasWalletIdIndexRoute,
  AppGestaoCarteiraConciliacaoDataprevIndexRoute:
    AppGestaoCarteiraConciliacaoDataprevIndexRoute,
  AppGestaoCarteiraRecuperacaoAcordosIndexRoute:
    AppGestaoCarteiraRecuperacaoAcordosIndexRoute,
  AppParceirosSolicitacoesIdIndexRoute: AppParceirosSolicitacoesIdIndexRoute,
  AppPessoasFisicasTodasPersonIdIndexRoute:
    AppPessoasFisicasTodasPersonIdIndexRoute,
  AppPessoasJuridicasTodasPersonIdIndexRoute:
    AppPessoasJuridicasTodasPersonIdIndexRoute,
  AppSegurancaGruposGroupIdIndexRoute: AppSegurancaGruposGroupIdIndexRoute,
  AppSegurancaRecursosCorrespondenteIdIndexRoute:
    AppSegurancaRecursosCorrespondenteIdIndexRoute,
  AppSegurancaUsuariosAplicacaoAplicacaoIdIndexRoute:
    AppSegurancaUsuariosAplicacaoAplicacaoIdIndexRoute,
  AppSegurancaUsuariosUserIdIndexRoute: AppSegurancaUsuariosUserIdIndexRoute,
  AppContasDigitaisContasBankAccountIdPixGerenciarChavesRoute:
    AppContasDigitaisContasBankAccountIdPixGerenciarChavesRoute,
  AppContasDigitaisContasBankAccountIdVisualizarTabRoute:
    AppContasDigitaisContasBankAccountIdVisualizarTabRoute,
  AppGestaoCarteiraCarteirasArquivosFileIdRemessaRoute:
    AppGestaoCarteiraCarteirasArquivosFileIdRemessaRoute,
  AppGestaoCarteiraCarteirasArquivosFileIdRetornoRoute:
    AppGestaoCarteiraCarteirasArquivosFileIdRetornoRoute,
  AppGestaoCarteiraConciliacaoDataprevConciliationIdHistoricoRoute:
    AppGestaoCarteiraConciliacaoDataprevConciliationIdHistoricoRoute,
  AppGestaoCarteiraConciliacaoDataprevConciliationIdInconsistenciasRoute:
    AppGestaoCarteiraConciliacaoDataprevConciliationIdInconsistenciasRoute,
  AppGestaoCarteiraConciliacaoDataprevConciliationIdLinhaDeRepasseRoute:
    AppGestaoCarteiraConciliacaoDataprevConciliationIdLinhaDeRepasseRoute,
  AppGestaoCarteiraConciliacaoDataprevConciliationIdNaoEncerradasRoute:
    AppGestaoCarteiraConciliacaoDataprevConciliationIdNaoEncerradasRoute,
  AppGestaoCarteiraConciliacaoDataprevBolsaoIdRoute:
    AppGestaoCarteiraConciliacaoDataprevBolsaoIdRoute,
  AppCadastroConfiguracaoRegrasRuleIdProdutosIndexRoute:
    AppCadastroConfiguracaoRegrasRuleIdProdutosIndexRoute,
  AppContasDigitaisContasBankAccountIdVisualizarIndexRoute:
    AppContasDigitaisContasBankAccountIdVisualizarIndexRoute,
  AppGestaoCarteiraConciliacaoDataprevConciliationIdIndexRoute:
    AppGestaoCarteiraConciliacaoDataprevConciliationIdIndexRoute,
  AppGestaoCarteiraConciliacaoDataprevBolsaoIndexRoute:
    AppGestaoCarteiraConciliacaoDataprevBolsaoIndexRoute,
  AppContasDigitaisContasBankAccountIdPixPixAutomaticoAtivasRoute:
    AppContasDigitaisContasBankAccountIdPixPixAutomaticoAtivasRoute,
  AppContasDigitaisContasBankAccountIdPixPixAutomaticoHistoricoRoute:
    AppContasDigitaisContasBankAccountIdPixPixAutomaticoHistoricoRoute,
  AppContasDigitaisContasBankAccountIdPixPixAutomaticoPendentesRoute:
    AppContasDigitaisContasBankAccountIdPixPixAutomaticoPendentesRoute,
  AppContasDigitaisContasBankAccountIdPixPixMedConsultarRoute:
    AppContasDigitaisContasBankAccountIdPixPixMedConsultarRoute,
  AppContasDigitaisContasBankAccountIdPixPixMedContestarRoute:
    AppContasDigitaisContasBankAccountIdPixPixMedContestarRoute,
  AppContasDigitaisContasBankAccountIdPixPixMedInformacoesRoute:
    AppContasDigitaisContasBankAccountIdPixPixMedInformacoesRoute,
  AppContasDigitaisContasBankAccountIdPixPixAutomaticoIndexRoute:
    AppContasDigitaisContasBankAccountIdPixPixAutomaticoIndexRoute,
  AppContasDigitaisContasBankAccountIdPixPixMedIndexRoute:
    AppContasDigitaisContasBankAccountIdPixPixMedIndexRoute,
  AppContasDigitaisContasBankAccountIdPixPixAutomaticoAgendadosRealizadosRoute:
    AppContasDigitaisContasBankAccountIdPixPixAutomaticoAgendadosRealizadosRoute,
  AppContasDigitaisContasBankAccountIdPixPixAutomaticoAgendadosIndexRoute:
    AppContasDigitaisContasBankAccountIdPixPixAutomaticoAgendadosIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface DevCreditoRouteRouteChildren {
  DevCreditoCreditNoteIdRoute: typeof DevCreditoCreditNoteIdRoute
  DevCreditoIndexRoute: typeof DevCreditoIndexRoute
}

const DevCreditoRouteRouteChildren: DevCreditoRouteRouteChildren = {
  DevCreditoCreditNoteIdRoute: DevCreditoCreditNoteIdRoute,
  DevCreditoIndexRoute: DevCreditoIndexRoute,
}

const DevCreditoRouteRouteWithChildren = DevCreditoRouteRoute._addFileChildren(
  DevCreditoRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  LoginRouteRoute: LoginRouteRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  DevCreditoRouteRoute: DevCreditoRouteRouteWithChildren,
  DevBlocksRoute: DevBlocksRoute,
  DevCessionariosRoute: DevCessionariosRoute,
  DevFormsRoute: DevFormsRoute,
  DevPatternsRoute: DevPatternsRoute,
  DevProdutosCobrancaRoute: DevProdutosCobrancaRoute,
  DevRecordRoute: DevRecordRoute,
  DevReguaCobrancaRoute: DevReguaCobrancaRoute,
  DevShellRoute: DevShellRoute,
  DevUiRoute: DevUiRoute,
  DevBoletosIndexRoute: DevBoletosIndexRoute,
  DevCarteirasIndexRoute: DevCarteirasIndexRoute,
  DevCentralRegrasIndexRoute: DevCentralRegrasIndexRoute,
  DevCobrancasIndexRoute: DevCobrancasIndexRoute,
  DevConciliacaoIndexRoute: DevConciliacaoIndexRoute,
  DevConveniosIndexRoute: DevConveniosIndexRoute,
  DevCreditoExcluidosIndexRoute: DevCreditoExcluidosIndexRoute,
  DevDataprevIndexRoute: DevDataprevIndexRoute,
  DevFluxoIndexRoute: DevFluxoIndexRoute,
  DevGruposIndexRoute: DevGruposIndexRoute,
  DevMeuPerfilIndexRoute: DevMeuPerfilIndexRoute,
  DevPermissoesCorrespondenteIndexRoute: DevPermissoesCorrespondenteIndexRoute,
  DevPessoasIndexRoute: DevPessoasIndexRoute,
  DevPixMedAdminIndexRoute: DevPixMedAdminIndexRoute,
  DevProdutosContaIndexRoute: DevProdutosContaIndexRoute,
  DevProdutosCreditoIndexRoute: DevProdutosCreditoIndexRoute,
  DevProdutosLiquidacaoAutomaticaIndexRoute:
    DevProdutosLiquidacaoAutomaticaIndexRoute,
  DevRegrasDinamicasIndexRoute: DevRegrasDinamicasIndexRoute,
  DevReguaComunicacaoIndexRoute: DevReguaComunicacaoIndexRoute,
  DevSolicitacoesParceirosIndexRoute: DevSolicitacoesParceirosIndexRoute,
  DevUsuariosAplicacaoIndexRoute: DevUsuariosAplicacaoIndexRoute,
  DevUsuariosIndexRoute: DevUsuariosIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
